var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/constants.ts
var DEFAULT_LOCALE = "ja-JP";
var DEFAULT_TIME_ZONE = "Asia/Tokyo";

// src/models/data-types/aams/aams-alert-type/index.ts
import * as v3 from "valibot";

// src/utilities/batch-processor.ts
import { Subject } from "rxjs";
var BatchProcessor = class {
  static {
    __name(this, "BatchProcessor");
  }
  buffer = [];
  timer;
  subject = new Subject();
  debounceTime;
  maxBatchSize;
  constructor(debounceTime, maxBatchSize) {
    this.debounceTime = debounceTime;
    this.maxBatchSize = maxBatchSize;
  }
  add(item) {
    this.buffer.push(item);
    if (this.buffer.length >= this.maxBatchSize) {
      this.flushBatch();
    } else {
      this.resetTimer();
    }
  }
  resetTimer() {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => this.flushBatch(), this.debounceTime);
  }
  flushBatch() {
    if (this.buffer.length === 0) {
      return;
    }
    clearTimeout(this.timer);
    while (this.buffer.length > 0) {
      const batch = this.buffer.splice(0, this.maxBatchSize);
      this.subject.next(batch);
    }
  }
  asObservable() {
    return this.subject.asObservable();
  }
  // クリーンアップ
  destroy() {
    clearTimeout(this.timer);
    this.flushBatch();
    this.subject.complete();
  }
};

// src/utilities/date-time.ts
import { Temporal } from "temporal-polyfill";

// src/utilities/string.ts
var ALPHABETIC_CHARACTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
var ALPHANUMERIC_CHARACTERS = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
var DEFAULT_GRAPHEME_SEGMENTER = new Intl.Segmenter(void 0, {
  granularity: "grapheme"
});
var NUMERIC_CHARACTERS = "0123456789";
function generateRandomString(length2) {
  let s = "";
  for (let i = 0; i < length2; i++) {
    s += ALPHANUMERIC_CHARACTERS[Math.floor(Math.random() * ALPHANUMERIC_CHARACTERS.length)];
  }
  return s;
}
__name(generateRandomString, "generateRandomString");

// src/utilities/number.ts
function toDuosexagesimal(decimal) {
  if (typeof decimal === "number") {
    if (!Number.isSafeInteger(decimal) || decimal < 0) {
      throw new TypeError(
        `'decimal = ${decimal}'\u306F'0'\u4EE5\u4E0A'${Number.MAX_SAFE_INTEGER}'\u4EE5\u4E0B\u306E\u6574\u6570\u3067\u306F\u3042\u308A\u307E\u305B\u3093\u3002`
      );
    }
    if (decimal === 0) {
      return "0";
    }
    const duosexagesimal = new Array(
      Math.floor(1 + Math.log(decimal) / Math.log(ALPHANUMERIC_CHARACTERS.length))
    );
    for (let n = decimal; n > 0; n = Math.floor(n / ALPHANUMERIC_CHARACTERS.length)) {
      duosexagesimal.push(ALPHANUMERIC_CHARACTERS.at(n % ALPHANUMERIC_CHARACTERS.length));
    }
    return duosexagesimal.reverse().join("");
  } else {
    if (decimal < 0n) {
      throw new TypeError(`'decimal = ${decimal}'\u306F'0'\u4EE5\u4E0A\u306E\u6574\u6570\u3067\u306F\u3042\u308A\u307E\u305B\u3093\u3002`);
    }
    if (decimal === 0n) {
      return "0";
    }
    const ALPHANUMERIC_CHARACTERS_LENGTH = BigInt(ALPHANUMERIC_CHARACTERS.length);
    const duosexagesimal = [];
    for (let n = decimal; n > 0; n = n / ALPHANUMERIC_CHARACTERS_LENGTH) {
      duosexagesimal.push(ALPHANUMERIC_CHARACTERS.at(Number(n % ALPHANUMERIC_CHARACTERS_LENGTH)));
    }
    return duosexagesimal.reverse().join("");
  }
}
__name(toDuosexagesimal, "toDuosexagesimal");

// src/utilities/date-time.ts
function toPythonDateTimeString(dateTime) {
  if (dateTime instanceof Temporal.PlainDateTime) {
    dateTime = dateTime.toZonedDateTime("Asia/Tokyo");
  }
  return dateTime.toString({
    calendarName: "never",
    roundingMode: "trunc",
    smallestUnit: "millisecond",
    timeZoneName: "never"
  });
}
__name(toPythonDateTimeString, "toPythonDateTimeString");
function toDateNumber(year, month, day) {
  const n = Math.max(1, Math.ceil(Math.log2(year)));
  return year + month * 2 ** n + day * 2 ** (n + 4) + 1 * 2 ** (n + 9);
}
__name(toDateNumber, "toDateNumber");
function toTimeNumber(hour, minute, second, millisecond, microsecond, nanosecond) {
  return hour + minute * 2 ** 5 + second * 2 ** 11 + millisecond * 2 ** 17 + microsecond * 2 ** 27 + nanosecond * 2 ** 37;
}
__name(toTimeNumber, "toTimeNumber");
var DATE_TIME_NUMBER_MODE_BIT_COUNT = 4n;
var DATE_TIME_NUMBER_MODE_BIT_MASK = 0b1111n;
var DATE_TIME_NUMBER_YEAR_MODE = 0;
var DATE_TIME_NUMBER_MONTH_MODE = 1;
var DATE_TIME_NUMBER_DAY_MODE = 2;
var DATE_TIME_NUMBER_HOUR_MODE = 3;
var DATE_TIME_NUMBER_MINUTE_MODE = 4;
var DATE_TIME_NUMBER_SECOND_MODE = 5;
var DATE_TIME_NUMBER_MILLISECOND_MODE = 6;
var DATE_TIME_NUMBER_MICROSECOND_MODE = 7;
var DATE_TIME_NUMBER_NANOSECOND_MODE = 8;
function toDateTimeNumber(year, month, day, hour, minute, second, millisecond, microsecond, nanosecond, _) {
  if (year < 0 || !Number.isSafeInteger(year)) {
    throw new TypeError(`'year = ${year}'\u306F'0'\u4EE5\u4E0A\u306E\u6574\u6570\u3067\u306F\u3042\u308A\u307E\u305B\u3093\u3002`);
  }
  let n = BigInt(year);
  if (month === void 0) {
    return n << DATE_TIME_NUMBER_MODE_BIT_COUNT | BigInt(DATE_TIME_NUMBER_YEAR_MODE);
  } else if (month === null) {
    return n;
  } else if (month < 1 || month > 12 || !Number.isSafeInteger(month)) {
    throw new TypeError(`'month = ${month}'\u306F'1'\u4EE5\u4E0A'12'\u4EE5\u4E0B\u306E\u6574\u6570\u3067\u306F\u3042\u308A\u307E\u305B\u3093\u3002`);
  }
  n = n << 4n | BigInt(month);
  if (day === void 0) {
    return n << DATE_TIME_NUMBER_MODE_BIT_COUNT | BigInt(DATE_TIME_NUMBER_MONTH_MODE);
  } else if (day === null) {
    return n;
  } else if (day < 1 || day > 31 || !Number.isSafeInteger(day)) {
    throw new TypeError(`'day = ${day}'\u306F'1'\u4EE5\u4E0A'31'\u4EE5\u4E0B\u306E\u6574\u6570\u3067\u306F\u3042\u308A\u307E\u305B\u3093\u3002`);
  }
  n = n << 5n | BigInt(day);
  if (hour === void 0) {
    return n << DATE_TIME_NUMBER_MODE_BIT_COUNT | BigInt(DATE_TIME_NUMBER_DAY_MODE);
  } else if (hour === null) {
    return n;
  } else if (hour < 0 || hour > 23 || !Number.isSafeInteger(hour)) {
    throw new TypeError(`'hour = ${hour}'\u306F'0'\u4EE5\u4E0A'23'\u4EE5\u4E0B\u306E\u6574\u6570\u3067\u306F\u3042\u308A\u307E\u305B\u3093\u3002`);
  }
  n = n << 5n | BigInt(hour);
  if (minute === void 0) {
    return n << DATE_TIME_NUMBER_MODE_BIT_COUNT | BigInt(DATE_TIME_NUMBER_HOUR_MODE);
  } else if (minute === null) {
    return n;
  } else if (minute < 0 || minute > 59 || !Number.isSafeInteger(minute)) {
    throw new TypeError(`'minute = ${minute}'\u306F'0'\u4EE5\u4E0A'59'\u4EE5\u4E0B\u306E\u6574\u6570\u3067\u306F\u3042\u308A\u307E\u305B\u3093\u3002`);
  }
  n = n << 6n | BigInt(minute);
  if (second === void 0) {
    return n << DATE_TIME_NUMBER_MODE_BIT_COUNT | BigInt(DATE_TIME_NUMBER_MINUTE_MODE);
  } else if (second === null) {
    return n;
  } else if (second < 0 || second > 59 || !Number.isSafeInteger(second)) {
    throw new TypeError(`'second = ${second}'\u306F'0'\u4EE5\u4E0A'59'\u4EE5\u4E0B\u306E\u6574\u6570\u3067\u306F\u3042\u308A\u307E\u305B\u3093\u3002`);
  }
  n = n << 6n | BigInt(second);
  if (millisecond === void 0) {
    return n << DATE_TIME_NUMBER_MODE_BIT_COUNT | BigInt(DATE_TIME_NUMBER_SECOND_MODE);
  } else if (millisecond === null) {
    return n;
  } else if (millisecond < 0 || millisecond > 999 || !Number.isSafeInteger(millisecond)) {
    throw new TypeError(`'millisecond = ${millisecond}'\u306F'0'\u4EE5\u4E0A'999'\u4EE5\u4E0B\u306E\u6574\u6570\u3067\u306F\u3042\u308A\u307E\u305B\u3093\u3002`);
  }
  n = n << 10n | BigInt(millisecond);
  if (microsecond === void 0) {
    return n << DATE_TIME_NUMBER_MODE_BIT_COUNT | BigInt(DATE_TIME_NUMBER_MILLISECOND_MODE);
  } else if (microsecond === null) {
    return n;
  } else if (microsecond < 0 || microsecond > 999 || !Number.isSafeInteger(microsecond)) {
    throw new TypeError(`'microsecond = ${microsecond}'\u306F'0'\u4EE5\u4E0A'999'\u4EE5\u4E0B\u306E\u6574\u6570\u3067\u306F\u3042\u308A\u307E\u305B\u3093\u3002`);
  }
  n = n << 10n | BigInt(microsecond);
  if (nanosecond === void 0) {
    return n << DATE_TIME_NUMBER_MODE_BIT_COUNT | BigInt(DATE_TIME_NUMBER_MICROSECOND_MODE);
  } else if (nanosecond === null) {
    return n;
  } else if (nanosecond < 0 || nanosecond > 999 || !Number.isSafeInteger(nanosecond)) {
    throw new TypeError(`'nanosecond = ${nanosecond}'\u306F'0'\u4EE5\u4E0A'999'\u4EE5\u4E0B\u306E\u6574\u6570\u3067\u306F\u3042\u308A\u307E\u305B\u3093\u3002`);
  }
  n = n << 10n | BigInt(nanosecond);
  if (_ === null) {
    return n;
  } else {
    return n << DATE_TIME_NUMBER_MODE_BIT_COUNT | BigInt(DATE_TIME_NUMBER_NANOSECOND_MODE);
  }
}
__name(toDateTimeNumber, "toDateTimeNumber");
function toDateTimeString(dateTime, precision) {
  switch (precision) {
    case "second":
      if (dateTime.year >= 52476) {
        throw new TypeError(
          "\u79D2\u7CBE\u5EA6\u306E\u65E5\u6642\u6587\u5B57\u5217\u3092\u4F5C\u6210\u3059\u308B\u6642\u3001\u5E74\u306F52476\u672A\u6E80\u3067\u306A\u3051\u308C\u3070\u306A\u308A\u307E\u305B\u3093\u3002" + dateTime.year + "\u304C\u6307\u5B9A\u3055\u308C\u307E\u3057\u305F\u3002"
        );
      }
      return toDuosexagesimal(
        toDateTimeNumber(
          dateTime.year,
          dateTime.month,
          dateTime.day,
          dateTime.hour,
          dateTime.minute,
          dateTime.second,
          null
        )
      ).padStart(7, "0");
    case "millisecond":
      if (dateTime.year >= 196990) {
        throw new TypeError(
          "\u30DF\u30EA\u79D2\u7CBE\u5EA6\u306E\u65E5\u6642\u6587\u5B57\u5217\u3092\u4F5C\u6210\u3059\u308B\u6642\u3001\u5E74\u306F196990\u672A\u6E80\u3067\u306A\u3051\u308C\u3070\u306A\u308A\u307E\u305B\u3093\u3002" + dateTime.year + "\u304C\u6307\u5B9A\u3055\u308C\u307E\u3057\u305F\u3002"
        );
      }
      return toDuosexagesimal(
        toDateTimeNumber(
          dateTime.year,
          dateTime.month,
          dateTime.day,
          dateTime.hour,
          dateTime.minute,
          dateTime.second,
          dateTime.millisecond,
          null
        )
      ).padStart(9, "0");
    default:
      throw new TypeError(precision + "\u306F\u672A\u5BFE\u5FDC\u306E\u65E5\u6642\u7CBE\u5EA6\u3067\u3059\u3002");
  }
}
__name(toDateTimeString, "toDateTimeString");

// src/utilities/memoization.ts
function memoize(target) {
  let cache;
  return function() {
    cache ??= target();
    return cache;
  };
}
__name(memoize, "memoize");

// src/utilities/path.ts
var ALTERNATIVE_CHARACTERS = /* @__PURE__ */ new Map([
  ['"', "\uFF02"],
  // Windows
  ["*", "\uFF0A"],
  // Windows
  ["/", "\uFF0F"],
  // macOS, Linux, Windows
  [":", "\uFF1A"],
  // 古いmacOS, Windows
  ["<", "\uFF1C"],
  // Windows
  [">", "\uFF1E"],
  // Windows
  ["?", "\uFF1F"],
  // Windows
  ["\\", "\uFF3C"],
  // Windows
  ["|", "\uFF5C"]
  // Windows
]);
function toPathSafeString(string65) {
  return string65.replaceAll(/./g, function(character) {
    return ALTERNATIVE_CHARACTERS.get(character) ?? character;
  });
}
__name(toPathSafeString, "toPathSafeString");

// src/utilities/retry.ts
function backoff(base, jitter, iteration) {
  return base * Math.pow(2, iteration) * (1 + jitter * (1 - 2 * Math.random()));
}
__name(backoff, "backoff");
async function ExponentialBackOff(base, jitter, iteration) {
  return new Promise(function(resolve) {
    setTimeout(resolve, backoff(base, jitter, iteration));
  });
}
__name(ExponentialBackOff, "ExponentialBackOff");
function Retry(maximumNumberOfRetries, randomDelay, minimumDelay = 0, maximumDelay = Infinity) {
  return async function(task, retry) {
    let result;
    for (let numberOfRetries = 0; numberOfRetries < maximumNumberOfRetries; numberOfRetries++) {
      try {
        result = await task(numberOfRetries);
        break;
      } catch (error) {
        const retriable = numberOfRetries + 1 < maximumNumberOfRetries && await retry?.(error, numberOfRetries) !== false;
        if (retriable) {
          await new Promise(function(resolve) {
            setTimeout(
              resolve,
              Math.min(
                randomDelay * Math.pow(2, numberOfRetries) * Math.random() + minimumDelay,
                maximumDelay
              )
            );
          });
          continue;
        } else {
          throw error;
        }
      }
    }
    return result;
  };
}
__name(Retry, "Retry");

// src/utilities/semaphore.ts
var Semaphore = class {
  static {
    __name(this, "Semaphore");
  }
  /** 最大許可証数 */
  maximumNumberOfPermits;
  /** 現在の許可証数 */
  numberOfPermits;
  /** 全ての許可証が解放された時に解決されるプロミス */
  promise;
  /** **許可証の獲得待ち行列** 関数を実行すると許可証を獲得させる。 */
  queue;
  /**
   * @param maximumNumberOfPermits 最大許可証数
   * 小数点以下は切り捨て、`1`未満の値は`1`として扱う。
   */
  constructor(maximumNumberOfPermits) {
    this.maximumNumberOfPermits = Math.max(Math.floor(maximumNumberOfPermits), 1);
    this.numberOfPermits = 0;
    this.queue = [];
  }
  /** 許可証を獲得する。 */
  async acquire() {
    let released = false;
    const release = function() {
      if (!released) {
        released = true;
        this.numberOfPermits = Math.max(this.numberOfPermits - 1, 0);
        const resolve = this.queue.shift();
        if (resolve) {
          this.numberOfPermits++;
          resolve();
        } else if (this.numberOfPermits === 0) {
          this.promise?.resolve();
          this.promise = void 0;
        }
      }
    }.bind(this);
    if (this.numberOfPermits < this.maximumNumberOfPermits) {
      this.promise ??= Promise.withResolvers();
      this.numberOfPermits++;
      return release;
    } else {
      const { promise, resolve } = Promise.withResolvers();
      this.queue.push(function() {
        resolve(release);
      });
      return promise;
    }
  }
  /** 全ての許可証が解放されるまで待つ。 */
  async wait() {
    await this.promise?.promise;
  }
};

// src/utilities/translation.ts
var configuration = { locales: ["ja"] };
function getLocales() {
  return configuration.locales;
}
__name(getLocales, "getLocales");
function setLocales(...locales) {
  configuration.locales = locales;
}
__name(setLocales, "setLocales");
function t(dictionary, options) {
  for (const locale of options?.locales ?? configuration.locales) {
    const string65 = dictionary[locale];
    if (string65 !== void 0) {
      return string65.replace(/\{\{([^{}]+)\}\}/g, function(token, key) {
        const variable = dictionary._?.[key];
        if (typeof variable === "function") {
          return variable(locale);
        } else if (typeof variable === "string") {
          return variable;
        } else {
          return token;
        }
      });
    }
  }
  return "";
}
__name(t, "t");

// src/models/data-types/error/core.ts
import { Subject as Subject2 } from "rxjs";
import { Temporal as Temporal2 } from "temporal-polyfill";
import { ValiError } from "valibot";
import * as v from "valibot";

// src/models/data-types/error/error-code/enumeration.ts
var enumeration_exports = {};
__export(enumeration_exports, {
  ABORTED: () => ABORTED,
  ALERT_AUDIO_ELEMENT_NOT_FOUND: () => ALERT_AUDIO_ELEMENT_NOT_FOUND,
  ANSIEL_ACCESS_TOKEN_ISSUE_FAILED: () => ANSIEL_ACCESS_TOKEN_ISSUE_FAILED,
  ANSIEL_EVENTS_FETCH_FAILED: () => ANSIEL_EVENTS_FETCH_FAILED,
  ANSIEL_PUSH_NOTIFICATION_REGISTER_FAILED: () => ANSIEL_PUSH_NOTIFICATION_REGISTER_FAILED,
  ANSIEL_PUSH_NOTIFICATION_UNREGISTER_FAILED: () => ANSIEL_PUSH_NOTIFICATION_UNREGISTER_FAILED,
  ANSIEL_SENSORS_FETCH_FAILED: () => ANSIEL_SENSORS_FETCH_FAILED,
  ANSIEL_VITALS_FETCH_FAILED: () => ANSIEL_VITALS_FETCH_FAILED,
  ASSESSMENT_ALREADY_REGISTERED: () => ASSESSMENT_ALREADY_REGISTERED,
  AUDIO_PLAY_FAILED: () => AUDIO_PLAY_FAILED,
  AUTHENTICATION_SESSION_ERROR: () => AUTHENTICATION_SESSION_ERROR,
  BED_DELETED: () => BED_DELETED,
  BED_NOT_FOUND: () => BED_NOT_FOUND,
  CHANNEL_NOT_FOUND: () => CHANNEL_NOT_FOUND,
  CLIPBOARD_UNAVAILABLE: () => CLIPBOARD_UNAVAILABLE,
  COPY_TO_CLIPBOARD_FAILED: () => COPY_TO_CLIPBOARD_FAILED,
  DEPRECATED: () => DEPRECATED,
  EMAIL_ADDRESS_ALREADY_REGISTERED: () => EMAIL_ADDRESS_ALREADY_REGISTERED,
  FACILITY_DISABLED: () => FACILITY_DISABLED,
  FACILITY_NOT_FOUND: () => FACILITY_NOT_FOUND,
  FACILITY_STAFF_ALREADY_REGISTERED: () => FACILITY_STAFF_ALREADY_REGISTERED,
  FAILED_TO_GET_PUSH_NOTIFICATION_TOKEN: () => FAILED_TO_GET_PUSH_NOTIFICATION_TOKEN,
  FAILED_TO_SUBSCRIBE_PUSH_NOTIFICATIONS: () => FAILED_TO_SUBSCRIBE_PUSH_NOTIFICATIONS,
  FALL_ALREADY_REGISTERED: () => FALL_ALREADY_REGISTERED,
  FALL_DISABLED: () => FALL_DISABLED,
  FALL_NOT_FOUND: () => FALL_NOT_FOUND,
  GROUP_DELETED: () => GROUP_DELETED,
  INCOMPATIBLE_BROWSER: () => INCOMPATIBLE_BROWSER,
  INPUT_DUPLICATED: () => INPUT_DUPLICATED,
  INPUT_REQUIRED: () => INPUT_REQUIRED,
  INVALID_DATA: () => INVALID_DATA,
  INVALID_DATE: () => INVALID_DATE,
  INVALID_DATE_TIME: () => INVALID_DATE_TIME,
  INVALID_EMAIL_ADDRESS_INPUT: () => INVALID_EMAIL_ADDRESS_INPUT,
  INVALID_ENTRY_POINT_INPUT: () => INVALID_ENTRY_POINT_INPUT,
  INVALID_FORM: () => INVALID_FORM,
  INVALID_HTTPS_URL: () => INVALID_HTTPS_URL,
  INVALID_PASSWORD_INPUT: () => INVALID_PASSWORD_INPUT,
  INVALID_PHONE_NUMBER_INPUT: () => INVALID_PHONE_NUMBER_INPUT,
  INVALID_POSTAL_CODE_INPUT: () => INVALID_POSTAL_CODE_INPUT,
  INVALID_RESPONSE_PACKET: () => INVALID_RESPONSE_PACKET,
  INVALID_RESPONSE_PAYLOAD: () => INVALID_RESPONSE_PAYLOAD,
  INVALID_TIME: () => INVALID_TIME,
  INVALID_USER_KEY_FORMAT: () => INVALID_USER_KEY_FORMAT,
  NATIVE_APPLICATION_ERROR: () => NATIVE_APPLICATION_ERROR,
  NOT_FOUND: () => NOT_FOUND,
  NOT_LOADED: () => NOT_LOADED,
  OPTIONAL_FIELD_NOT_EMPTY: () => OPTIONAL_FIELD_NOT_EMPTY,
  ORGANIZATION_DISABLED: () => ORGANIZATION_DISABLED,
  ORGANIZATION_NOT_FOUND: () => ORGANIZATION_NOT_FOUND,
  PARENT_CHILD_RELATIONSHIP_BROKEN: () => PARENT_CHILD_RELATIONSHIP_BROKEN,
  PARSE_FAILED: () => PARSE_FAILED,
  PHONE_NUMBER_ALREADY_REGISTERED: () => PHONE_NUMBER_ALREADY_REGISTERED,
  PROVIDER_DISABLED: () => PROVIDER_DISABLED,
  PROVIDER_NOT_FOUND: () => PROVIDER_NOT_FOUND,
  PUSH_NOTIFICATION_TOKEN_NOT_FOUND: () => PUSH_NOTIFICATION_TOKEN_NOT_FOUND,
  RESIDENT_ALREADY_REGISTERED: () => RESIDENT_ALREADY_REGISTERED,
  RESIDENT_BED_NOT_FOUND: () => RESIDENT_BED_NOT_FOUND,
  RESIDENT_DELETED: () => RESIDENT_DELETED,
  RESIDENT_DUPLICATED: () => RESIDENT_DUPLICATED,
  RESIDENT_NOT_FOUND: () => RESIDENT_NOT_FOUND,
  ROOM_DISABLED: () => ROOM_DISABLED,
  ROOM_NOT_FOUND: () => ROOM_NOT_FOUND,
  SENSOR_DELETED: () => SENSOR_DELETED,
  SENSOR_NOT_FOUND: () => SENSOR_NOT_FOUND,
  SERVER_ERROR: () => SERVER_ERROR,
  SOCKET_COMMUNICATION_ERROR: () => SOCKET_COMMUNICATION_ERROR,
  STATUS_ALREADY_CONFIRMED: () => STATUS_ALREADY_CONFIRMED,
  STATUS_NOT_FOUND: () => STATUS_NOT_FOUND,
  TOO_FEW_BEDS: () => TOO_FEW_BEDS,
  TOO_FEW_CHARACTERS: () => TOO_FEW_CHARACTERS,
  TOO_HEAVY_WEIGHT: () => TOO_HEAVY_WEIGHT,
  TOO_LIGHT_WEIGHT: () => TOO_LIGHT_WEIGHT,
  TOO_MANY_BEDS: () => TOO_MANY_BEDS,
  TOO_MANY_CHARACTERS: () => TOO_MANY_CHARACTERS,
  TOO_SHORT_HEIGHT: () => TOO_SHORT_HEIGHT,
  TOO_TALL_HEIGHT: () => TOO_TALL_HEIGHT,
  UNACCEPTABLE_METHOD: () => UNACCEPTABLE_METHOD,
  UNACCEPTABLE_REQUEST_PACKET: () => UNACCEPTABLE_REQUEST_PACKET,
  UNACCEPTABLE_REQUEST_PAYLOAD: () => UNACCEPTABLE_REQUEST_PAYLOAD,
  UNAUTHENTICATED: () => UNAUTHENTICATED,
  UNAUTHORIZED: () => UNAUTHORIZED,
  UNEXPECTED: () => UNEXPECTED,
  UNIMPLEMENTED: () => UNIMPLEMENTED,
  UNINITIALIZED: () => UNINITIALIZED,
  UNKNOWN: () => UNKNOWN,
  UNSUPPORTED: () => UNSUPPORTED,
  USER_DISABLED: () => USER_DISABLED,
  USER_NOT_FOUND: () => USER_NOT_FOUND
});
var UNAUTHENTICATED = "E001";
var INVALID_DATA = "E002";
var INPUT_REQUIRED = "E003";
var UNACCEPTABLE_REQUEST_PACKET = "E004";
var UNACCEPTABLE_REQUEST_PAYLOAD = "E005";
var UNACCEPTABLE_METHOD = "E006";
var INVALID_RESPONSE_PACKET = "E007";
var INVALID_RESPONSE_PAYLOAD = "E008";
var COPY_TO_CLIPBOARD_FAILED = "E009";
var CLIPBOARD_UNAVAILABLE = "E010";
var EMAIL_ADDRESS_ALREADY_REGISTERED = "E011";
var PHONE_NUMBER_ALREADY_REGISTERED = "E012";
var PARENT_CHILD_RELATIONSHIP_BROKEN = "E013";
var ORGANIZATION_NOT_FOUND = "E014";
var FACILITY_NOT_FOUND = "E015";
var PROVIDER_NOT_FOUND = "E016";
var SENSOR_NOT_FOUND = "E017";
var USER_NOT_FOUND = "E018";
var INVALID_DATE = "E019";
var BED_NOT_FOUND = "E020";
var RESIDENT_NOT_FOUND = "E021";
var BED_DELETED = "E022";
var RESIDENT_DELETED = "E023";
var SENSOR_DELETED = "E024";
var RESIDENT_DUPLICATED = "E025";
var INVALID_DATE_TIME = "E026";
var AUTHENTICATION_SESSION_ERROR = "E027";
var ANSIEL_ACCESS_TOKEN_ISSUE_FAILED = "E028";
var ANSIEL_SENSORS_FETCH_FAILED = "E029";
var ANSIEL_EVENTS_FETCH_FAILED = "E030";
var ANSIEL_VITALS_FETCH_FAILED = "E031";
var INVALID_HTTPS_URL = "E032";
var ANSIEL_PUSH_NOTIFICATION_REGISTER_FAILED = "E033";
var ANSIEL_PUSH_NOTIFICATION_UNREGISTER_FAILED = "E034";
var INVALID_FORM = "E035";
var ASSESSMENT_ALREADY_REGISTERED = "E036";
var FALL_NOT_FOUND = "E037";
var FALL_DISABLED = "E038";
var FALL_ALREADY_REGISTERED = "E039";
var FACILITY_DISABLED = "E040";
var USER_DISABLED = "E041";
var ROOM_DISABLED = "E042";
var PROVIDER_DISABLED = "E043";
var ORGANIZATION_DISABLED = "E044";
var INVALID_USER_KEY_FORMAT = "E045";
var FACILITY_STAFF_ALREADY_REGISTERED = "E046";
var INVALID_TIME = "E047";
var CHANNEL_NOT_FOUND = "E048";
var RESIDENT_ALREADY_REGISTERED = "E049";
var STATUS_NOT_FOUND = "E050";
var STATUS_ALREADY_CONFIRMED = "E051";
var AUDIO_PLAY_FAILED = "E052";
var ALERT_AUDIO_ELEMENT_NOT_FOUND = "E053";
var ROOM_NOT_FOUND = "E054";
var FAILED_TO_GET_PUSH_NOTIFICATION_TOKEN = "E055";
var PUSH_NOTIFICATION_TOKEN_NOT_FOUND = "E056";
var FAILED_TO_SUBSCRIBE_PUSH_NOTIFICATIONS = "E057";
var NOT_LOADED = "E058";
var RESIDENT_BED_NOT_FOUND = "E059";
var GROUP_DELETED = "E060";
var SOCKET_COMMUNICATION_ERROR = "E986";
var NATIVE_APPLICATION_ERROR = "E987";
var PARSE_FAILED = "E988";
var ABORTED = "E989";
var UNSUPPORTED = "E990";
var UNAUTHORIZED = "E991";
var UNINITIALIZED = "E992";
var DEPRECATED = "E993";
var NOT_FOUND = "E994";
var UNIMPLEMENTED = "E995";
var INCOMPATIBLE_BROWSER = "E996";
var SERVER_ERROR = "E997";
var UNEXPECTED = "E998";
var UNKNOWN = "E999";
var INVALID_EMAIL_ADDRESS_INPUT = "F001";
var INVALID_POSTAL_CODE_INPUT = "F002";
var INVALID_PASSWORD_INPUT = "F003";
var TOO_MANY_CHARACTERS = "F004";
var TOO_FEW_CHARACTERS = "F005";
var INVALID_PHONE_NUMBER_INPUT = "F006";
var TOO_SHORT_HEIGHT = "F007";
var TOO_TALL_HEIGHT = "F008";
var TOO_LIGHT_WEIGHT = "F009";
var TOO_HEAVY_WEIGHT = "F010";
var TOO_MANY_BEDS = "F011";
var TOO_FEW_BEDS = "F012";
var INPUT_DUPLICATED = "F013";
var INVALID_ENTRY_POINT_INPUT = "F014";
var OPTIONAL_FIELD_NOT_EMPTY = "F015";

// src/models/data-types/error/core.ts
function concatenateStacks(a, b) {
  if (a && b) {
    const lines = b.split("\n");
    return a.split("\n").filter(function(line) {
      return !lines.includes(line);
    }).join("\n") + "\n" + b;
  } else {
    return a || b;
  }
}
__name(concatenateStacks, "concatenateStacks");
function doesHaveStack(target) {
  return target !== null && typeof target === "object" && "stack" in target && typeof target.stack === "string" && target.stack.length > 0;
}
__name(doesHaveStack, "doesHaveStack");
var UniversalError = class _UniversalError extends Error {
  static {
    __name(this, "UniversalError");
  }
  /** コード */
  code;
  /** 日時 */
  dateTime;
  /** **データ** このエラーに関連するデータ。 */
  data;
  /**
   * @param code エラーコード
   * @param options エラーオプション
   * 文字列を指定した場合、メッセージとして扱う。
   */
  constructor(code = _UniversalError.DEFAULT_CODE, options) {
    if (typeof options === "string") {
      super(options);
      this.code = code;
      this.dateTime = Temporal2.Now.zonedDateTimeISO();
    } else {
      super(options?.message, options);
      this.code = code;
      this.dateTime = options?.dateTime ?? Temporal2.Now.zonedDateTimeISO();
      if (options?.data) {
        this.data = options.data;
      }
    }
    Object.defineProperty(this, "name", {
      configurable: true,
      enumerable: false,
      value: "UniversalError#" + this.code,
      writable: true
    });
    if (Object.hasOwn(Error, "captureStackTrace")) {
      Error.captureStackTrace(this, this.constructor);
      if (typeof options !== "string" && doesHaveStack(options?.cause)) {
        this.stack = concatenateStacks(this.stack, options.cause.stack);
      }
    }
  }
  /**
   * 原因リスト
   * このインスタンスの原因となったインスタンスを祖先を先頭にして返す。
   */
  get causes() {
    const causes = /* @__PURE__ */ new Set();
    let cause = this.cause;
    while (cause !== void 0) {
      if (causes.has(cause)) {
        break;
      }
      causes.add(cause);
      if (typeof cause === "object" && cause !== null && Object.hasOwn(cause, "cause")) {
        cause = cause.cause;
      } else {
        break;
      }
    }
    return Array.from(causes).reverse();
  }
  toObject(secure = false) {
    if (secure) {
      return {
        dateTime: this.dateTime.toString(),
        ...this.code !== _UniversalError.DEFAULT_CODE && { code: this.code },
        ...this.data && { data: this.data },
        ...this.message.length > 0 && { message: this.message }
      };
    } else {
      return {
        dateTime: this.dateTime.toString(),
        ...this.code !== _UniversalError.DEFAULT_CODE && { code: this.code },
        ...this.data?.public && { data: { public: this.data?.public } }
      };
    }
  }
  toString() {
    return this.name + (this.message ? ": " + this.message : "") + (this.data ? " " + JSON.stringify(this.data) : "") + " [" + this.dateTime.toString() + "]";
  }
  /** 既定のコード */
  static DEFAULT_CODE = "ERROR";
  static fromObject(object94, options) {
    if (object94 === null || typeof object94 !== "object") {
      const error = new _UniversalError(
        _UniversalError.DEFAULT_CODE,
        "object = " + JSON.stringify(object94) + "\u304C\u30AA\u30D6\u30B8\u30A7\u30AF\u30C8\u3067\u306F\u3042\u308A\u307E\u305B\u3093\u3002"
      );
      if (options?.throw) {
        throw error;
      } else {
        return error;
      }
    }
    if (object94.code !== void 0 && typeof object94.code !== "string") {
      const error = new _UniversalError(
        _UniversalError.DEFAULT_CODE,
        "object.code = " + JSON.stringify(object94.code) + "\u304C\u6587\u5B57\u5217\u3067\u306F\u3042\u308A\u307E\u305B\u3093\u3002"
      );
      if (options?.throw) {
        throw error;
      } else {
        return error;
      }
    }
    let dateTime;
    try {
      if (Object.hasOwn(object94, "dateTime")) {
        dateTime = Temporal2.ZonedDateTime.from(object94.dateTime);
      }
    } catch (error) {
      const e = new _UniversalError(_UniversalError.DEFAULT_CODE, {
        cause: error,
        message: "object.dateTime = " + JSON.stringify(object94.dateTime) + "\u304C\u4E0D\u6B63\u3067\u3059\u3002"
      });
      if (options?.throw) {
        throw e;
      } else {
        return e;
      }
    }
    if (object94.message !== void 0 && typeof object94.message !== "string") {
      const error = new _UniversalError(
        _UniversalError.DEFAULT_CODE,
        "object.message = " + JSON.stringify(object94.message) + "\u304C\u6587\u5B57\u5217\u3067\u306F\u3042\u308A\u307E\u305B\u3093\u3002"
      );
      if (options?.throw) {
        throw error;
      } else {
        return error;
      }
    }
    if (object94.data !== void 0 && (object94.data === null || typeof object94.data !== "object")) {
      const error = new _UniversalError(
        _UniversalError.DEFAULT_CODE,
        "object.data = " + JSON.stringify(object94.data) + "\u304C\u30AA\u30D6\u30B8\u30A7\u30AF\u30C8\u3067\u306F\u3042\u308A\u307E\u305B\u3093\u3002"
      );
      if (options?.throw) {
        throw error;
      } else {
        return error;
      }
    }
    return new _UniversalError(object94.code, { ...object94, dateTime });
  }
  /**
   * このインスタンスを更新し、新しいインスタンスを返す。
   * `options`を省略した場合、`this`を返す。
   * @param options オプション
   * @returns 新しいインスタンスまたは`this`
   */
  renew(options) {
    if (options === void 0) {
      return this;
    } else {
      const error = new _UniversalError(options?.code ?? this.code, {
        ...this,
        ...options
      });
      if (this.stack !== void 0) {
        error.stack = this.stack;
      }
      return error;
    }
  }
};
var ErrorSchema = memoize(function() {
  return v.union([
    v.instance(UniversalError),
    v.pipe(
      v.any(),
      v.rawTransform(function({ NEVER, addIssue, dataset }) {
        try {
          return UniversalError.fromObject(dataset.value, { throw: true });
        } catch (error) {
          addIssue({ input: dataset.value, message: enumeration_exports.PARSE_FAILED });
          return NEVER;
        }
      })
    )
  ]);
});
var ERROR_STREAM = new Subject2();
function toUniversalError(error, options) {
  if (error instanceof UniversalError) {
    return error.renew(options);
  } else if (error instanceof ValiError) {
    return new UniversalError(options?.code ?? enumeration_exports.PARSE_FAILED, {
      ...options,
      cause: error
    });
  } else {
    return new UniversalError(options?.code ?? enumeration_exports.UNKNOWN, { ...options, cause: error });
  }
}
__name(toUniversalError, "toUniversalError");
var createUniversalError = toUniversalError;
function fromErrorCodeToHttpStatus(errorCode) {
  switch (errorCode) {
    case enumeration_exports.INVALID_DATA:
    case enumeration_exports.INPUT_REQUIRED:
    case enumeration_exports.PARSE_FAILED:
    case enumeration_exports.UNACCEPTABLE_REQUEST_PACKET:
    case enumeration_exports.UNACCEPTABLE_REQUEST_PAYLOAD:
    case enumeration_exports.INCOMPATIBLE_BROWSER:
      return 400;
    case enumeration_exports.UNAUTHENTICATED:
      return 401;
    case enumeration_exports.NOT_FOUND:
      return 404;
    case enumeration_exports.UNACCEPTABLE_METHOD:
      return 405;
    case enumeration_exports.INVALID_RESPONSE_PACKET:
    case enumeration_exports.INVALID_RESPONSE_PAYLOAD:
    case enumeration_exports.SERVER_ERROR:
    case enumeration_exports.UNEXPECTED:
    case enumeration_exports.UNKNOWN:
      return 500;
    case enumeration_exports.UNIMPLEMENTED:
      return 501;
    case enumeration_exports.UNINITIALIZED:
      return 503;
    case enumeration_exports.DEPRECATED:
      return 507;
    default:
      return 500;
  }
}
__name(fromErrorCodeToHttpStatus, "fromErrorCodeToHttpStatus");
function getErrorStream() {
  return ERROR_STREAM.asObservable();
}
__name(getErrorStream, "getErrorStream");
function streamError(error, options) {
  return ERROR_STREAM.next(toUniversalError(error, options));
}
__name(streamError, "streamError");
function parse2(schema, input, options) {
  try {
    return v.parse(schema, input);
  } catch (error) {
    throw toUniversalError(error, options);
  }
}
__name(parse2, "parse");
var parseData = parse2;

// src/models/data-types/resident-state/index.ts
import * as v2 from "valibot";

// src/models/data-types/resident-state/resident-state-values.ts
var resident_state_values_exports = {};
__export(resident_state_values_exports, {
  CAME_BACK: () => CAME_BACK,
  GOT_UP: () => GOT_UP,
  PROVIDER_ERROR: () => PROVIDER_ERROR,
  SENSOR_ERROR: () => SENSOR_ERROR,
  SLEEPING: () => SLEEPING,
  SLEEPING_HEAVILY: () => SLEEPING_HEAVILY,
  SLEEPING_LIGHTLY: () => SLEEPING_LIGHTLY,
  UNKNOWN: () => UNKNOWN2,
  WAKING: () => WAKING,
  WANDERING: () => WANDERING,
  WENT_OUT: () => WENT_OUT
});
var CAME_BACK = "CameBack";
var GOT_UP = "GotUp";
var PROVIDER_ERROR = "ProviderError";
var SENSOR_ERROR = "SensorError";
var SLEEPING = "Sleeping";
var SLEEPING_HEAVILY = "SleepingHeavily";
var SLEEPING_LIGHTLY = "SleepingLightly";
var UNKNOWN2 = "Unknown";
var WAKING = "Waking";
var WANDERING = "Wandering";
var WENT_OUT = "WentOut";

// src/models/data-types/resident-state/index.ts
var ALL_RESIDENT_STATES = [
  CAME_BACK,
  GOT_UP,
  PROVIDER_ERROR,
  SENSOR_ERROR,
  SLEEPING,
  SLEEPING_HEAVILY,
  SLEEPING_LIGHTLY,
  UNKNOWN2,
  WAKING,
  WANDERING,
  WENT_OUT
];
var RESIDENT_STATE_ORDER1 = [
  PROVIDER_ERROR,
  SENSOR_ERROR,
  WANDERING,
  GOT_UP,
  WAKING,
  SLEEPING,
  SLEEPING_LIGHTLY,
  SLEEPING_HEAVILY,
  CAME_BACK,
  WENT_OUT,
  UNKNOWN2
];
var SLEEPING_RESIDENT_STATES = [
  SLEEPING,
  SLEEPING_HEAVILY,
  SLEEPING_LIGHTLY
];
var ResidentStateSchema = memoize(function() {
  return v2.picklist(ALL_RESIDENT_STATES);
});

// src/models/data-types/aams/aams-alert-type/enumeration.ts
var enumeration_exports2 = {};
__export(enumeration_exports2, {
  BODY_MOVEMENT: () => BODY_MOVEMENT,
  GOT_UP: () => GOT_UP2,
  HEART_RATE: () => HEART_RATE,
  RESPIRATORY_RATE: () => RESPIRATORY_RATE,
  SENSOR_ERROR: () => SENSOR_ERROR2,
  TEST: () => TEST,
  TRYING_TO_GET_UP: () => TRYING_TO_GET_UP,
  WANDERING: () => WANDERING2
});
var HEART_RATE = 1;
var RESPIRATORY_RATE = 2;
var BODY_MOVEMENT = 3;
var GOT_UP2 = 4;
var WANDERING2 = 5;
var TRYING_TO_GET_UP = 6;
var SENSOR_ERROR2 = 8;
var TEST = 9;

// src/models/data-types/aams/aams-alert-type/index.ts
var ALL_AAMS_ALERT_TYPES = [
  HEART_RATE,
  RESPIRATORY_RATE,
  BODY_MOVEMENT,
  GOT_UP2,
  WANDERING2,
  TRYING_TO_GET_UP,
  SENSOR_ERROR2,
  TEST
];
var getAamsAlertTypeSchema = memoize(function() {
  return v3.picklist(ALL_AAMS_ALERT_TYPES);
});
function parseAamsAlertType(aamsAlertType, options) {
  try {
    return v3.parse(getAamsAlertTypeSchema(), aamsAlertType);
  } catch (error) {
    throw toUniversalError(error, options);
  }
}
__name(parseAamsAlertType, "parseAamsAlertType");
function isAamsAlertType(aamsAlertType) {
  return v3.is(getAamsAlertTypeSchema(), aamsAlertType);
}
__name(isAamsAlertType, "isAamsAlertType");
function fromAamsAlertTypeToResidentState(aamsAlertType) {
  switch (aamsAlertType) {
    case GOT_UP2:
    case WANDERING2:
      return resident_state_values_exports.GOT_UP;
    case SENSOR_ERROR2:
      return resident_state_values_exports.SENSOR_ERROR;
    // case AAMS_ALERT_TYPE.BODY_MOVEMENT:
    // case AAMS_ALERT_TYPE.HEART_RATE:
    // case AAMS_ALERT_TYPE.RESPIRATORY_RATE:
    // case AAMS_ALERT_TYPE.TEST:
    // case AAMS_ALERT_TYPE.TRYING_TO_GET_UP:
    default:
      throw new UniversalError(
        enumeration_exports.UNEXPECTED,
        "AAMS\u30A2\u30E9\u30FC\u30C8\u30BF\u30A4\u30D7(" + aamsAlertType + ")\u304C\u60F3\u5B9A\u5916\u3067\u3059\u3002"
      );
  }
}
__name(fromAamsAlertTypeToResidentState, "fromAamsAlertTypeToResidentState");

// src/models/data-types/aams/aams-care-record-state/index.ts
import * as v4 from "valibot";

// src/models/data-types/aams/aams-care-record-state/enumeration.ts
var enumeration_exports3 = {};
__export(enumeration_exports3, {
  GOT_UP: () => GOT_UP3,
  SLEEPING_HEAVILY: () => SLEEPING_HEAVILY2,
  SLEEPING_LIGHTLY: () => SLEEPING_LIGHTLY2,
  WAKING: () => WAKING2
});
var GOT_UP3 = 0;
var WAKING2 = 1;
var SLEEPING_LIGHTLY2 = 2;
var SLEEPING_HEAVILY2 = 3;

// src/models/data-types/aams/aams-care-record-state/index.ts
var ALL_AAMS_CARE_RECORD_STATES = [
  GOT_UP3,
  WAKING2,
  SLEEPING_LIGHTLY2,
  SLEEPING_HEAVILY2
];
var getAamsCareRecordStateSchema = memoize(function() {
  return v4.picklist(ALL_AAMS_CARE_RECORD_STATES);
});
function fromAamsCareRecordStateToResidentState(aamsCareRecordState) {
  switch (aamsCareRecordState) {
    case GOT_UP3:
      return resident_state_values_exports.GOT_UP;
    case WAKING2:
      return resident_state_values_exports.WAKING;
    case SLEEPING_LIGHTLY2:
      return resident_state_values_exports.SLEEPING_LIGHTLY;
    case SLEEPING_HEAVILY2:
      return resident_state_values_exports.SLEEPING_HEAVILY;
    default:
      throw new UniversalError(
        enumeration_exports.UNEXPECTED,
        "AAMS\u30B1\u30A2\u30EC\u30B3\u30FC\u30C9\u72B6\u614B(" + aamsCareRecordState + ")\u304C\u60F3\u5B9A\u5916\u3067\u3059\u3002"
      );
  }
}
__name(fromAamsCareRecordStateToResidentState, "fromAamsCareRecordStateToResidentState");

// src/models/data-types/ansiel/ansiel-event-code/index.ts
import * as v5 from "valibot";

// src/models/data-types/ansiel/ansiel-event-code/enumeration.ts
var enumeration_exports4 = {};
__export(enumeration_exports4, {
  AWAKE0: () => AWAKE0,
  BED1: () => BED1,
  BED3: () => BED3,
  SB0: () => SB0,
  SB1: () => SB1,
  SB2: () => SB2,
  SB3: () => SB3,
  SB4: () => SB4,
  SLEEP0: () => SLEEP0,
  SLEEP1: () => SLEEP1,
  WKRDY0: () => WKRDY0,
  WKRDY1: () => WKRDY1
});
var AWAKE0 = "AWAKE:0";
var BED1 = "BED:1";
var BED3 = "BED:3";
var SB0 = "SB0";
var SB1 = "SB1";
var SB2 = "SB2";
var SB3 = "SB3";
var SB4 = "SB4";
var SLEEP0 = "SLEEP:0";
var SLEEP1 = "SLEEP:1";
var WKRDY0 = "WKRDY:0";
var WKRDY1 = "WKRDY:1";

// src/models/data-types/ansiel/ansiel-event-code/index.ts
var ALL_ANSIEL_EVENT_CODES = [
  AWAKE0,
  BED1,
  BED3,
  SB0,
  SB1,
  SB2,
  SB3,
  SB4,
  SLEEP0,
  SLEEP1,
  WKRDY0,
  WKRDY1
];
var AnsielEventCodeSchema = memoize(function() {
  return v5.picklist(ALL_ANSIEL_EVENT_CODES);
});
function parseAnsielEventCode(ansielEventCode, options) {
  try {
    return v5.parse(AnsielEventCodeSchema(), ansielEventCode);
  } catch (error) {
    throw toUniversalError(error, options);
  }
}
__name(parseAnsielEventCode, "parseAnsielEventCode");
function isAnsielEventCode(ansielEventCode) {
  return v5.is(AnsielEventCodeSchema(), ansielEventCode);
}
__name(isAnsielEventCode, "isAnsielEventCode");
function fromAnsielEventCodeToResidentState(ansielEventCode) {
  switch (ansielEventCode) {
    case BED3:
    case SB1:
      return resident_state_values_exports.GOT_UP;
    case SLEEP0:
      return resident_state_values_exports.SLEEPING_HEAVILY;
    case SLEEP1:
      return resident_state_values_exports.SLEEPING_LIGHTLY;
    case AWAKE0:
    case BED1:
    case SB0:
    case SB4:
    case WKRDY0:
    case WKRDY1:
      return resident_state_values_exports.WAKING;
    // 変換出来ないイベントは例外を投げる。
    // case ANSIEL_EVENT_CODE.SB2:
    // case ANSIEL_EVENT_CODE.SB3:
    default:
      throw new UniversalError(
        enumeration_exports.UNEXPECTED,
        "ANSIEL\u30A4\u30D9\u30F3\u30C8\u30B3\u30FC\u30C9(" + ansielEventCode + ")\u306F\u5165\u5C45\u8005\u72B6\u614B\u306B\u5909\u63DB\u3067\u304D\u307E\u305B\u3093\u3002"
      );
  }
}
__name(fromAnsielEventCodeToResidentState, "fromAnsielEventCodeToResidentState");

// src/models/data-types/ansiel/core.ts
import * as v6 from "valibot";
var AnsielDeviceIdSchema = memoize(function() {
  return v6.pipe(v6.number(), v6.integer());
});
var AnsielReceiverUniqueKeySchema = memoize(function() {
  return v6.pipe(v6.string(), v6.nonEmpty());
});
var AnsielSerialNumberSchema = memoize(function() {
  return v6.pipe(v6.string(), v6.nonEmpty());
});

// src/models/data-types/android-notification-channel/index.ts
import * as v7 from "valibot";

// src/models/data-types/android-notification-channel/enumeration.ts
var enumeration_exports5 = {};
__export(enumeration_exports5, {
  DEFAULT: () => DEFAULT,
  GOT_UP__MILD: () => GOT_UP__MILD,
  GOT_UP__MODERATE: () => GOT_UP__MODERATE,
  GOT_UP__SEVERE: () => GOT_UP__SEVERE,
  WANDERING: () => WANDERING3
});
var DEFAULT = "Default";
var GOT_UP__MILD = "GotUp.1";
var GOT_UP__MODERATE = "GotUp.2";
var GOT_UP__SEVERE = "GotUp.3";
var WANDERING3 = "Wandering";

// src/models/data-types/android-notification-channel/index.ts
var AndroidNotificationChannelSchema = memoize(function() {
  return v7.picklist([
    DEFAULT,
    GOT_UP__MILD,
    GOT_UP__MODERATE,
    GOT_UP__SEVERE,
    WANDERING3
  ]);
});

// src/models/data-types/array.ts
function sort(array28, compare, reversed = false) {
  return array28.toSorted(function(a, b) {
    return (compare ? compare(a, b) : a > b ? 1 : a < b ? -1 : 0) * (reversed ? -1 : 1);
  });
}
__name(sort, "sort");

// src/models/data-types/independence-level-type/index.ts
import * as v8 from "valibot";

// src/models/data-types/independence-level-type/enumeration.ts
var enumeration_exports6 = {};
__export(enumeration_exports6, {
  COMPLEMENTED: () => COMPLEMENTED,
  ESTIMATED: () => ESTIMATED,
  OBSERVED: () => OBSERVED
});
var COMPLEMENTED = "Complemented";
var ESTIMATED = "Estimated";
var OBSERVED = "Observed";

// src/models/data-types/independence-level-type/index.ts
var IndependenceLevelTypeSchema = memoize(function() {
  return v8.picklist([
    COMPLEMENTED,
    ESTIMATED,
    OBSERVED
  ]);
});

// src/models/data-types/body-part/enumeration.ts
var enumeration_exports7 = {};
__export(enumeration_exports7, {
  BELLY: () => BELLY,
  BUTTOCK: () => BUTTOCK,
  CHEST: () => CHEST,
  ELBOW: () => ELBOW,
  FOOT: () => FOOT,
  FOREARM: () => FOREARM,
  GENITAL_AREA: () => GENITAL_AREA,
  HAND: () => HAND,
  HIP_JOINT: () => HIP_JOINT,
  KNEE: () => KNEE,
  LEFT_FACE: () => LEFT_FACE,
  LEFT_HEAD: () => LEFT_HEAD,
  LOWER_BACK: () => LOWER_BACK,
  LOWER_LEG: () => LOWER_LEG,
  RIGHT_FACE: () => RIGHT_FACE,
  RIGHT_HEAD: () => RIGHT_HEAD,
  SHOULDER: () => SHOULDER,
  THIGH: () => THIGH,
  UPPER_ARM: () => UPPER_ARM,
  UPPER_BACK: () => UPPER_BACK
});
var LEFT_HEAD = "LeftHead";
var RIGHT_HEAD = "RightHead";
var LEFT_FACE = "LeftFace";
var RIGHT_FACE = "RightFace";
var SHOULDER = "Shoulder";
var UPPER_ARM = "UpperArm";
var ELBOW = "Elbow";
var FOREARM = "Forearm";
var HAND = "Hand";
var HIP_JOINT = "HipJoint";
var THIGH = "Thigh";
var KNEE = "Knee";
var LOWER_LEG = "LowerLeg";
var FOOT = "Foot";
var CHEST = "Chest";
var BELLY = "Belly";
var UPPER_BACK = "UpperBack";
var LOWER_BACK = "LowerBack";
var BUTTOCK = "Buttock";
var GENITAL_AREA = "GenitalArea";

// src/models/data-types/data-receiver-path/values.ts
var values_exports = {};
__export(values_exports, {
  AAMS_ALERT: () => AAMS_ALERT,
  AAMS_CARE_RECORDS: () => AAMS_CARE_RECORDS,
  ANSIEL_PUSH_NOTIFICATION: () => ANSIEL_PUSH_NOTIFICATION
});
var AAMS_CARE_RECORDS = "/partnerships/biosilver/api/biosilver/v1/carerecords";
var AAMS_ALERT = "/partnerships/biosilver/api/biosilver/v1/alert";
var ANSIEL_PUSH_NOTIFICATION = "/partnerships/sekisui/ansiel/push-notification";

// src/models/data-types/date.ts
import { Temporal as Temporal3 } from "temporal-polyfill";
import * as v9 from "valibot";
var DateSchema = memoize(function() {
  return v9.union([
    /** `Temporal.PlainDate` */
    v9.instance(Temporal3.PlainDate),
    /** ISO 8601 */
    v9.pipe(
      v9.string(),
      v9.rawTransform(function({ addIssue, dataset: { value }, NEVER }) {
        const issues = [];
        try {
          return Temporal3.PlainDate.from(value);
        } catch (error) {
          issues.push({
            expected: "ISO 8601(`Temporal.PlainDate.toString()`)",
            message: enumeration_exports.INVALID_DATA,
            received: value
          });
        }
        try {
          const components = value.split("/").map(function(component) {
            return Number.parseInt(component, 10);
          });
          if (components.length === 3 && components.every(function(component) {
            return Number.isSafeInteger(component);
          })) {
            const [year, month, day] = components;
            return Temporal3.PlainDate.from({ year, month, day });
          } else {
            issues.push({
              expected: "YYYY/MM/DD",
              message: enumeration_exports.INVALID_DATA,
              received: value
            });
          }
        } catch (error) {
          issues.push({
            expected: "YYYY/MM/DD",
            message: enumeration_exports.INVALID_DATA,
            received: value
          });
        }
        if (issues.length === 0) {
          issues.push({
            expected: "\u65E5\u4ED8\u3092\u8868\u3059\u6587\u5B57\u5217",
            message: enumeration_exports.INVALID_DATA,
            received: value
          });
        }
        for (const issue of issues) {
          addIssue(issue);
        }
        return NEVER;
      })
    )
  ]);
});
function toPracticalDate(dateTime) {
  if (dateTime instanceof Temporal3.Instant) {
    dateTime = dateTime.toZonedDateTimeISO(DEFAULT_TIME_ZONE);
  } else if (dateTime instanceof Temporal3.ZonedDateTime) {
    dateTime = dateTime.withTimeZone(DEFAULT_TIME_ZONE);
  }
  return dateTime.hour < 6 ? dateTime.toPlainDate().subtract({ days: 1 }) : dateTime.toPlainDate();
}
__name(toPracticalDate, "toPracticalDate");

// src/models/data-types/date-time.ts
import { Temporal as Temporal4 } from "temporal-polyfill";
import * as v10 from "valibot";
var DateTimeSchema = memoize(function() {
  return v10.union([
    /** `Temporal.PlainDateTime` */
    v10.instance(Temporal4.PlainDateTime),
    /** ISO 8601 */
    v10.pipe(
      v10.string(),
      v10.rawTransform(function({ addIssue, dataset: { value }, NEVER }) {
        const issues = [];
        try {
          return Temporal4.PlainDateTime.from(value);
        } catch (error) {
          issues.push({
            expected: "ISO 8601(`Temporal.PlainDateTime.toString()`)",
            message: enumeration_exports.INVALID_DATA,
            received: value
          });
        }
        try {
          return Temporal4.ZonedDateTime.from(value).withTimeZone("Asia/Tokyo").toPlainDateTime();
        } catch (error) {
          issues.push({
            expected: "ISO 8601(`Temporal.ZonedDateTime.toString()`)",
            message: enumeration_exports.INVALID_DATA,
            received: value
          });
        }
        try {
          return Temporal4.Instant.from(value).toZonedDateTimeISO("Asia/Tokyo").toPlainDateTime();
        } catch (error) {
          issues.push({
            expected: "ISO 8601(`Date.toISOString()`)`)",
            message: enumeration_exports.INVALID_DATA,
            received: value
          });
        }
        if (issues.length === 0) {
          issues.push({
            expected: "\u65E5\u6642\u3092\u8868\u3059\u6587\u5B57\u5217",
            message: enumeration_exports.INVALID_DATA,
            received: value
          });
        }
        for (const issue of issues) {
          addIssue(issue);
        }
        return NEVER;
      })
    ),
    /** UNIX時間(エポックミリ秒) */
    v10.pipe(
      v10.number(),
      v10.transform(function(n) {
        return Temporal4.Instant.fromEpochMilliseconds(n).toZonedDateTimeISO("Asia/Tokyo").toPlainDateTime();
      })
    ),
    /** JavaScript `Date` */
    v10.pipe(
      v10.date(),
      v10.transform(function(date4) {
        return Temporal4.Instant.fromEpochMilliseconds(date4.getTime()).toZonedDateTimeISO("Asia/Tokyo").toPlainDateTime();
      })
    ),
    /** `Temporal.ZonedDateTime` */
    v10.pipe(
      v10.instance(Temporal4.ZonedDateTime),
      v10.transform(function(input) {
        return input.withTimeZone("Asia/Tokyo").toPlainDateTime();
      })
    )
  ]);
});
var CreationDateTimeSchema = memoize(function() {
  return v10.optional(DateTimeSchema(), function() {
    return Temporal4.Now.plainDateTimeISO("Asia/Tokyo");
  });
});
var DeletionDateTimeSchema = memoize(function() {
  return v10.optional(DateTimeSchema());
});
var MigrationDateTimeSchema = memoize(function() {
  return v10.optional(DateTimeSchema());
});
var UpdateDateTimeSchema = memoize(function() {
  return v10.optional(DateTimeSchema(), function() {
    return Temporal4.Now.plainDateTimeISO("Asia/Tokyo");
  });
});
function parseDateTime(dateTime) {
  return parse2(DateTimeSchema(), dateTime);
}
__name(parseDateTime, "parseDateTime");

// src/models/data-types/deletion-flag/index.ts
import * as v11 from "valibot";

// src/models/data-types/deletion-flag/values.ts
var values_exports2 = {};
__export(values_exports2, {
  ARCHIVED: () => ARCHIVED,
  DEFAULT: () => DEFAULT2,
  DELETED: () => DELETED,
  DELETION_CASCADED: () => DELETION_CASCADED,
  REMOVAL_CASCADED: () => REMOVAL_CASCADED,
  REMOVED: () => REMOVED
});
var DEFAULT2 = 0;
var ARCHIVED = 1;
var REMOVED = 2;
var REMOVAL_CASCADED = 3;
var DELETED = 4;
var DELETION_CASCADED = 5;

// src/models/data-types/deletion-flag/index.ts
var ALL_DELETION_FLAGS = [
  DEFAULT2,
  ARCHIVED,
  REMOVED,
  REMOVAL_CASCADED,
  DELETED,
  DELETION_CASCADED
];
var DeletionFlagSchema = memoize(function() {
  return v11.picklist(ALL_DELETION_FLAGS);
});
var getDeletionFlagSchema = DeletionFlagSchema;
var DefaultDeletionFlagSchema = memoize(function() {
  return v11.optional(DeletionFlagSchema(), DEFAULT2);
});
var getDefaultDeletionFlagSchema = DefaultDeletionFlagSchema;
var DefaultNoncascadeDeletionFlagSchema = memoize(function() {
  return v11.optional(
    v11.picklist([
      DEFAULT2,
      ARCHIVED,
      REMOVED,
      DELETED
    ]),
    DEFAULT2
  );
});
function isDeleted(entity) {
  return entity.deleted !== DEFAULT2;
}
__name(isDeleted, "isDeleted");
function isEnabled(entity) {
  return !!entity && entity.deleted === DEFAULT2;
}
__name(isEnabled, "isEnabled");
function isDisabled(entity) {
  return !entity || entity.deleted !== DEFAULT2;
}
__name(isDisabled, "isDisabled");
function isNotArchived(entity) {
  return entity.deleted < ARCHIVED;
}
__name(isNotArchived, "isNotArchived");
function isNotRemoved(entity) {
  return entity.deleted < REMOVED;
}
__name(isNotRemoved, "isNotRemoved");
function isNotDeleted(entity) {
  return entity.deleted < DELETED;
}
__name(isNotDeleted, "isNotDeleted");
function isExistent(entity) {
  return !!entity && entity.deleted === DEFAULT2;
}
__name(isExistent, "isExistent");

// src/models/data-types/duration.ts
import { Temporal as Temporal5 } from "temporal-polyfill";
import * as v12 from "valibot";
var DurationSchema = memoize(function() {
  return v12.union([
    v12.instance(Temporal5.Duration),
    v12.pipe(
      v12.number(),
      v12.integer(),
      v12.gtValue(0),
      v12.transform(function(milliseconds) {
        return Temporal5.Duration.from({ milliseconds });
      })
    ),
    /** ISO 8601 */
    v12.pipe(
      v12.string(),
      v12.rawTransform(function({ addIssue, dataset: { value }, NEVER }) {
        const issues = [];
        try {
          return Temporal5.Duration.from(value);
        } catch (error) {
          issues.push({
            expected: "ISO 8601(`Temporal.Duration.toString()`)",
            message: enumeration_exports.INVALID_DATA,
            received: value
          });
        }
        if (issues.length === 0) {
          issues.push({
            expected: "\u671F\u9593\u3092\u8868\u3059\u6587\u5B57\u5217",
            message: enumeration_exports.INVALID_DATA,
            received: value
          });
        }
        for (const issue of issues) {
          addIssue(issue);
        }
        return NEVER;
      })
    )
  ]);
});

// src/models/data-types/dynamodb.ts
import * as v13 from "valibot";
var BinaryComparisonOperatorSchema = memoize(function() {
  return v13.picklist(["=", "<", "<=", ">", ">="]);
});
var StringBinaryComparisonOperatorSchema = memoize(function() {
  return v13.picklist([
    ...BinaryComparisonOperatorSchema().options,
    "^"
  ]);
});
var TernaryComparisonOperatorSchema = memoize(function() {
  return v13.literal("-");
});
function QueryFilterSchema(schema) {
  return v13.union([
    v13.tuple([BinaryComparisonOperatorSchema(), schema]),
    v13.tuple([TernaryComparisonOperatorSchema(), schema, schema])
  ]);
}
__name(QueryFilterSchema, "QueryFilterSchema");

// src/models/data-types/email-address.ts
import * as v14 from "valibot";
var getEmailAddressSchema = memoize(function() {
  return v14.pipe(v14.string(), v14.trim(), v14.maxLength(320), v14.rfcEmail());
});

// src/models/data-types/entity-class/index.ts
import * as v15 from "valibot";

// src/models/data-types/entity-class/entity-class-values.ts
var entity_class_values_exports = {};
__export(entity_class_values_exports, {
  APPLE_DEVELOPER_KEY: () => APPLE_DEVELOPER_KEY,
  APPLICATION_CONFIGURATION: () => APPLICATION_CONFIGURATION,
  ASSESSMENT: () => ASSESSMENT,
  BED: () => BED,
  CHANNEL: () => CHANNEL,
  FACILITY: () => FACILITY,
  FACILITY_EVENT: () => FACILITY_EVENT,
  FACILITY_MONTHLY_SUMMARY: () => FACILITY_MONTHLY_SUMMARY,
  FACILITY_OPERATOR: () => FACILITY_OPERATOR,
  FACILITY_STAFF: () => FACILITY_STAFF,
  FALL: () => FALL,
  FALL_RISK_ENTRY: () => FALL_RISK_ENTRY,
  FALL_SCORE_ENTRY: () => FALL_SCORE_ENTRY,
  GOOGLE_CLOUD_SERVICE_ACCOUNT: () => GOOGLE_CLOUD_SERVICE_ACCOUNT,
  GROUP: () => GROUP,
  INDEPENDENCE_LEVEL_ENTRY: () => INDEPENDENCE_LEVEL_ENTRY,
  MEASUREMENT: () => MEASUREMENT,
  OPERATOR: () => OPERATOR,
  ORGANIZATION: () => ORGANIZATION,
  PROVIDER: () => PROVIDER,
  PUSH_NOTIFICATION_RECEIVER: () => PUSH_NOTIFICATION_RECEIVER,
  RESIDENT: () => RESIDENT,
  RESOURCE_INSTANCE: () => RESOURCE_INSTANCE,
  ROOM: () => ROOM,
  SENSOR: () => SENSOR,
  SOCKET_CLIENT: () => SOCKET_CLIENT,
  STATUS: () => STATUS,
  STATUS_SCHEDULE: () => STATUS_SCHEDULE,
  UNIQUE_CONSTRAINT: () => UNIQUE_CONSTRAINT,
  USER: () => USER,
  WATCHTOWER: () => WATCHTOWER
});
var APPLICATION_CONFIGURATION = "ApplicationConfiguration";
var APPLE_DEVELOPER_KEY = "AppleDeveloperKey";
var ASSESSMENT = "Assessment";
var BED = "Bed";
var CHANNEL = "Channel";
var FACILITY = "Facility";
var FACILITY_EVENT = "FacilityEvent";
var FACILITY_MONTHLY_SUMMARY = "FacilityMonthlySummary";
var FACILITY_OPERATOR = "FacilityOperator";
var FACILITY_STAFF = "FacilityStaff";
var GROUP = "Group";
var FALL = "Fall";
var FALL_RISK_ENTRY = "FallRiskEntry";
var FALL_SCORE_ENTRY = "FallScoreEntry";
var GOOGLE_CLOUD_SERVICE_ACCOUNT = "GoogleCloudServiceAccount";
var INDEPENDENCE_LEVEL_ENTRY = "IndependenceLevelEntry";
var MEASUREMENT = "Measurement";
var OPERATOR = "Operator";
var ORGANIZATION = "Organization";
var PROVIDER = "Provider";
var PUSH_NOTIFICATION_RECEIVER = "PushNotificationReceiver";
var RESIDENT = "Resident";
var RESOURCE_INSTANCE = "ResourceInstance";
var ROOM = "Room";
var SENSOR = "Sensor";
var SOCKET_CLIENT = "SocketClient";
var STATUS = "Status";
var STATUS_SCHEDULE = "StatusSchedule";
var UNIQUE_CONSTRAINT = "UniqueConstraint";
var USER = "User";
var WATCHTOWER = "Watchtower";

// src/models/data-types/entity-class/index.ts
function EntityClassSchema(entityClass) {
  return v15.optional(v15.literal(entityClass), entityClass);
}
__name(EntityClassSchema, "EntityClassSchema");

// src/models/data-types/facility-staff-role/index.ts
import * as v16 from "valibot";

// src/models/data-types/facility-staff-role/enumeration.ts
var enumeration_exports8 = {};
__export(enumeration_exports8, {
  CAREGIVER: () => CAREGIVER,
  NURSE: () => NURSE,
  THERAPIST: () => THERAPIST
});
var CAREGIVER = "Caregiver";
var NURSE = "Nurse";
var THERAPIST = "Therapist";

// src/models/data-types/facility-staff-role/index.ts
var ALL_FACILITY_STAFF_ROLES = [
  CAREGIVER,
  NURSE,
  THERAPIST
];
var FacilityStaffRoleSchema = memoize(function() {
  return v16.picklist(ALL_FACILITY_STAFF_ROLES);
});
function parseFacilityStaffRole(facilityStaffTier, options) {
  return parse2(FacilityStaffRoleSchema(), facilityStaffTier, options);
}
__name(parseFacilityStaffRole, "parseFacilityStaffRole");

// src/models/data-types/facility-staff-tier/index.ts
import * as v17 from "valibot";

// src/models/data-types/facility-staff-tier/enumeration.ts
var enumeration_exports9 = {};
__export(enumeration_exports9, {
  ADMINISTRATOR: () => ADMINISTRATOR,
  DEFAULT: () => DEFAULT3,
  MANAGER: () => MANAGER
});
var ADMINISTRATOR = 0;
var MANAGER = 20;
var DEFAULT3 = 1e3;

// src/models/data-types/facility-staff-tier/index.ts
var ALL_FACILITY_STAFF_TIERS = [
  ADMINISTRATOR,
  MANAGER,
  DEFAULT3
];
var FacilityStaffTierSchema = memoize(function() {
  return v17.picklist(ALL_FACILITY_STAFF_TIERS);
});
function parseFacilityStaffTier(facilityStaffTier, options) {
  return parse2(FacilityStaffTierSchema(), facilityStaffTier, options);
}
__name(parseFacilityStaffTier, "parseFacilityStaffTier");

// src/models/data-types/fall-risk/index.ts
import * as v18 from "valibot";

// src/models/data-types/fall-risk/enumeration.ts
var enumeration_exports10 = {};
__export(enumeration_exports10, {
  MILD: () => MILD,
  MODERATE: () => MODERATE,
  SEVERE: () => SEVERE
});
var MILD = 1;
var MODERATE = 2;
var SEVERE = 3;

// src/models/data-types/fall-risk/index.ts
var FallRiskSchema = memoize(function() {
  return v18.picklist([MILD, MODERATE, SEVERE]);
});
var ALL_FALL_RISKS = [
  SEVERE,
  MODERATE,
  MILD
];

// src/models/data-types/fall-score.ts
import * as v19 from "valibot";
var FallScoreSchema = memoize(function() {
  return v19.pipe(v19.number(), v19.safeInteger(), v19.brand("FallScore"));
});
function parseFallScore(fallScore) {
  return v19.parse(FallScoreSchema(), fallScore);
}
__name(parseFallScore, "parseFallScore");

// src/models/data-types/fim-domain/enumeration.ts
var enumeration_exports11 = {};
__export(enumeration_exports11, {
  COMMUNICATION: () => COMMUNICATION,
  LOCOMOTION: () => LOCOMOTION,
  SELF_CARE: () => SELF_CARE,
  SOCIAL_COGNITION: () => SOCIAL_COGNITION,
  SPHINCTER_CONTROL: () => SPHINCTER_CONTROL,
  TRANSFER: () => TRANSFER
});
var COMMUNICATION = "Communication";
var LOCOMOTION = "Locomotion";
var SELF_CARE = "SelfCare";
var SPHINCTER_CONTROL = "SphincterControl";
var SOCIAL_COGNITION = "SocialCognition";
var TRANSFER = "Transfer";

// src/models/data-types/fim-item/index.ts
import * as v20 from "valibot";

// src/models/data-types/fim-item/fim-item-values.ts
var fim_item_values_exports = {};
__export(fim_item_values_exports, {
  BATHING: () => BATHING,
  BED_CHAIR_WHEELCHAIR: () => BED_CHAIR_WHEELCHAIR,
  BLADDER_MANAGEMENT: () => BLADDER_MANAGEMENT,
  BOWEL_MANAGEMENT: () => BOWEL_MANAGEMENT,
  COMPREHENSION: () => COMPREHENSION,
  EATING: () => EATING,
  EXPRESSION: () => EXPRESSION,
  GROOMING: () => GROOMING,
  LOWER_BODY_DRESSING: () => LOWER_BODY_DRESSING,
  MEMORY: () => MEMORY,
  PROBLEM_SOLVING: () => PROBLEM_SOLVING,
  SOCIAL_INTERACTION: () => SOCIAL_INTERACTION,
  STAIRS: () => STAIRS,
  TOILET: () => TOILET,
  TOILETING: () => TOILETING,
  TUB_SHOWER: () => TUB_SHOWER,
  UPPER_BODY_DRESSING: () => UPPER_BODY_DRESSING,
  WALK_WHEELCHAIR: () => WALK_WHEELCHAIR
});
var EATING = 0;
var GROOMING = 1;
var BATHING = 2;
var UPPER_BODY_DRESSING = 3;
var LOWER_BODY_DRESSING = 4;
var TOILETING = 5;
var BLADDER_MANAGEMENT = 6;
var BOWEL_MANAGEMENT = 7;
var BED_CHAIR_WHEELCHAIR = 8;
var TOILET = 9;
var TUB_SHOWER = 10;
var WALK_WHEELCHAIR = 11;
var STAIRS = 12;
var COMPREHENSION = 13;
var EXPRESSION = 14;
var SOCIAL_INTERACTION = 15;
var PROBLEM_SOLVING = 16;
var MEMORY = 17;

// src/models/data-types/fim-item/index.ts
var ALL_FIM_ITEMS = [
  EATING,
  GROOMING,
  BATHING,
  UPPER_BODY_DRESSING,
  LOWER_BODY_DRESSING,
  TOILETING,
  BLADDER_MANAGEMENT,
  BOWEL_MANAGEMENT,
  BED_CHAIR_WHEELCHAIR,
  TOILET,
  TUB_SHOWER,
  WALK_WHEELCHAIR,
  STAIRS,
  COMPREHENSION,
  EXPRESSION,
  SOCIAL_INTERACTION,
  PROBLEM_SOLVING,
  MEMORY
];
var getFimItemSchema = memoize(function() {
  return v20.picklist(ALL_FIM_ITEMS);
});
function fromFimItemToFimDomain(fimItem) {
  switch (fimItem) {
    case EATING:
    case GROOMING:
    case BATHING:
    case UPPER_BODY_DRESSING:
    case LOWER_BODY_DRESSING:
    case TOILETING:
      return enumeration_exports11.SELF_CARE;
    case BLADDER_MANAGEMENT:
    case BOWEL_MANAGEMENT:
      return enumeration_exports11.SPHINCTER_CONTROL;
    case BED_CHAIR_WHEELCHAIR:
    case TOILET:
    case TUB_SHOWER:
      return enumeration_exports11.TRANSFER;
    case WALK_WHEELCHAIR:
    case STAIRS:
      return enumeration_exports11.LOCOMOTION;
    case COMPREHENSION:
    case EXPRESSION:
      return enumeration_exports11.COMMUNICATION;
    case SOCIAL_INTERACTION:
    case PROBLEM_SOLVING:
    case MEMORY:
      return enumeration_exports11.SOCIAL_COGNITION;
  }
}
__name(fromFimItemToFimDomain, "fromFimItemToFimDomain");

// src/models/data-types/fim-subscale/enumeration.ts
var enumeration_exports12 = {};
__export(enumeration_exports12, {
  COGNITION: () => COGNITION,
  MOTOR: () => MOTOR
});
var COGNITION = "Cognition";
var MOTOR = "Motor";

// src/models/data-types/independence-level/index.ts
import * as v21 from "valibot";

// src/models/data-types/independence-level/values.ts
var values_exports3 = {};
__export(values_exports3, {
  COMPLETE_INDEPENDENCE: () => COMPLETE_INDEPENDENCE,
  MAXIMAL_ASSISTANCE: () => MAXIMAL_ASSISTANCE,
  MINIMAL_ASSISTANCE: () => MINIMAL_ASSISTANCE,
  MODERATE_ASSISTANCE: () => MODERATE_ASSISTANCE,
  MODIFIED_INDEPENDENCE: () => MODIFIED_INDEPENDENCE,
  SUPERVISION: () => SUPERVISION,
  TOTAL_ASSISTANCE: () => TOTAL_ASSISTANCE
});
var TOTAL_ASSISTANCE = 1;
var MAXIMAL_ASSISTANCE = 2;
var MODERATE_ASSISTANCE = 3;
var MINIMAL_ASSISTANCE = 4;
var SUPERVISION = 5;
var MODIFIED_INDEPENDENCE = 6;
var COMPLETE_INDEPENDENCE = 7;

// src/models/data-types/independence-level/index.ts
var ALL_INDEPENDENCE_LEVELS = [
  COMPLETE_INDEPENDENCE,
  MODIFIED_INDEPENDENCE,
  SUPERVISION,
  MINIMAL_ASSISTANCE,
  MODERATE_ASSISTANCE,
  MAXIMAL_ASSISTANCE,
  TOTAL_ASSISTANCE
];
var IndependenceLevelSchema = memoize(function() {
  return v21.picklist([
    TOTAL_ASSISTANCE,
    MAXIMAL_ASSISTANCE,
    MODERATE_ASSISTANCE,
    MINIMAL_ASSISTANCE,
    SUPERVISION,
    MODIFIED_INDEPENDENCE,
    COMPLETE_INDEPENDENCE
  ]);
});
var getIndependenceLevelSchema = IndependenceLevelSchema;
function parseIndependenceLevel(independenceLevel, options) {
  return v21.parse(IndependenceLevelSchema(), independenceLevel, options);
}
__name(parseIndependenceLevel, "parseIndependenceLevel");
var IndependenceLevelsSchema = memoize(function() {
  return v21.tuple([
    IndependenceLevelSchema(),
    IndependenceLevelSchema(),
    IndependenceLevelSchema(),
    IndependenceLevelSchema(),
    IndependenceLevelSchema(),
    IndependenceLevelSchema(),
    IndependenceLevelSchema(),
    IndependenceLevelSchema(),
    IndependenceLevelSchema(),
    IndependenceLevelSchema(),
    IndependenceLevelSchema(),
    IndependenceLevelSchema(),
    IndependenceLevelSchema(),
    IndependenceLevelSchema(),
    IndependenceLevelSchema(),
    IndependenceLevelSchema(),
    IndependenceLevelSchema(),
    IndependenceLevelSchema()
  ]);
});
function parseIndependenceLevels(independenceLevels, options) {
  try {
    return v21.parse(
      IndependenceLevelsSchema(),
      Array.isArray(independenceLevels) ? independenceLevels : [
        independenceLevels["0"],
        independenceLevels["1"],
        independenceLevels["2"],
        independenceLevels["3"],
        independenceLevels["4"],
        independenceLevels["5"],
        independenceLevels["6"],
        independenceLevels["7"],
        independenceLevels["8"],
        independenceLevels["9"],
        independenceLevels["10"],
        independenceLevels["11"],
        independenceLevels["12"],
        independenceLevels["13"],
        independenceLevels["14"],
        independenceLevels["15"],
        independenceLevels["16"],
        independenceLevels["17"]
      ]
    );
  } catch (error) {
    throw toUniversalError(error, options);
  }
}
__name(parseIndependenceLevels, "parseIndependenceLevels");

// src/models/data-types/ios-sound/enumeration.ts
var enumeration_exports13 = {};
__export(enumeration_exports13, {
  ALERT__GOT_UP__MILD: () => ALERT__GOT_UP__MILD,
  ALERT__GOT_UP__MODERATE: () => ALERT__GOT_UP__MODERATE,
  ALERT__GOT_UP__SEVERE: () => ALERT__GOT_UP__SEVERE,
  ALERT__WANDERING: () => ALERT__WANDERING
});
var ALERT__GOT_UP__MILD = "alert.got-up.mild.mp3";
var ALERT__GOT_UP__MODERATE = "alert.got-up.moderate.mp3";
var ALERT__GOT_UP__SEVERE = "alert.got-up.severe.mp3";
var ALERT__WANDERING = "alert.wandering.mp3";

// src/models/data-types/key.ts
import { Temporal as Temporal6 } from "temporal-polyfill";
import * as v22 from "valibot";
function generateDateTimePart(dateTime, precision) {
  switch (precision) {
    case "second":
      if (dateTime.year >= 52476) {
        throw new UniversalError(enumeration_exports.DEPRECATED);
      }
      return toDuosexagesimal(
        toDateTimeNumber(
          dateTime.year,
          dateTime.month,
          dateTime.day,
          dateTime.hour,
          dateTime.minute,
          dateTime.second,
          null
        )
      ).padStart(7, "0");
    case "millisecond":
      if (dateTime.year >= 196990) {
        throw new UniversalError(enumeration_exports.DEPRECATED);
      }
      return toDuosexagesimal(
        toDateTimeNumber(
          dateTime.year,
          dateTime.month,
          dateTime.day,
          dateTime.hour,
          dateTime.minute,
          dateTime.second,
          dateTime.millisecond,
          null
        )
      ).padStart(9, "0");
    default:
      throw new UniversalError(enumeration_exports.UNEXPECTED, precision + "\u306F\u672A\u5BFE\u5FDC\u306E\u65E5\u6642\u7CBE\u5EA6\u3067\u3059\u3002");
  }
}
__name(generateDateTimePart, "generateDateTimePart");
var BedKeySchema = memoize(function() {
  return v22.pipe(v22.string(), v22.regex(/^b[0-9A-Za-z]{11}$/), v22.brand("BedKey"));
});
function generateBedKey(randomString, dateTime) {
  dateTime ??= Temporal6.Now.plainDateTimeISO("Asia/Tokyo");
  randomString ??= generateRandomString(2);
  return v22.parse(
    BedKeySchema(),
    "b" + generateDateTimePart(dateTime, "millisecond") + randomString
  );
}
__name(generateBedKey, "generateBedKey");
var FacilityKeySchema = memoize(function() {
  return v22.custom(function(value) {
    return typeof value === "string" && /^f[0-9A-Za-z]{9}$/.test(value);
  });
});
var getFacilityKeySchema = FacilityKeySchema;
function isFacilityKey(facilityKey) {
  return v22.is(FacilityKeySchema(), facilityKey);
}
__name(isFacilityKey, "isFacilityKey");
function generateFacilityKey(dateTime, randomString) {
  dateTime ??= Temporal6.Now.plainDateTimeISO("Asia/Tokyo");
  randomString ??= generateRandomString(2);
  return v22.parse(
    FacilityKeySchema(),
    "f" + generateDateTimePart(dateTime, "second") + randomString
  );
}
__name(generateFacilityKey, "generateFacilityKey");
var FallKeySchema = memoize(function() {
  return v22.custom(function(value) {
    return typeof value === "string" && /^u[0-9A-Za-z]{11}f[0-9A-Za-z]{9}$/.test(value);
  });
});
function isFallKey(fallKey) {
  return v22.is(FallKeySchema(), fallKey);
}
__name(isFallKey, "isFallKey");
function generateFallKey(userKey, dateTime) {
  return v22.parse(FallKeySchema(), userKey + "f" + generateDateTimePart(dateTime, "millisecond"));
}
__name(generateFallKey, "generateFallKey");
var MeasurementKeySchema = memoize(function() {
  return v22.custom(function(value) {
    return typeof value === "string" && /^[su][0-9A-Za-z]{11}m[0-9A-Za-z]{7,9}$/.test(value);
  });
});
function generateMeasurementKey(parentKey, dateTime) {
  return v22.parse(
    MeasurementKeySchema(),
    parentKey + "m" + generateDateTimePart(dateTime, "millisecond")
  );
}
__name(generateMeasurementKey, "generateMeasurementKey");
var OrganizationKeySchema = memoize(function() {
  return v22.custom(function(value) {
    return typeof value === "string" && /^o[0-9A-Za-z]{9}$/.test(value);
  });
});
var getOrganizationKeySchema = OrganizationKeySchema;
function isOrganizationKey(value) {
  return v22.is(OrganizationKeySchema(), value);
}
__name(isOrganizationKey, "isOrganizationKey");
function generateOrganizationKey(dateTime, randomString) {
  dateTime ??= Temporal6.Now.plainDateTimeISO("Asia/Tokyo");
  randomString ??= generateRandomString(2);
  return v22.parse(
    OrganizationKeySchema(),
    "o" + generateDateTimePart(dateTime, "second") + randomString
  );
}
__name(generateOrganizationKey, "generateOrganizationKey");
function parseOrganizationKey(organizationKey, options) {
  return v22.parse(OrganizationKeySchema(), organizationKey, options);
}
__name(parseOrganizationKey, "parseOrganizationKey");
var ProviderKeySchema = memoize(function() {
  return v22.custom(function(value) {
    return typeof value === "string" && /^p[0-9A-Za-z]{9}$/.test(value);
  });
});
var getProviderKeySchema = ProviderKeySchema;
function isProviderKey(providerKey) {
  return v22.is(ProviderKeySchema(), providerKey);
}
__name(isProviderKey, "isProviderKey");
function generateProviderKey(dateTime, randomString) {
  dateTime ??= Temporal6.Now.plainDateTimeISO("Asia/Tokyo");
  randomString ??= generateRandomString(2);
  return v22.parse(
    ProviderKeySchema(),
    "p" + generateDateTimePart(dateTime, "second") + randomString
  );
}
__name(generateProviderKey, "generateProviderKey");
var RoomKeySchema = memoize(function() {
  return v22.custom(function(value) {
    return typeof value === "string" && /^r[0-9A-Za-z]{11}$/.test(value);
  });
});
var getRoomKeySchema = RoomKeySchema;
function isRoomKey(roomKey) {
  return v22.is(RoomKeySchema(), roomKey);
}
__name(isRoomKey, "isRoomKey");
function generateRoomKey(dateTime) {
  dateTime ??= Temporal6.Now.plainDateTimeISO("Asia/Tokyo");
  if (dateTime.year >= 196990) {
    throw new UniversalError(enumeration_exports.DEPRECATED);
  }
  return v22.parse(
    RoomKeySchema(),
    "r" + generateDateTimePart(dateTime, "millisecond") + generateRandomString(2)
  );
}
__name(generateRoomKey, "generateRoomKey");
var SensorKeySchema = memoize(function() {
  return v22.custom(function(value) {
    return typeof value === "string" && /^s[0-9A-Za-z]{11}$/.test(value);
  });
});
var getSensorKeySchema = SensorKeySchema;
function isSensorKey(sensorKey) {
  return v22.is(SensorKeySchema(), sensorKey);
}
__name(isSensorKey, "isSensorKey");
function generateSensorKey(dateTime, randomString) {
  dateTime ??= Temporal6.Now.plainDateTimeISO("Asia/Tokyo");
  randomString ??= generateRandomString(2);
  return v22.parse(
    SensorKeySchema(),
    "s" + generateDateTimePart(dateTime, "millisecond") + randomString
  );
}
__name(generateSensorKey, "generateSensorKey");
var StatusKeySchema = memoize(function() {
  return v22.custom(function(value) {
    return typeof value === "string" && /^[su][0-9A-Za-z]{11}s[0-9A-Za-z]{9}$/.test(value);
  });
});
function isStatusKey(statusKey) {
  return v22.is(StatusKeySchema(), statusKey);
}
__name(isStatusKey, "isStatusKey");
function generateStatusKey(parentKey, dateTime) {
  return v22.parse(
    StatusKeySchema(),
    parentKey + "s" + generateDateTimePart(dateTime, "millisecond")
  );
}
__name(generateStatusKey, "generateStatusKey");
var UserKeySchema = memoize(function() {
  return v22.custom(function(value) {
    return typeof value === "string" && /^u[0-9A-Za-z]{11}$/.test(value);
  });
});
var getUserKeySchema = UserKeySchema;
function isUserKey(userKey) {
  return v22.is(UserKeySchema(), userKey);
}
__name(isUserKey, "isUserKey");
function parseUserKey(userKey) {
  return v22.parse(UserKeySchema(), userKey);
}
__name(parseUserKey, "parseUserKey");
function generateUserKey(dateTime, randomString) {
  dateTime ??= Temporal6.Now.plainDateTimeISO("Asia/Tokyo");
  randomString ??= generateRandomString(2);
  return v22.parse(
    UserKeySchema(),
    "u" + generateDateTimePart(dateTime, "millisecond") + randomString
  );
}
__name(generateUserKey, "generateUserKey");
var UsernameSchema = memoize(function() {
  return v22.union([FacilityKeySchema(), OrganizationKeySchema(), UserKeySchema()]);
});
function parseUsername(username) {
  return v22.parse(UsernameSchema(), username);
}
__name(parseUsername, "parseUsername");
var WatchtowerKeySchema = memoize(function() {
  return v22.custom(function(value) {
    return typeof value === "string" && /^w[0-9A-Za-z]{23}$/.test(value);
  });
});
function isWatchtowerKey(watchtowerKey) {
  return v22.is(WatchtowerKeySchema(), watchtowerKey);
}
__name(isWatchtowerKey, "isWatchtowerKey");
function generateWatchtowerKey(dateTime) {
  dateTime ??= Temporal6.Now.plainDateTimeISO("Asia/Tokyo");
  return v22.parse(
    WatchtowerKeySchema(),
    "w" + generateDateTimePart(dateTime, "millisecond") + generateRandomString(14)
  );
}
__name(generateWatchtowerKey, "generateWatchtowerKey");

// src/models/data-types/mac-address.ts
import * as v23 from "valibot";
var MacAddressSchema = memoize(function() {
  return v23.pipe(v23.string(), v23.trim(), v23.toUpperCase(), v23.regex(/^([0-9A-F]{2}:){5}[0-9A-F]{2}$/));
});
var getMacAddressSchema = MacAddressSchema;

// src/models/data-types/operator-tier/index.ts
import * as v24 from "valibot";

// src/models/data-types/operator-tier/operator-tier-values.ts
var operator_tier_values_exports = {};
__export(operator_tier_values_exports, {
  ADMINISTRATOR: () => ADMINISTRATOR2,
  DEFAULT: () => DEFAULT4
});
var ADMINISTRATOR2 = 0;
var DEFAULT4 = 100;

// src/models/data-types/operator-tier/index.ts
var getOperatorTierSchema = memoize(function() {
  return v24.picklist([ADMINISTRATOR2, DEFAULT4]);
});

// src/models/data-types/pagination.ts
import * as v25 from "valibot";
var LimitSchema = memoize(function() {
  return v25.pipe(v25.number(), v25.integer(), v25.minValue(1));
});
var NextPageTokenSchema = memoize(function() {
  return v25.record(v25.string(), v25.any());
});
var PageSizeSchema = memoize(function() {
  return v25.pipe(v25.number(), v25.integer(), v25.minValue(1));
});

// src/models/data-types/password.ts
import * as v26 from "valibot";
var PASSWORD_REGEX = /^[0-9A-Za-z!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]{6,256}$/;
function PasswordSchema() {
  return v26.pipe(v26.string(), v26.trim(), v26.regex(PASSWORD_REGEX));
}
__name(PasswordSchema, "PasswordSchema");
var getPasswordSchema = PasswordSchema;
var SPECIAL_CHARACTERS = "!\"#$%&'()*+,-./:;<=>?@[\\]^_`{|}~";
var PASSWORD_CHARACTERS = ALPHANUMERIC_CHARACTERS + SPECIAL_CHARACTERS;
var NUMBER_OF_ALPHABETS = Math.floor(ALPHABETIC_CHARACTERS.length / 2);
function generatePassword(length2 = 24) {
  if (length2 < 4) {
    throw new UniversalError(enumeration_exports.UNEXPECTED, {
      message: "4\u6587\u5B57\u672A\u6E80\u306E\u30D1\u30B9\u30EF\u30FC\u30C9\u306F\u751F\u6210\u51FA\u6765\u307E\u305B\u3093\u3002"
    });
  }
  const characters = [
    NUMERIC_CHARACTERS.at(Math.floor(Math.random() * NUMERIC_CHARACTERS.length)),
    ALPHABETIC_CHARACTERS.at(Math.floor(Math.random() * NUMBER_OF_ALPHABETS)),
    ALPHABETIC_CHARACTERS.at(Math.floor(Math.random() * NUMBER_OF_ALPHABETS) + NUMBER_OF_ALPHABETS),
    SPECIAL_CHARACTERS.at(Math.floor(Math.random() * SPECIAL_CHARACTERS.length))
  ];
  for (let i = Math.max(length2 - characters.length, 0); i > 0; i--) {
    characters.push(PASSWORD_CHARACTERS[Math.floor(Math.random() * PASSWORD_CHARACTERS.length)]);
  }
  for (let index1 = characters.length - 1; index1 > 0; index1--) {
    const index2 = Math.floor(Math.random() * (index1 + 1));
    const element = characters[index1];
    characters[index1] = characters[index2];
    characters[index2] = element;
  }
  return characters.join("");
}
__name(generatePassword, "generatePassword");

// src/models/data-types/phone-number.ts
import * as v27 from "valibot";
var PHONE_NUMBER_REGEX = /^(\+\d{1,3}|\+1-\d{3}|0)\d{1,20}$/;
var getPhoneNumberSchema = memoize(function() {
  return v27.pipe(
    v27.string(),
    v27.trim(),
    v27.regex(PHONE_NUMBER_REGEX),
    v27.transform(normalizePhoneNumber)
  );
});
function normalizePhoneNumber(phoneNumber) {
  return phoneNumber.startsWith("0") ? "+81" + phoneNumber.slice(1) : phoneNumber;
}
__name(normalizePhoneNumber, "normalizePhoneNumber");
function denormalizePhoneNumber(phoneNumber) {
  return phoneNumber.startsWith("+81") ? "0" + phoneNumber.slice(3) : phoneNumber;
}
__name(denormalizePhoneNumber, "denormalizePhoneNumber");

// src/models/data-types/postal-code.ts
import * as v28 from "valibot";
var POSTAL_CODE_REGEX = /^\d{7}$/;
var getPostalCodeSchema = memoize(function() {
  return v28.pipe(v28.string(), v28.trim(), v28.regex(POSTAL_CODE_REGEX));
});

// src/models/data-types/provider-state/values.ts
var values_exports5 = {};
__export(values_exports5, {
  PROVIDER_ERROR: () => PROVIDER_ERROR3,
  RUNNING: () => RUNNING
});

// src/models/data-types/sensor-state/values.ts
var values_exports4 = {};
__export(values_exports4, {
  GOT_UP: () => GOT_UP4,
  PROVIDER_ERROR: () => PROVIDER_ERROR2,
  SENSOR_ERROR: () => SENSOR_ERROR3,
  SLEEPING: () => SLEEPING2,
  SLEEPING_HEAVILY: () => SLEEPING_HEAVILY3,
  SLEEPING_LIGHTLY: () => SLEEPING_LIGHTLY3,
  UNKNOWN: () => UNKNOWN3,
  WAKING: () => WAKING3
});
var GOT_UP4 = resident_state_values_exports.GOT_UP;
var PROVIDER_ERROR2 = resident_state_values_exports.PROVIDER_ERROR;
var SENSOR_ERROR3 = resident_state_values_exports.SENSOR_ERROR;
var SLEEPING2 = resident_state_values_exports.SLEEPING;
var SLEEPING_HEAVILY3 = resident_state_values_exports.SLEEPING_HEAVILY;
var SLEEPING_LIGHTLY3 = resident_state_values_exports.SLEEPING_LIGHTLY;
var UNKNOWN3 = resident_state_values_exports.UNKNOWN;
var WAKING3 = resident_state_values_exports.WAKING;

// src/models/data-types/provider-state/values.ts
var PROVIDER_ERROR3 = values_exports4.PROVIDER_ERROR;
var RUNNING = "Running";

// src/models/data-types/provider-type/index.ts
import * as v29 from "valibot";

// src/models/data-types/provider-type/values.ts
var values_exports6 = {};
__export(values_exports6, {
  AAMS_SERVER: () => AAMS_SERVER,
  ANSIEL_API: () => ANSIEL_API,
  GENERIC_PROVIDER: () => GENERIC_PROVIDER
});
var AAMS_SERVER = "AamsServer";
var ANSIEL_API = "AnsielApi";
var GENERIC_PROVIDER = "GenericProvider";

// src/models/data-types/provider-type/index.ts
var ALL_PROVIDER_TYPES = [
  AAMS_SERVER,
  ANSIEL_API,
  GENERIC_PROVIDER
];
var ProviderTypeSchema = memoize(function() {
  return v29.picklist(ALL_PROVIDER_TYPES);
});

// src/models/data-types/push-notification-receiver-type/index.ts
import * as v30 from "valibot";

// src/models/data-types/push-notification-receiver-type/enumeration.ts
var enumeration_exports14 = {};
__export(enumeration_exports14, {
  APNS: () => APNS,
  FCM: () => FCM
});
var APNS = "Apns";
var FCM = "Fcm";

// src/models/data-types/push-notification-receiver-type/index.ts
var PushNotificationReceiverTypeSchema = memoize(function() {
  return v30.picklist([APNS, FCM]);
});

// src/models/data-types/query.ts
import * as v31 from "valibot";
var QueryOptionsSchema = memoize(function() {
  return v31.partial(
    v31.object({
      /**
       * **数え上げフラグ**
       * 項目の一覧は省略し、数だけを返す場合に`true`を指定する。
       * DynamoDBの`Select: "Count"`を指定する事で実現しており、
       * 項目そのものは読み込まれるため、パフォーマンスやコストには影響しない。
       */
      // counting: v.boolean(),
      /**
       * **降順フラグ**
       * 項目を降順で取得する場合に`true`を指定する。
       * **スキャンには無効**でクエリにのみ有効。
       */
      descendingOrder: v31.boolean(),
      /**
       * **リミットのスキーマ**
       * 1回の通信で取得する項目数の最大値のスキーマ。
       * 指定しない場合は可能な限り多くの項目を取得する。
       */
      limit: LimitSchema(),
      /**
       * **次のページのトークン**
       * クエリを途中から再開する場合に指定する。
       */
      nextPageToken: v31.pipe(NextPageTokenSchema(), v31.readonly()),
      /**
       * **ページサイズ**
       * 1回の通信で取得する最大の項目数を指定する。
       * 指定しない場合は可能な限り多くの項目を取得する。
       * @deprecated 代わりに`limit`を使用する。
       */
      pageSize: PageSizeSchema()
    })
  );
});
var BedQueryFiltersSchema = memoize(function() {
  return v31.union([
    v31.object({ bedKey: BedKeySchema() }),
    v31.object({
      facilityKey: FacilityKeySchema(),
      deleted: v31.optional(v31.union([DeletionFlagSchema(), QueryFilterSchema(DeletionFlagSchema())]))
    }),
    v31.object({ sensorKey: SensorKeySchema() }),
    v31.object({ userKey: UserKeySchema() })
  ]);
});
var FacilityQueryFiltersSchema = memoize(function() {
  return v31.union([
    v31.object({ facilityKey: FacilityKeySchema() }),
    v31.object({
      organizationKey: OrganizationKeySchema(),
      deleted: v31.optional(v31.union([DeletionFlagSchema(), QueryFilterSchema(DeletionFlagSchema())]))
    })
  ]);
});
var FacilityStaffQueryFiltersSchema = memoize(function() {
  return v31.union([
    v31.object({
      facilityKey: FacilityKeySchema(),
      userKey: v31.optional(v31.union([UserKeySchema(), QueryFilterSchema(UserKeySchema())]))
    }),
    v31.object({
      facilityKey: FacilityKeySchema(),
      deleted: v31.optional(v31.union([DeletionFlagSchema(), QueryFilterSchema(DeletionFlagSchema())]))
    }),
    v31.object({
      userKey: UserKeySchema(),
      deleted: v31.optional(v31.union([DeletionFlagSchema(), QueryFilterSchema(DeletionFlagSchema())]))
    })
  ]);
});
var FallQueryFiltersSchema = memoize(function() {
  return v31.union([
    v31.object({ fallKey: FallKeySchema() }),
    v31.intersect([
      v31.object({
        userKey: UserKeySchema()
      }),
      v31.union([
        v31.object({
          deleted: DeletionFlagSchema(),
          fellAt: v31.optional(v31.union([DateTimeSchema(), QueryFilterSchema(DateTimeSchema())]))
        }),
        v31.object({ deleted: v31.optional(QueryFilterSchema(DeletionFlagSchema())) })
      ])
    ])
  ]);
});
var MeasurementQueryFiltersSchema = memoize(function() {
  return v31.union([
    v31.object({ measurementKey: MeasurementKeySchema() }),
    v31.intersect([
      v31.object({ sensorKey: SensorKeySchema() }),
      v31.union([
        v31.object({
          deleted: DeletionFlagSchema(),
          measuredAt: v31.optional(v31.union([DateTimeSchema(), QueryFilterSchema(DateTimeSchema())]))
        }),
        v31.object({ deleted: v31.optional(QueryFilterSchema(DeletionFlagSchema())) })
      ])
    ]),
    v31.intersect([
      v31.object({ userKey: UserKeySchema() }),
      v31.union([
        v31.object({
          deleted: DeletionFlagSchema(),
          measuredAt: v31.optional(v31.union([DateTimeSchema(), QueryFilterSchema(DateTimeSchema())]))
        }),
        v31.object({ deleted: v31.optional(QueryFilterSchema(DeletionFlagSchema())) })
      ])
    ])
  ]);
});
var OrganizationQueryFiltersSchema = memoize(function() {
  return v31.union([v31.object({ organizationKey: OrganizationKeySchema() })]);
});
var ProviderQueryFiltersSchema = memoize(function() {
  return v31.union([
    v31.object({
      facilityKey: FacilityKeySchema(),
      deleted: v31.optional(v31.union([DeletionFlagSchema(), QueryFilterSchema(DeletionFlagSchema())]))
    }),
    v31.object({
      organizationKey: OrganizationKeySchema(),
      deleted: v31.optional(v31.union([DeletionFlagSchema(), QueryFilterSchema(DeletionFlagSchema())]))
    }),
    v31.object({ providerKey: ProviderKeySchema() }),
    v31.object({
      type: ProviderTypeSchema(),
      deleted: v31.optional(v31.union([DeletionFlagSchema(), QueryFilterSchema(DeletionFlagSchema())]))
    }),
    v31.object({ uniqueString: v31.string() })
  ]);
});
var PushNotificationReceiverQueryFiltersSchema = memoize(function() {
  return v31.variant("index", [
    v31.object({
      index: v31.optional(v31.undefined()),
      condition: v31.union([
        v31.tuple([v31.tuple([v31.literal("token"), v31.literal("="), v31.string()])]),
        v31.tuple([
          v31.tuple([v31.literal("token"), v31.literal("="), v31.string()]),
          v31.union([
            v31.tuple([
              v31.literal("type"),
              v31.picklist(["=", "<", "<=", ">", ">="]),
              PushNotificationReceiverTypeSchema()
            ]),
            v31.tuple([
              v31.picklist(["BEGINS_WITH"]),
              v31.literal("type"),
              PushNotificationReceiverTypeSchema()
            ]),
            v31.tuple([
              v31.literal("type"),
              v31.picklist(["BETWEEN"]),
              PushNotificationReceiverTypeSchema(),
              v31.literal("AND"),
              PushNotificationReceiverTypeSchema()
            ])
          ])
        ])
      ])
    }),
    v31.object({
      index: v31.literal("facilityKey-subscribedAt"),
      condition: v31.union([
        v31.tuple([v31.tuple([v31.literal("facilityKey"), v31.literal("="), FacilityKeySchema()])]),
        v31.tuple([
          v31.tuple([v31.literal("facilityKey"), v31.literal("="), FacilityKeySchema()]),
          v31.union([
            v31.tuple([
              v31.literal("subscribedAt"),
              v31.picklist(["=", "<", "<=", ">", ">="]),
              DateTimeSchema()
            ]),
            v31.tuple([v31.picklist(["BEGINS_WITH"]), v31.literal("subscribedAt"), DateTimeSchema()]),
            v31.tuple([
              v31.literal("subscribedAt"),
              v31.picklist(["BETWEEN"]),
              DateTimeSchema(),
              v31.literal("AND"),
              DateTimeSchema()
            ])
          ])
        ])
      ])
    })
  ]);
});
var ResidentQueryFiltersSchema = memoize(function() {
  return v31.union([
    v31.object({ bedKey: BedKeySchema() }),
    v31.object({
      facilityKey: FacilityKeySchema(),
      deleted: v31.optional(v31.union([DeletionFlagSchema(), QueryFilterSchema(DeletionFlagSchema())]))
    }),
    v31.object({
      organizationKey: OrganizationKeySchema(),
      deleted: v31.optional(v31.union([DeletionFlagSchema(), QueryFilterSchema(DeletionFlagSchema())]))
    }),
    v31.object({
      providerKey: ProviderKeySchema(),
      deleted: v31.optional(v31.union([DeletionFlagSchema(), QueryFilterSchema(DeletionFlagSchema())]))
    }),
    v31.object({ sensorKey: SensorKeySchema() }),
    v31.object({ userKey: UserKeySchema() })
  ]);
});
var ResidentArchiveQueryFiltersSchema = memoize(function() {
  return v31.union([
    v31.object({
      userKey: UserKeySchema(),
      updatedAt: v31.union([DateTimeSchema(), QueryFilterSchema(DateTimeSchema())])
    })
  ]);
});
var RoomQueryFiltersSchema = memoize(function() {
  return v31.union([
    v31.object({
      facilityKey: FacilityKeySchema(),
      deleted: v31.optional(v31.union([DeletionFlagSchema(), QueryFilterSchema(DeletionFlagSchema())]))
    }),
    v31.object({
      organizationKey: OrganizationKeySchema(),
      deleted: v31.optional(v31.union([DeletionFlagSchema(), QueryFilterSchema(DeletionFlagSchema())]))
    }),
    v31.object({ roomKey: RoomKeySchema() })
  ]);
});
var SensorQueryFiltersSchema = memoize(function() {
  return v31.union([
    v31.object({ bedKey: BedKeySchema() }),
    v31.object({
      facilityKey: FacilityKeySchema(),
      deleted: v31.optional(v31.union([DeletionFlagSchema(), QueryFilterSchema(DeletionFlagSchema())]))
    }),
    v31.object({
      organizationKey: OrganizationKeySchema(),
      deleted: v31.optional(v31.union([DeletionFlagSchema(), QueryFilterSchema(DeletionFlagSchema())]))
    }),
    v31.object({
      providerKey: ProviderKeySchema(),
      deleted: v31.optional(v31.union([DeletionFlagSchema(), QueryFilterSchema(DeletionFlagSchema())]))
    }),
    v31.object({ sensorKey: SensorKeySchema() }),
    v31.object({ uniqueString: v31.string() }),
    v31.object({ userKey: UserKeySchema() })
  ]);
});
var StatusQueryFiltersSchema = memoize(function() {
  return v31.union([
    v31.intersect([
      v31.object({ sensorKey: SensorKeySchema() }),
      v31.union([
        v31.object({
          deleted: DeletionFlagSchema(),
          transitionedAt: v31.optional(
            v31.union([DateTimeSchema(), QueryFilterSchema(DateTimeSchema())])
          )
        }),
        v31.object({ deleted: v31.optional(QueryFilterSchema(DeletionFlagSchema())) })
      ])
    ]),
    v31.object({ statusKey: StatusKeySchema() }),
    v31.intersect([
      v31.object({ userKey: UserKeySchema() }),
      v31.union([
        v31.object({
          deleted: DeletionFlagSchema(),
          transitionedAt: v31.optional(
            v31.union([DateTimeSchema(), QueryFilterSchema(DateTimeSchema())])
          )
        }),
        v31.object({ deleted: v31.optional(QueryFilterSchema(DeletionFlagSchema())) })
      ])
    ])
  ]);
});
var StatusScheduleQueryFiltersSchema = memoize(function() {
  return v31.union([
    v31.object({
      userKey: UserKeySchema(),
      scheduledAt: v31.optional(v31.union([DateTimeSchema(), QueryFilterSchema(DateTimeSchema())]))
    }),
    v31.object({
      shard: v31.number(),
      scheduledAt: v31.optional(v31.union([DateTimeSchema(), QueryFilterSchema(DateTimeSchema())]))
    })
  ]);
});
var ResourceInstanceQueryFiltersSchema = memoize(function() {
  return v31.variant("index", [
    v31.object({
      index: v31.optional(v31.undefined()),
      condition: v31.union([
        v31.tuple([v31.tuple([v31.literal("partitionKey"), v31.literal("="), v31.string()])]),
        v31.tuple([
          v31.tuple([v31.literal("partitionKey"), v31.literal("="), v31.string()]),
          v31.union([
            v31.tuple([v31.literal("sortKey"), v31.picklist(["=", "<", "<=", ">", ">="]), v31.string()]),
            v31.tuple([v31.picklist(["BEGINS_WITH"]), v31.literal("sortKey"), v31.string()]),
            v31.tuple([
              v31.literal("sortKey"),
              v31.picklist(["BETWEEN"]),
              v31.string(),
              v31.literal("AND"),
              v31.string()
            ])
          ])
        ])
      ])
    })
  ]);
});
var WatchtowerQueryFiltersSchema = memoize(function() {
  return v31.union([
    v31.object({ deleted: v31.picklist([values_exports2.DEFAULT, values_exports2.ARCHIVED]) }),
    v31.object({ watchtowerKey: v31.string() })
  ]);
});

// src/models/data-types/sensor-type/index.ts
import * as v32 from "valibot";

// src/models/data-types/sensor-type/values.ts
var values_exports7 = {};
__export(values_exports7, {
  AAMS: () => AAMS,
  ANSIEL: () => ANSIEL
});
var AAMS = "Aams";
var ANSIEL = "Ansiel";

// src/models/data-types/sensor-type/index.ts
var ALL_SENSOR_TYPES = [AAMS, ANSIEL];
var SensorTypeSchema = memoize(function() {
  return v32.picklist(ALL_SENSOR_TYPES);
});
var getSensorTypeSchema = SensorTypeSchema;

// src/models/data-types/serialized-data.ts
import { isPlainObject } from "es-toolkit";
import { Temporal as Temporal7 } from "temporal-polyfill";
function tryToParseJson(input) {
  let output;
  if (typeof input === "string") {
    try {
      output = JSON.parse(input);
    } catch {
      output = input;
    }
  } else {
    output = input;
  }
  return output;
}
__name(tryToParseJson, "tryToParseJson");
function serialize(input, mode) {
  if (input instanceof Temporal7.Duration) {
    return input.total({ unit: "milliseconds" });
  } else if (input instanceof Temporal7.PlainDate) {
    return input.toString({ calendarName: "never" }).padStart(10, " ");
  } else if (input instanceof Temporal7.PlainDateTime) {
    return input.toString({ calendarName: "never", roundingMode: "trunc", smallestUnit: "millisecond" }).padStart(23, " ");
  } else if (input instanceof Temporal7.PlainMonthDay) {
    return input.toString({ calendarName: "never" }).padStart(10, " ");
  } else if (input instanceof Temporal7.PlainTime) {
    return input.toString({ roundingMode: "trunc", smallestUnit: "millisecond" }).padStart(12, " ");
  } else if (input instanceof Temporal7.PlainYearMonth) {
    return input.toString({ calendarName: "never" }).padStart(7, " ");
  } else if (input instanceof Temporal7.ZonedDateTime) {
    return serialize(input.withTimeZone("Asia/Tokyo").toPlainDateTime());
  } else if (Array.isArray(input)) {
    return input.map(function(value) {
      return serialize(value, mode);
    });
  } else if (isPlainObject(input)) {
    return Object.entries(input).reduce(function(output, [key, value]) {
      if (value !== void 0) {
        output[key] = serialize(value, mode);
      }
      return output;
    }, {});
  } else {
    return input;
  }
}
__name(serialize, "serialize");

// src/models/data-types/simple-independence-level/index.ts
import * as v33 from "valibot";

// src/models/data-types/simple-independence-level/values.ts
var values_exports8 = {};
__export(values_exports8, {
  COMPLETE_ASSISTANCE: () => COMPLETE_ASSISTANCE,
  INDEPENDENCE: () => INDEPENDENCE,
  PARTIAL_ASSISTANCE: () => PARTIAL_ASSISTANCE
});
var COMPLETE_ASSISTANCE = 1;
var PARTIAL_ASSISTANCE = 2;
var INDEPENDENCE = 3;

// src/models/data-types/simple-independence-level/index.ts
var ALL_SIMPLE_INDEPENDENCE_LEVELS = [
  COMPLETE_ASSISTANCE,
  PARTIAL_ASSISTANCE,
  INDEPENDENCE
];
var SimpleIndependenceLevelSchema = memoize(function() {
  return v33.picklist(ALL_SIMPLE_INDEPENDENCE_LEVELS);
});
var SimpleIndependenceLevelsSchema1 = memoize(function() {
  return v33.object({
    /** 9. (I) 運動 > 移乗 > ベッド・椅子・車椅子 */
    [fim_item_values_exports.BED_CHAIR_WHEELCHAIR]: SimpleIndependenceLevelSchema(),
    /** 12. (L) 運動 > 移動 > 歩行・車椅子 */
    [fim_item_values_exports.WALK_WHEELCHAIR]: SimpleIndependenceLevelSchema(),
    /** 17. (Q) 認知 > 社会認識 > 問題解決 */
    [fim_item_values_exports.PROBLEM_SOLVING]: SimpleIndependenceLevelSchema(),
    /** 18. (R) 認知 > 社会認識 > 記憶 */
    [fim_item_values_exports.MEMORY]: SimpleIndependenceLevelSchema()
  });
});
function simplifyIndependenceLevel(independenceLevel) {
  switch (independenceLevel) {
    case values_exports3.TOTAL_ASSISTANCE:
    case values_exports3.MAXIMAL_ASSISTANCE:
      return COMPLETE_ASSISTANCE;
    case values_exports3.MODERATE_ASSISTANCE:
    case values_exports3.MINIMAL_ASSISTANCE:
      return PARTIAL_ASSISTANCE;
    case values_exports3.SUPERVISION:
    case values_exports3.MODIFIED_INDEPENDENCE:
    case values_exports3.COMPLETE_INDEPENDENCE:
      return INDEPENDENCE;
    default:
      throw new UniversalError(enumeration_exports.UNEXPECTED, {
        message: "\u81EA\u7ACB\u5EA6\u304B\u3089\u7C21\u6613\u81EA\u7ACB\u5EA6\u3078\u306E\u5909\u63DB\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002"
      });
  }
}
__name(simplifyIndependenceLevel, "simplifyIndependenceLevel");

// src/models/data-types/sex/index.ts
import * as v34 from "valibot";

// src/models/data-types/sex/values.ts
var values_exports9 = {};
__export(values_exports9, {
  FEMALE: () => FEMALE,
  MALE: () => MALE
});
var FEMALE = "Female";
var MALE = "Male";

// src/models/data-types/sex/index.ts
var ALL_SEXES = [MALE, FEMALE];
var SexSchema = memoize(function() {
  return v34.picklist(ALL_SEXES);
});
var getSexSchema = SexSchema;

// src/models/data-types/storage-object-path/index.ts
function createResidentImagePath(parameters) {
  return `residents/${parameters.userKey}/image.jpg`;
}
__name(createResidentImagePath, "createResidentImagePath");

// src/models/data-types/storage-object-type/enumeration.ts
var enumeration_exports15 = {};
__export(enumeration_exports15, {
  RESIDENT_IMAGE: () => RESIDENT_IMAGE
});
var RESIDENT_IMAGE = "ResidentImage";

// src/models/data-types/table-name/table-name-values.ts
var table_name_values_exports = {};
__export(table_name_values_exports, {
  ASSESSMENT: () => ASSESSMENT2,
  BED: () => BED2,
  CHANNEL: () => CHANNEL2,
  FACILITY: () => FACILITY2,
  FACILITY_STAFF: () => FACILITY_STAFF2,
  FALL: () => FALL2,
  FALL_RISK_ENTRY: () => FALL_RISK_ENTRY2,
  FALL_SCORE_ENTRY: () => FALL_SCORE_ENTRY2,
  GROUP: () => GROUP2,
  INDEPENDENCE_LEVEL_ENTRY: () => INDEPENDENCE_LEVEL_ENTRY2,
  INSTALLATION: () => INSTALLATION,
  MEASUREMENT: () => MEASUREMENT2,
  OPERATOR: () => OPERATOR2,
  ORGANIZATION: () => ORGANIZATION2,
  PRIVATE_DATA: () => PRIVATE_DATA,
  PROVIDER: () => PROVIDER2,
  PUBLIC_DATA: () => PUBLIC_DATA,
  PUSH_NOTIFICATION_RECEIVER: () => PUSH_NOTIFICATION_RECEIVER2,
  RESIDENT: () => RESIDENT2,
  RESIDENT_ARCHIVE: () => RESIDENT_ARCHIVE,
  RESOURCE_INSTANCE: () => RESOURCE_INSTANCE2,
  ROOM: () => ROOM2,
  SENSOR: () => SENSOR2,
  SOCKET_CLIENT: () => SOCKET_CLIENT2,
  STATUS: () => STATUS2,
  STATUS_SCHEDULE: () => STATUS_SCHEDULE2,
  UNIQUE_CONSTRAINT: () => UNIQUE_CONSTRAINT2,
  USER: () => USER2,
  WATCHTOWER: () => WATCHTOWER2
});
var ASSESSMENT2 = "assessments";
var BED2 = "beds";
var CHANNEL2 = "channels";
var FACILITY2 = "facilities";
var FACILITY_STAFF2 = "facility-staffs";
var FALL2 = "falls";
var FALL_SCORE_ENTRY2 = "fall-score-entries";
var FALL_RISK_ENTRY2 = "fall-risk-entries";
var GROUP2 = "groups";
var INSTALLATION = "installations";
var INDEPENDENCE_LEVEL_ENTRY2 = "independence-level-entries";
var MEASUREMENT2 = "measurements";
var OPERATOR2 = "operators";
var ORGANIZATION2 = "organizations";
var PRIVATE_DATA = "private-data";
var PROVIDER2 = "providers";
var PUBLIC_DATA = "public-data";
var PUSH_NOTIFICATION_RECEIVER2 = "push-notification-receivers";
var RESIDENT2 = "residents";
var RESIDENT_ARCHIVE = "resident-archives";
var RESOURCE_INSTANCE2 = "resource-instances";
var ROOM2 = "rooms";
var SENSOR2 = "sensors";
var SOCKET_CLIENT2 = "socket-clients";
var STATUS2 = "statuses";
var STATUS_SCHEDULE2 = "status-schedules";
var UNIQUE_CONSTRAINT2 = "unique-constraints";
var USER2 = "users";
var WATCHTOWER2 = "watchtowers";

// src/models/data-types/table-name/index.ts
var ALL_TABLE_NAMES = [
  ASSESSMENT2,
  BED2,
  CHANNEL2,
  FACILITY2,
  FACILITY_STAFF2,
  FALL2,
  FALL_SCORE_ENTRY2,
  FALL_RISK_ENTRY2,
  GROUP2,
  INSTALLATION,
  INDEPENDENCE_LEVEL_ENTRY2,
  MEASUREMENT2,
  OPERATOR2,
  ORGANIZATION2,
  PRIVATE_DATA,
  PROVIDER2,
  PUBLIC_DATA,
  PUSH_NOTIFICATION_RECEIVER2,
  RESIDENT2,
  RESIDENT_ARCHIVE,
  RESOURCE_INSTANCE2,
  ROOM2,
  SENSOR2,
  SOCKET_CLIENT2,
  STATUS2,
  STATUS_SCHEDULE2,
  UNIQUE_CONSTRAINT2,
  USER2,
  WATCHTOWER2
];

// src/models/data-types/text-to-speech-mode/index.ts
import * as v35 from "valibot";

// src/models/data-types/text-to-speech-mode/enumeration.ts
var enumeration_exports16 = {};
__export(enumeration_exports16, {
  RESIDENT_NAME: () => RESIDENT_NAME,
  ROOM_NAME_BED_NAME: () => ROOM_NAME_BED_NAME
});
var RESIDENT_NAME = "ResidentName";
var ROOM_NAME_BED_NAME = "RoomNameBedName";

// src/models/data-types/text-to-speech-mode/index.ts
var TextToSpeechModeSchema = memoize(function() {
  return v35.picklist([RESIDENT_NAME, ROOM_NAME_BED_NAME]);
});

// src/models/data-types/time.ts
import { Temporal as Temporal8 } from "temporal-polyfill";
import * as v36 from "valibot";
var TimeSchema = memoize(function() {
  return v36.union([
    v36.instance(Temporal8.PlainTime),
    /** ISO 8601 */
    v36.pipe(
      v36.string(),
      v36.rawTransform(function({ addIssue, dataset: { value }, NEVER }) {
        const issues = [];
        try {
          return Temporal8.PlainTime.from(value);
        } catch (error) {
          issues.push({
            expected: "ISO 8601(`Temporal.PlainTime.toString()`)",
            message: enumeration_exports.INVALID_DATA,
            received: value
          });
        }
        try {
          return Temporal8.PlainDateTime.from(value).toPlainTime();
        } catch (error) {
          issues.push({
            expected: "ISO 8601(`Temporal.PlainDateTime.toString()`)",
            message: enumeration_exports.INVALID_DATA,
            received: value
          });
        }
        try {
          return Temporal8.ZonedDateTime.from(value).toPlainTime();
        } catch (error) {
          issues.push({
            expected: "ISO 8601(`Temporal.ZonedDateTime.toString()`)",
            message: enumeration_exports.INVALID_DATA,
            received: value
          });
        }
        if (issues.length === 0) {
          issues.push({
            expected: "\u65E5\u6642\u3092\u8868\u3059\u6587\u5B57\u5217",
            message: enumeration_exports.INVALID_DATA,
            received: value
          });
        }
        for (const issue of issues) {
          addIssue(issue);
        }
        return NEVER;
      })
    ),
    /** JavaScript `Date` */
    v36.pipe(
      v36.date(),
      v36.transform(function(date4) {
        return Temporal8.PlainTime.from({
          hour: date4.getHours(),
          minute: date4.getMinutes(),
          second: date4.getSeconds(),
          millisecond: date4.getMilliseconds()
        });
      })
    ),
    v36.pipe(
      v36.union([v36.instance(Temporal8.PlainDateTime), v36.instance(Temporal8.ZonedDateTime)]),
      v36.transform(function(input) {
        return Temporal8.PlainTime.from(input);
      })
    )
  ]);
});

// src/models/data-types/time-frame/values.ts
var values_exports10 = {};
__export(values_exports10, {
  DAYTIME: () => DAYTIME,
  NIGHTTIME: () => NIGHTTIME
});
var DAYTIME_START = 6;
var NIGHTTIME_START = 21;
var DAYTIME = [DAYTIME_START, NIGHTTIME_START];
var NIGHTTIME = [NIGHTTIME_START, DAYTIME_START];

// src/models/data-types/version.ts
import * as semver from "semver";
import * as v37 from "valibot";
var VersionSchema = memoize(function() {
  return v37.custom(function(input) {
    return typeof input === "string" && semver.valid(input) !== null;
  });
});
function parseVersion(version) {
  return parse2(VersionSchema(), version);
}
__name(parseVersion, "parseVersion");

// src/models/data-types/watchtower-type/enumeration.ts
var enumeration_exports17 = {};
__export(enumeration_exports17, {
  EMAIL_ADDRESS: () => EMAIL_ADDRESS,
  SLACK_INCOMING_WEBHOOK: () => SLACK_INCOMING_WEBHOOK
});
var EMAIL_ADDRESS = "EmailAddress";
var SLACK_INCOMING_WEBHOOK = "SlackIncomingWebhook";

// src/models/data-types/watchtower-type/index.ts
var ALL_WATCHTOWER_TYPES = [
  EMAIL_ADDRESS,
  SLACK_INCOMING_WEBHOOK
];

// src/models/data-types/year-month.ts
import { Temporal as Temporal9 } from "temporal-polyfill";
import * as v38 from "valibot";
var YearMonthSchema = memoize(function() {
  return v38.union([
    v38.instance(Temporal9.PlainYearMonth),
    /** ISO 8601 */
    v38.pipe(
      v38.string(),
      v38.rawTransform(function({ addIssue, dataset: { value }, NEVER }) {
        const issues = [];
        try {
          return Temporal9.PlainYearMonth.from(value);
        } catch (error) {
          issues.push({
            expected: "ISO 8601(`Temporal.PlainYearMonth.toString()`)",
            message: enumeration_exports.INVALID_DATA,
            received: value
          });
        }
        try {
          return Temporal9.PlainYearMonth.from(Temporal9.PlainDateTime.from(value));
        } catch (error) {
          issues.push({
            expected: "ISO 8601(`Temporal.PlainDateTime.toString()`)",
            message: enumeration_exports.INVALID_DATA,
            received: value
          });
        }
        try {
          return Temporal9.PlainYearMonth.from(Temporal9.ZonedDateTime.from(value));
        } catch (error) {
          issues.push({
            expected: "ISO 8601(`Temporal.ZonedDateTime.toString()`)",
            message: enumeration_exports.INVALID_DATA,
            received: value
          });
        }
        try {
          return Temporal9.PlainYearMonth.from(
            Temporal9.Instant.from(value).toZonedDateTimeISO("Asia/Tokyo")
          );
        } catch (error) {
          issues.push({
            expected: "ISO 8601(`Temporal.Instant.toISOString()`)`)",
            message: enumeration_exports.INVALID_DATA,
            received: value
          });
        }
        if (issues.length === 0) {
          issues.push({
            expected: "\u65E5\u6642\u3092\u8868\u3059\u6587\u5B57\u5217",
            message: enumeration_exports.INVALID_DATA,
            received: value
          });
        }
        for (const issue of issues) {
          addIssue(issue);
        }
        return NEVER;
      })
    ),
    /** UNIX時間(エポックミリ秒) */
    v38.pipe(
      v38.number(),
      v38.transform(function(n) {
        return Temporal9.PlainYearMonth.from(
          Temporal9.Instant.fromEpochMilliseconds(n).toZonedDateTimeISO("Asia/Tokyo")
        );
      })
    ),
    /** JavaScript `Date` */
    v38.pipe(
      v38.date(),
      v38.transform(function(date4) {
        return Temporal9.PlainYearMonth.from(
          Temporal9.Instant.fromEpochMilliseconds(date4.getTime()).toZonedDateTimeISO("Asia/Tokyo")
        );
      })
    ),
    v38.pipe(
      v38.union([
        v38.instance(Temporal9.PlainDate),
        v38.instance(Temporal9.PlainDateTime),
        v38.instance(Temporal9.ZonedDateTime)
      ]),
      v38.transform(function(input) {
        return Temporal9.PlainYearMonth.from(input);
      })
    )
  ]);
});

// src/models/entities/apple-developer-key.ts
import { memoize as memoize2 } from "es-toolkit";
import * as v39 from "valibot";
function AppleDeveloperKeyKeyChainSchema() {
  return v39.object({
    /** パーティションキー */
    partitionKey: EntityClassSchema(entity_class_values_exports.APPLE_DEVELOPER_KEY),
    /** ソートキー */
    sortKey: v39.optional(v39.literal(" "), " ")
  });
}
__name(AppleDeveloperKeyKeyChainSchema, "AppleDeveloperKeyKeyChainSchema");
function Schema1() {
  return v39.object({
    /** エンティティクラス */
    class: EntityClassSchema(entity_class_values_exports.APPLE_DEVELOPER_KEY),
    /** 作成日時 */
    createdAt: CreationDateTimeSchema(),
    /** `AuthKey_${keyId}.p8`ファイルの内容 */
    data: v39.pipe(
      v39.string(),
      v39.startsWith("-----BEGIN PRIVATE KEY-----"),
      v39.endsWith("-----END PRIVATE KEY-----")
    ),
    /** Key ID */
    keyId: v39.pipe(v39.string(), v39.graphemes(10)),
    /** Team ID */
    teamId: v39.pipe(v39.string(), v39.graphemes(10)),
    /** APNsのトピックID */
    topicId: v39.pipe(v39.string(), v39.nonEmpty()),
    /** 更新日時 */
    updatedAt: UpdateDateTimeSchema()
  });
}
__name(Schema1, "Schema1");
var AppleDeveloperKeySchema = memoize2(function() {
  return v39.intersect([AppleDeveloperKeyKeyChainSchema(), Schema1()]);
});
function parseAppleDeveloperKey(appleDeveloperKey) {
  return v39.parse(AppleDeveloperKeySchema(), appleDeveloperKey);
}
__name(parseAppleDeveloperKey, "parseAppleDeveloperKey");

// src/models/entities/application-configuration.ts
import * as v40 from "valibot";
function ApplicationConfigurationKeyChainSchema() {
  return v40.object({
    /** パーティションキー */
    partitionKey: EntityClassSchema(entity_class_values_exports.APPLICATION_CONFIGURATION),
    /** ソートキー */
    sortKey: v40.optional(v40.literal(" "), " ")
  });
}
__name(ApplicationConfigurationKeyChainSchema, "ApplicationConfigurationKeyChainSchema");
function Schema12() {
  return v40.object({
    /** エンティティクラス */
    class: EntityClassSchema(entity_class_values_exports.APPLICATION_CONFIGURATION),
    /** 作成日時 */
    createdAt: CreationDateTimeSchema(),
    /** メンテナンスモードが有効である場合、`true` */
    maintenance: v40.boolean(),
    /** メンテナンス期間 */
    maintenancePeriod: v40.optional(v40.tuple([DateTimeSchema(), v40.nullable(DateTimeSchema())])),
    /** 必須のAndroid版 */
    android: v40.optional(
      v40.object({
        requiredRevision: v40.pipe(v40.number(), v40.safeInteger(), v40.minValue(0))
      })
    ),
    /** 必須バージョン */
    requiredVersion: VersionSchema(),
    ios: v40.optional(
      v40.object({
        requiredRevision: v40.pipe(v40.number(), v40.safeInteger(), v40.minValue(0))
      })
    ),
    /** 更新日時 */
    updatedAt: UpdateDateTimeSchema()
  });
}
__name(Schema12, "Schema1");
var ApplicationConfigurationSchema = memoize(function() {
  return v40.intersect([ApplicationConfigurationKeyChainSchema(), Schema12()]);
});
function parseApplicationConfiguration(applicationConfiguration) {
  return v40.parse(ApplicationConfigurationSchema(), applicationConfiguration);
}
__name(parseApplicationConfiguration, "parseApplicationConfiguration");
var PartialApplicationConfigurationSchema = memoize(function() {
  return v40.pipe(
    v40.tuple([ApplicationConfigurationKeyChainSchema(), v40.partial(Schema12())]),
    v40.transform(function([a, b, ..._]) {
      _;
      return { ...a, ...b };
    })
  );
});
function parsePartialApplicationConfiguration(applicationConfiguration) {
  return v40.parse(PartialApplicationConfigurationSchema(), applicationConfiguration);
}
__name(parsePartialApplicationConfiguration, "parsePartialApplicationConfiguration");

// src/models/entities/bed.ts
import * as v42 from "valibot";

// src/models/entities/group.ts
import { Temporal as Temporal10 } from "temporal-polyfill";
import * as v41 from "valibot";
var GroupKeySchema = memoize(function() {
  return v41.custom(function(value) {
    return typeof value === "string" && /^g[0-9A-Za-z]{10}$/.test(value);
  });
});
function isGroupKey(groupKey) {
  return v41.is(GroupKeySchema(), groupKey);
}
__name(isGroupKey, "isGroupKey");
function generateGroupKey(dateTime, randomString) {
  dateTime ??= Temporal10.Now.plainDateTimeISO(DEFAULT_TIME_ZONE);
  randomString ??= generateRandomString(1);
  return parse2(
    GroupKeySchema(),
    "g" + toDateTimeString(dateTime, "millisecond") + randomString
  );
}
__name(generateGroupKey, "generateGroupKey");
var GroupKeyChainSchema = memoize(function() {
  return v41.object({
    /** グループキー */
    groupKey: GroupKeySchema()
  });
});
function Schema13() {
  return v41.object({
    /** エンティティクラス */
    class: EntityClassSchema(entity_class_values_exports.GROUP),
    /** 作成日時 */
    createdAt: CreationDateTimeSchema(),
    /** 削除フラグ */
    deleted: v41.optional(
      v41.picklist([values_exports2.DEFAULT, values_exports2.ARCHIVED]),
      values_exports2.DEFAULT
    ),
    /** 削除日時(削除されている場合) */
    deletedAt: DeletionDateTimeSchema(),
    /** **施設キー** このグループを所有する施設の識別子。 */
    facilityKey: FacilityKeySchema(),
    /** **名前** グループの名前。 */
    name: v41.pipe(v41.string(), v41.minLength(1), v41.maxGraphemes(128)),
    /** 更新日時 */
    updatedAt: UpdateDateTimeSchema()
  });
}
__name(Schema13, "Schema1");
var GroupSchema = memoize(function() {
  return v41.intersect([GroupKeyChainSchema(), Schema13()]);
});
function parseGroup(group, options) {
  return parse2(GroupSchema(), group, options);
}
__name(parseGroup, "parseGroup");
var PartialGroupSchema = memoize(function() {
  return v41.pipe(
    v41.tuple([GroupKeyChainSchema(), v41.optional(v41.partial(Schema13()))]),
    v41.transform(function([a, b, ..._]) {
      _;
      return { ...a, ...b };
    })
  );
});
function parsePartialGroup(partialGroup, options) {
  return parse2(PartialGroupSchema(), partialGroup, options);
}
__name(parsePartialGroup, "parsePartialGroup");
var GroupQuerySchema = memoize(function() {
  const group = GroupSchema();
  const { groupKey } = group.options[0].entries;
  const { deleted, facilityKey } = group.options[1].entries;
  const deletedConditionSchema = v41.tuple([
    v41.literal("deleted"),
    v41.picklist(["=", "<", "<=", ">", ">="]),
    deleted
  ]);
  const facilityKeyConditionSchema = v41.tuple([
    v41.literal("facilityKey"),
    v41.literal("="),
    facilityKey
  ]);
  const groupKeyConditionSchema = v41.tuple([v41.literal("groupKey"), v41.literal("="), groupKey]);
  return v41.intersect([
    v41.object({
      descendingOrder: v41.optional(v41.boolean()),
      limit: v41.optional(LimitSchema()),
      nextPageToken: v41.optional(NextPageTokenSchema())
    }),
    v41.variant("index", [
      v41.object({
        index: v41.literal("facilityKey-deleted"),
        condition: v41.union([
          v41.strictTuple([facilityKeyConditionSchema]),
          v41.tuple([facilityKeyConditionSchema, deletedConditionSchema])
        ])
      }),
      v41.object({
        index: v41.optional(v41.undefined()),
        /** 省略した場合、QueryではなくScanが行われる。 */
        condition: v41.optional(v41.tuple([groupKeyConditionSchema]))
      })
    ])
  ]);
});

// src/models/entities/bed.ts
function BedKeyChainSchema() {
  return v42.object({
    /** ベッドキー */
    bedKey: BedKeySchema()
  });
}
__name(BedKeyChainSchema, "BedKeyChainSchema");
function getSchemaB() {
  return v42.object({
    /** ベッド名 */
    bedName: v42.pipe(v42.string(), v42.maxGraphemes(32)),
    /** ベッド発音 */
    bedPronunciation: v42.pipe(v42.string(), v42.maxGraphemes(64)),
    /** エンティティクラス */
    class: EntityClassSchema(entity_class_values_exports.BED),
    /** 作成日時 */
    createdAt: CreationDateTimeSchema(),
    /** 削除フラグ */
    deleted: DefaultDeletionFlagSchema(),
    /** 削除日時 */
    deletedAt: DeletionDateTimeSchema(),
    /** ダミーフラグ */
    dummy: v42.optional(v42.boolean()),
    /** 施設キー */
    facilityKey: FacilityKeySchema(),
    /** **グループキー** このベッドが所属するグループの識別子。 */
    groupKey: GroupKeySchema(),
    /** 旧Reha3.0から新Reha3.0に移行したかどうかのフラグ */
    migrated: v42.optional(v42.boolean()),
    /** 旧Reha3.0から新Reha3.0に移行した日時 */
    migratedAt: MigrationDateTimeSchema(),
    /** 移行元のデータベースのホスト名 */
    migratedFrom: v42.optional(v42.string()),
    /** 名前 */
    name: v42.pipe(v42.string(), v42.maxGraphemes(64)),
    /** 居室名 */
    roomName: v42.pipe(v42.string(), v42.minLength(1), v42.maxGraphemes(32)),
    /** 居室発音 */
    roomPronunciation: v42.pipe(v42.string(), v42.maxGraphemes(64)),
    /** センサーキー */
    sensorKey: v42.optional(SensorKeySchema()),
    /** 更新日時 */
    updatedAt: UpdateDateTimeSchema(),
    /** ユーザーキー(入居者の識別子) */
    userKey: v42.optional(UserKeySchema())
  });
}
__name(getSchemaB, "getSchemaB");
var BedSchema = memoize(function() {
  return v42.intersect([BedKeyChainSchema(), getSchemaB()]);
});
var getBedSchema = BedSchema;
var PartialBedSchema = memoize(function() {
  return v42.pipe(
    v42.tuple([BedKeyChainSchema(), v42.partial(getSchemaB())]),
    v42.transform(function([a, b, ..._]) {
      _;
      return { ...a, ...b };
    })
  );
});
var getPartialBedSchema = PartialBedSchema;
function parseBed(bed, options) {
  return parse2(BedSchema(), bed, options);
}
__name(parseBed, "parseBed");
function parsePartialBed(bed, options) {
  return parse2(PartialBedSchema(), bed, options);
}
__name(parsePartialBed, "parsePartialBed");
var BedQuerySchema = memoize(function() {
  const bed = BedSchema();
  const { bedKey } = bed.options[0].entries;
  const { deleted, facilityKey, groupKey, sensorKey, userKey } = bed.options[1].entries;
  const bedKeyConditionSchema = v42.tuple([v42.literal("bedKey"), v42.literal("="), bedKey]);
  const deletedConditionSchema = v42.tuple([
    v42.literal("deleted"),
    v42.picklist(["=", "<", "<=", ">", ">="]),
    deleted
  ]);
  const facilityKeyConditionSchema = v42.tuple([
    v42.literal("facilityKey"),
    v42.literal("="),
    facilityKey
  ]);
  const groupKeyConditionSchema = v42.tuple([v42.literal("groupKey"), v42.literal("="), groupKey]);
  const sensorKeyConditionSchema = v42.tuple([
    v42.literal("sensorKey"),
    v42.literal("="),
    v42.nonNullable(v42.unwrap(sensorKey))
    // TODO: `sensorKey`から`null`を取り除いたら`nonNullable()`を外す。
  ]);
  const userKeyConditionSchema = v42.tuple([
    v42.literal("userKey"),
    v42.literal("="),
    v42.nonNullable(v42.unwrap(userKey))
    // TODO: `userKey`から`null`を取り除いたら`nonNullable()`を外す。
  ]);
  return v42.intersect([
    v42.object({
      descendingOrder: v42.optional(v42.boolean()),
      limit: v42.optional(LimitSchema()),
      nextPageToken: v42.optional(NextPageTokenSchema())
    }),
    v42.variant("index", [
      v42.object({
        index: v42.literal("facilityKey-deleted-gsi"),
        condition: v42.union([
          v42.strictTuple([facilityKeyConditionSchema]),
          v42.tuple([facilityKeyConditionSchema, deletedConditionSchema])
        ])
      }),
      v42.object({
        index: v42.literal("groupKey-deleted"),
        condition: v42.union([
          v42.strictTuple([groupKeyConditionSchema]),
          v42.tuple([groupKeyConditionSchema, deletedConditionSchema])
        ])
      }),
      v42.object({
        index: v42.literal("sensorKey-gsi"),
        condition: v42.tuple([sensorKeyConditionSchema])
      }),
      v42.object({
        index: v42.literal("userKey-gsi"),
        condition: v42.tuple([userKeyConditionSchema])
      }),
      v42.object({
        index: v42.optional(v42.undefined()),
        /** 省略した場合、QueryではなくScanが行われる。 */
        condition: v42.optional(v42.tuple([bedKeyConditionSchema]))
      })
    ])
  ]);
});

// src/models/entities/facility.ts
import * as v43 from "valibot";
var FacilityKeyChainSchema = memoize(function() {
  return v43.object({
    /** **施設キー** (Cognitoユーザーの`username`属性) */
    facilityKey: FacilityKeySchema()
  });
});
function Schema14() {
  return v43.object({
    /** 住所 */
    address: v43.pipe(v43.string(), v43.minLength(1), v43.maxGraphemes(256)),
    /** エンティティクラス */
    class: EntityClassSchema(entity_class_values_exports.FACILITY),
    /** 作成日時 */
    createdAt: CreationDateTimeSchema(),
    /** 削除フラグ */
    deleted: DefaultDeletionFlagSchema(),
    /** 削除日時 */
    deletedAt: DeletionDateTimeSchema(),
    /** ダミーフラグ */
    dummy: v43.optional(v43.boolean()),
    /** **メールアドレス** (Cognitoユーザーの`email`属性) */
    emailAddress: v43.nullable(getEmailAddressSchema()),
    /** メールアドレスログインフラグ */
    emailAddressLogin: v43.boolean(),
    /** **グループキー** 施設のデフォルトグループの識別子。 */
    groupKey: GroupKeySchema(),
    /** 一度でもログインした場合に`true`になるフラグ */
    loggedIn: v43.boolean(),
    /** 旧Reha3.0から新Reha3.0に移行したかどうかのフラグ */
    migrated: v43.optional(v43.boolean()),
    /** 旧Reha3.0から新Reha3.0に移行した日時 */
    migratedAt: MigrationDateTimeSchema(),
    /** 移行元のデータベースのホスト名 */
    migratedFrom: v43.optional(v43.string()),
    /** **名前(組織名・法人名)** (Cognitoユーザーの`name`属性) */
    name: v43.pipe(v43.string(), v43.trim(), v43.maxGraphemes(32)),
    /** 組織キー */
    organizationKey: OrganizationKeySchema(),
    /** **`+`から始まる電話番号** (Cognitoユーザーの`phone_number`属性) */
    phoneNumber: getPhoneNumberSchema(),
    /** 電話番号ログインフラグ */
    phoneNumberLogin: v43.boolean(),
    /** 郵便番号 */
    postalCode: getPostalCodeSchema(),
    /** 備考 */
    remark: v43.pipe(v43.string(), v43.maxGraphemes(1024)),
    /** 責任者名 */
    representativeName: v43.pipe(v43.string(), v43.maxGraphemes(32)),
    /** Text-to-Speechモード */
    textToSpeechMode: v43.optional(TextToSpeechModeSchema()),
    // TODO: 浸透したら必須化する。
    /** 更新日時 */
    updatedAt: UpdateDateTimeSchema()
  });
}
__name(Schema14, "Schema1");
var FacilitySchema = memoize(function() {
  return v43.intersect([FacilityKeyChainSchema(), Schema14()]);
});
function parseFacility(facility, options) {
  return parse2(FacilitySchema(), facility, options);
}
__name(parseFacility, "parseFacility");
var PartialFacilitySchema = memoize(function() {
  return v43.pipe(
    v43.tuple([FacilityKeyChainSchema(), v43.optional(v43.partial(Schema14()))]),
    v43.transform(function([a, b, ..._]) {
      _;
      return { ...a, ...b };
    })
  );
});
function parsePartialFacility(facility, options) {
  return parse2(PartialFacilitySchema(), facility, options);
}
__name(parsePartialFacility, "parsePartialFacility");
var FacilityQuerySchema = memoize(function() {
  const facility = FacilitySchema();
  const { facilityKey } = facility.options[0].entries;
  const { deleted, organizationKey } = facility.options[1].entries;
  const deletedConditionSchema = v43.tuple([
    v43.literal("deleted"),
    v43.picklist(["=", "<", "<=", ">", ">="]),
    deleted
  ]);
  const facilityKeyConditionSchema = v43.tuple([
    v43.literal("facilityKey"),
    v43.literal("="),
    facilityKey
  ]);
  const organizationKeyConditionSchema = v43.tuple([
    v43.literal("organizationKey"),
    v43.literal("="),
    organizationKey
  ]);
  return v43.intersect([
    v43.object({
      descendingOrder: v43.optional(v43.boolean()),
      limit: v43.optional(LimitSchema()),
      nextPageToken: v43.optional(NextPageTokenSchema())
    }),
    v43.variant("index", [
      v43.object({
        index: v43.literal("organizationKey-deleted-gsi"),
        condition: v43.union([
          v43.strictTuple([organizationKeyConditionSchema]),
          v43.tuple([organizationKeyConditionSchema, deletedConditionSchema])
        ])
      }),
      v43.object({
        index: v43.optional(v43.undefined()),
        /** 省略した場合、QueryではなくScanが行われる。 */
        condition: v43.optional(
          v43.union([
            v43.strictTuple([facilityKeyConditionSchema]),
            v43.tuple([facilityKeyConditionSchema, deletedConditionSchema])
          ])
        )
      })
    ])
  ]);
});

// src/models/entities/facility-staff.ts
import * as v44 from "valibot";
function FacilityStaffKeyChain() {
  return v44.object({
    /** 施設キー  */
    facilityKey: FacilityKeySchema(),
    /** ユーザーキー */
    userKey: UserKeySchema()
  });
}
__name(FacilityStaffKeyChain, "FacilityStaffKeyChain");
function getSchemaB2() {
  return v44.object({
    /** エンティティクラス */
    class: EntityClassSchema(entity_class_values_exports.FACILITY_STAFF),
    /** 作成日時 */
    createdAt: CreationDateTimeSchema(),
    /**
     * **削除フラグ**
     * このエンティティは大量に存在する可能性が高いため、
     * 親エンティティの削除時に削除フラグを変更しない。
     */
    deleted: DefaultDeletionFlagSchema(),
    /** 削除日時 */
    deletedAt: DeletionDateTimeSchema(),
    /**
     *  **組織・施設管理フラグ**
     * 施設がユーザーそのものを管理可能な場合、`true`。
     * `true`の場合、施設に権限を持つユーザーがこのエンティティを介して
     * 対象ユーザーのログイン情報の変更が可能。
     */
    managed: v44.optional(v44.boolean()),
    /** 旧Reha3.0から新Reha3.0に移行したかどうかのフラグ */
    migrated: v44.optional(v44.boolean()),
    /** 旧Reha3.0から新Reha3.0に移行した日時 */
    migratedAt: MigrationDateTimeSchema(),
    /** 移行元のデータベースのホスト名 */
    migratedFrom: v44.optional(v44.string()),
    /** 名前 */
    name: v44.string(),
    /** 組織キー */
    organizationKey: OrganizationKeySchema(),
    /** パーミッション */
    permissions: v44.array(v44.string()),
    /** ロール */
    roles: v44.array(FacilityStaffRoleSchema()),
    /** ティア */
    tier: FacilityStaffTierSchema(),
    /** 更新日時 */
    updatedAt: UpdateDateTimeSchema()
  });
}
__name(getSchemaB2, "getSchemaB");
var FacilityStaffSchema = memoize(function() {
  return v44.intersect([FacilityStaffKeyChain(), getSchemaB2()]);
});
function parseFacilityStaff(fall, options) {
  try {
    return v44.parse(FacilityStaffSchema(), fall);
  } catch (error) {
    throw toUniversalError(error, options);
  }
}
__name(parseFacilityStaff, "parseFacilityStaff");
var PartialFacilityStaffSchema = memoize(function() {
  return v44.pipe(
    v44.tuple([FacilityStaffKeyChain(), v44.partial(getSchemaB2())]),
    v44.transform(function([a, b, ..._]) {
      _;
      return { ...a, ...b };
    })
  );
});
function parsePartialFacilityStaff(fall, options) {
  try {
    return v44.parse(PartialFacilityStaffSchema(), fall);
  } catch (error) {
    throw toUniversalError(error, options);
  }
}
__name(parsePartialFacilityStaff, "parsePartialFacilityStaff");

// src/models/entities/fall.ts
import * as v45 from "valibot";
function FallKeyChain() {
  return v45.object({
    /** 転倒データキー  */
    fallKey: FallKeySchema()
  });
}
__name(FallKeyChain, "FallKeyChain");
function getSchemaB3() {
  return v45.object({
    /** エンティティクラス */
    class: EntityClassSchema(entity_class_values_exports.FALL),
    /** 作成日時 */
    createdAt: CreationDateTimeSchema(),
    /**
     * **削除フラグ**
     * このエンティティは大量に存在する可能性が高いため、
     * 親エンティティの削除時に削除フラグを変更しない。
     */
    deleted: DefaultNoncascadeDeletionFlagSchema(),
    /** 削除日時 */
    deletedAt: DeletionDateTimeSchema(),
    /** 転倒日時 */
    fellAt: DateTimeSchema(),
    /** 旧Reha3.0から新Reha3.0に移行したかどうかのフラグ */
    migrated: v45.optional(v45.boolean()),
    /** 旧Reha3.0から新Reha3.0に移行した日時 */
    migratedAt: MigrationDateTimeSchema(),
    /** 移行元のデータベースのホスト名 */
    migratedFrom: v45.optional(v45.string()),
    /** 登録者の識別子 */
    registeredBy: v45.union([FacilityKeySchema(), OrganizationKeySchema(), UserKeySchema()]),
    /** 更新日時 */
    updatedAt: UpdateDateTimeSchema(),
    /** **ユーザーキー** 入居者の識別子。 */
    userKey: UserKeySchema()
  });
}
__name(getSchemaB3, "getSchemaB");
var FallSchema = memoize(function() {
  return v45.intersect([FallKeyChain(), getSchemaB3()]);
});
function parseFall(fall, options) {
  try {
    return v45.parse(FallSchema(), fall);
  } catch (error) {
    throw toUniversalError(error, options);
  }
}
__name(parseFall, "parseFall");
var PartialFallSchema = memoize(function() {
  return v45.pipe(
    v45.tuple([FallKeyChain(), v45.partial(getSchemaB3())]),
    v45.transform(function([a, b, ..._]) {
      _;
      return { ...a, ...b };
    })
  );
});
function parsePartialFall(fall, options) {
  try {
    return v45.parse(PartialFallSchema(), fall);
  } catch (error) {
    throw toUniversalError(error, options);
  }
}
__name(parsePartialFall, "parsePartialFall");

// src/models/entities/fall-risk-entry.ts
import * as v46 from "valibot";
var FallRiskEntryKeyChainSchema = memoize(function() {
  return v46.object({
    /** ユーザーキー */
    userKey: UserKeySchema(),
    /** 評価日時 */
    assessedAt: DateTimeSchema()
  });
});
function Schema15() {
  return v46.object({
    /** エンティティクラス */
    class: EntityClassSchema(entity_class_values_exports.FALL_RISK_ENTRY),
    /** 作成日時 */
    createdAt: CreationDateTimeSchema(),
    /** ダミーフラグ */
    dummy: v46.optional(v46.boolean()),
    /** 施設キー */
    facilityKey: FacilityKeySchema(),
    /** 転倒リスク */
    fallRisk: FallRiskSchema(),
    /** グループキー */
    groupKey: GroupKeySchema(),
    /** 旧Reha3.0から新Reha3.0に移行したかどうかのフラグ */
    migrated: v46.optional(v46.boolean()),
    /** 旧Reha3.0から新Reha3.0に移行した日時 */
    migratedAt: MigrationDateTimeSchema(),
    /** 移行元のデータベースのホスト名 */
    migratedFrom: v46.optional(v46.string()),
    /** 転倒リスクタイプ */
    type: v46.optional(v46.literal("Estimated"), "Estimated"),
    // 将来的な拡張に備えて。
    /** 更新日時 */
    updatedAt: UpdateDateTimeSchema()
  });
}
__name(Schema15, "Schema1");
var FallRiskEntrySchema = memoize(function() {
  return v46.intersect([FallRiskEntryKeyChainSchema(), Schema15()]);
});
function parseFallRiskEntry(fallRiskEntry) {
  return v46.parse(FallRiskEntrySchema(), fallRiskEntry);
}
__name(parseFallRiskEntry, "parseFallRiskEntry");
var FallRiskEntryQuerySchema = memoize(function() {
  const fallRiskEntry = FallRiskEntrySchema();
  const { assessedAt, userKey } = fallRiskEntry.options[0].entries;
  const assessedAtConditionSchema = v46.union([
    v46.tuple([v46.literal("assessedAt"), v46.picklist(["=", "<", "<=", ">", ">="]), assessedAt]),
    v46.tuple([v46.picklist(["BEGINS_WITH"]), v46.literal("assessedAt"), assessedAt]),
    v46.tuple([
      v46.literal("assessedAt"),
      v46.picklist(["BETWEEN"]),
      assessedAt,
      v46.literal("AND"),
      assessedAt
    ])
  ]);
  const userKeyConditionSchema = v46.tuple([v46.literal("userKey"), v46.literal("="), userKey]);
  return v46.intersect([
    v46.object({
      descendingOrder: v46.optional(v46.boolean()),
      limit: v46.optional(LimitSchema()),
      nextPageToken: v46.optional(NextPageTokenSchema())
    }),
    v46.variant("index", [
      v46.object({
        index: v46.optional(v46.undefined()),
        /** 省略した場合、QueryではなくScanが行われる。 */
        condition: v46.optional(
          v46.union([
            v46.strictTuple([userKeyConditionSchema]),
            v46.tuple([userKeyConditionSchema, assessedAtConditionSchema])
          ])
        )
      })
    ])
  ]);
});

// src/models/entities/fall-score-entry.ts
import * as v47 from "valibot";
var FallScoreEntryKeyChainSchema = memoize(function() {
  return v47.object({
    /** ユーザーキー */
    userKey: UserKeySchema(),
    /** 評価日時 */
    assessedAt: DateTimeSchema()
  });
});
function Schema16() {
  return v47.object({
    /** エンティティクラス */
    class: EntityClassSchema(entity_class_values_exports.FALL_SCORE_ENTRY),
    /** 作成日時 */
    createdAt: CreationDateTimeSchema(),
    /** ダミーフラグ */
    dummy: v47.optional(v47.boolean()),
    /** 転倒スコア */
    fallScore: FallScoreSchema(),
    /** 旧Reha3.0から新Reha3.0に移行したかどうかのフラグ */
    migrated: v47.optional(v47.boolean()),
    /** 旧Reha3.0から新Reha3.0に移行した日時 */
    migratedAt: MigrationDateTimeSchema(),
    /** 移行元のデータベースのホスト名 */
    migratedFrom: v47.optional(v47.string()),
    /** 転倒スコアタイプ */
    type: v47.optional(v47.literal("Estimated"), "Estimated"),
    // 将来的な拡張に備えて。
    /** 更新日時 */
    updatedAt: UpdateDateTimeSchema()
  });
}
__name(Schema16, "Schema1");
var FallScoreEntrySchema = memoize(function() {
  return v47.intersect([FallScoreEntryKeyChainSchema(), Schema16()]);
});
function parseFallScoreEntry(fallScoreEntry) {
  return v47.parse(FallScoreEntrySchema(), fallScoreEntry);
}
__name(parseFallScoreEntry, "parseFallScoreEntry");
var FallScoreEntryQuerySchema = memoize(function() {
  const fallScoreEntry = FallScoreEntrySchema();
  const { assessedAt, userKey } = fallScoreEntry.options[0].entries;
  const assessedAtConditionSchema = v47.union([
    v47.tuple([v47.literal("assessedAt"), v47.picklist(["=", "<", "<=", ">", ">="]), assessedAt]),
    v47.tuple([v47.picklist(["BEGINS_WITH"]), v47.literal("assessedAt"), assessedAt]),
    v47.tuple([
      v47.literal("assessedAt"),
      v47.picklist(["BETWEEN"]),
      assessedAt,
      v47.literal("AND"),
      assessedAt
    ])
  ]);
  const userKeyConditionSchema = v47.tuple([v47.literal("userKey"), v47.literal("="), userKey]);
  return v47.intersect([
    v47.object({
      descendingOrder: v47.optional(v47.boolean()),
      limit: v47.optional(LimitSchema()),
      nextPageToken: v47.optional(NextPageTokenSchema())
    }),
    v47.variant("index", [
      v47.object({
        index: v47.optional(v47.undefined()),
        /** 省略した場合、QueryではなくScanが行われる。 */
        condition: v47.optional(
          v47.union([
            v47.strictTuple([userKeyConditionSchema]),
            v47.tuple([userKeyConditionSchema, assessedAtConditionSchema])
          ])
        )
      })
    ])
  ]);
});

// src/models/entities/google-cloud-service-account.ts
import { memoize as memoize3 } from "es-toolkit";
import * as v48 from "valibot";
function GoogleCloudServiceAccountKeyChainSchema() {
  return v48.object({
    /** パーティションキー */
    partitionKey: EntityClassSchema(entity_class_values_exports.GOOGLE_CLOUD_SERVICE_ACCOUNT),
    /** ソートキー */
    sortKey: v48.optional(v48.literal(" "), " ")
  });
}
__name(GoogleCloudServiceAccountKeyChainSchema, "GoogleCloudServiceAccountKeyChainSchema");
function SchemaB() {
  return v48.object({
    /** エンティティクラス */
    class: EntityClassSchema(entity_class_values_exports.GOOGLE_CLOUD_SERVICE_ACCOUNT),
    /** 作成日時 */
    createdAt: CreationDateTimeSchema(),
    /** JSONファイルの内容 */
    data: v48.object({
      type: v48.string(),
      project_id: v48.string(),
      private_key_id: v48.string(),
      private_key: v48.string(),
      client_email: v48.string(),
      client_id: v48.string(),
      auth_uri: v48.string(),
      token_uri: v48.string(),
      auth_provider_x509_cert_url: v48.string(),
      client_x509_cert_url: v48.string(),
      universe_domain: v48.string()
    }),
    /** 更新日時 */
    updatedAt: UpdateDateTimeSchema()
  });
}
__name(SchemaB, "SchemaB");
var GoogleCloudServiceAccountSchema = memoize3(function() {
  return v48.intersect([GoogleCloudServiceAccountKeyChainSchema(), SchemaB()]);
});
var PartialGoogleCloudServiceAccountSchema = memoize3(function() {
  return v48.pipe(
    v48.tuple([GoogleCloudServiceAccountKeyChainSchema(), v48.partial(SchemaB())]),
    v48.transform(function([a, b, ..._]) {
      _;
      return { ...a, ...b };
    })
  );
});
function parseGoogleCloudServiceAccount(googleCloudServiceAccount, options) {
  return parse2(GoogleCloudServiceAccountSchema(), googleCloudServiceAccount, options);
}
__name(parseGoogleCloudServiceAccount, "parseGoogleCloudServiceAccount");
function parsePartialGoogleCloudServiceAccount(partialGoogleCloudServiceAccount, options) {
  return parse2(PartialGoogleCloudServiceAccountSchema(), partialGoogleCloudServiceAccount, options);
}
__name(parsePartialGoogleCloudServiceAccount, "parsePartialGoogleCloudServiceAccount");

// src/models/entities/installation.ts
import * as v49 from "valibot";
var InstallationKeyChainSchema = memoize(function() {
  return v49.object({
    /** エディション(ソートキー) */
    edition: v49.picklist(["Android", "Ios"]),
    /** インストール情報識別子(パーティションキー) */
    identifier: v49.string()
  });
});
var NUMBER_OF_INSTALLATION_SHARDS = 20;
function Schema17() {
  return v49.object({
    /** エンティティクラス */
    class: v49.optional(v49.literal("Installation"), "Installation"),
    /** 作成日時 */
    createdAt: CreationDateTimeSchema(),
    /** 削除フラグ */
    deleted: v49.optional(
      v49.picklist([values_exports2.DEFAULT, values_exports2.ARCHIVED]),
      values_exports2.DEFAULT
    ),
    /** 削除日時(削除されている場合) */
    deletedAt: DeletionDateTimeSchema(),
    /** **施設キー** このグループを所有する施設の識別子。 */
    facilityKey: v49.optional(FacilityKeySchema()),
    /** リビジョン */
    revision: v49.pipe(v49.number(), v49.safeInteger(), v49.minValue(0)),
    /** **シャード** セカンダリインデックスの負荷を分散するためのシャード。 */
    shard: v49.optional(
      v49.pipe(v49.number(), v49.safeInteger(), v49.minValue(0), v49.ltValue(NUMBER_OF_INSTALLATION_SHARDS)),
      function() {
        return Math.floor(NUMBER_OF_INSTALLATION_SHARDS * Math.random());
      }
    ),
    /** 更新日時 */
    updatedAt: UpdateDateTimeSchema(),
    /** **ユーザー名** ログインしているユーザーの識別子。 */
    username: v49.optional(UsernameSchema()),
    /** バージョン */
    version: VersionSchema()
  });
}
__name(Schema17, "Schema1");
var InstallationSchema = memoize(function() {
  return v49.intersect([InstallationKeyChainSchema(), Schema17()]);
});
var PartialInstallationSchema = memoize(function() {
  return v49.pipe(
    v49.tuple([InstallationKeyChainSchema(), v49.optional(v49.partial(Schema17()))]),
    v49.transform(function([a, b, ..._]) {
      _;
      return { ...a, ...b };
    })
  );
});
var InstallationQuerySchema = memoize(function() {
  const installation = InstallationSchema();
  const { edition, identifier } = installation.options[0].entries;
  const { deleted, facilityKey, shard, updatedAt } = installation.options[1].entries;
  const deletedConditionSchema = v49.tuple([
    v49.literal("deleted"),
    v49.picklist(["=", "<", "<=", ">", ">="]),
    deleted
  ]);
  const editionConditionSchema = v49.tuple([
    v49.literal("edition"),
    v49.picklist(["=", "<", "<=", ">", ">="]),
    edition
  ]);
  const facilityKeyConditionSchema = v49.tuple([
    v49.literal("facilityKey"),
    v49.literal("="),
    v49.unwrap(facilityKey)
  ]);
  const identifierConditionSchema = v49.tuple([v49.literal("identifier"), v49.literal("="), identifier]);
  const shardConditionSchema = v49.tuple([v49.literal("shard"), v49.literal("="), shard]);
  const updatedAtConditionSchema = v49.tuple([
    v49.literal("updatedAt"),
    v49.picklist(["=", "<", "<=", ">", ">="]),
    updatedAt
  ]);
  return v49.intersect([
    v49.object({
      descendingOrder: v49.optional(v49.boolean()),
      limit: v49.optional(LimitSchema()),
      nextPageToken: v49.optional(NextPageTokenSchema())
    }),
    v49.variant("index", [
      v49.object({
        index: v49.literal("facilityKey-deleted"),
        condition: v49.union([
          v49.strictTuple([facilityKeyConditionSchema]),
          v49.tuple([facilityKeyConditionSchema, deletedConditionSchema])
        ])
      }),
      v49.object({
        index: v49.literal("shard-deleted-updatedAt"),
        condition: v49.union([
          v49.strictTuple([shardConditionSchema]),
          v49.strictTuple([shardConditionSchema, deletedConditionSchema]),
          v49.tuple([
            shardConditionSchema,
            v49.tuple([v49.literal("deleted"), v49.literal("="), deleted]),
            updatedAtConditionSchema
          ])
        ])
      }),
      v49.object({
        index: v49.optional(v49.undefined()),
        /** 省略した場合、QueryではなくScanが行われる。 */
        condition: v49.optional(
          v49.union([
            v49.strictTuple([identifierConditionSchema]),
            v49.tuple([identifierConditionSchema, editionConditionSchema])
          ])
        )
      })
    ])
  ]);
});

// src/models/entities/incident-report.ts
import { memoize as memoize4 } from "es-toolkit";
import * as v50 from "valibot";
function IncidentReportKeychainSchema() {
  return v50.object({
    // TODO: 続きを書く。
    userKey: UserKeySchema()
  });
}
__name(IncidentReportKeychainSchema, "IncidentReportKeychainSchema");
function SchemaB2() {
  return v50.object({
    /** エンティティクラス */
    // class: EntityClassSchema(ENTITY_CLASS.INCIDENT_REPORT),
    /** “転倒の瞬間を目撃しましたか?” */
    sawIncident: v50.boolean()
    /**
     * “発生日時”
     * 事故が発生した日時を記録する。
     * 事故を目撃した場合のみ。
     */
    // TODO: 定義する。
    /**
     * “発見日時”
     * 事故後、入居者を発見した日時を記録する。
     */
    // TODO: 定義する。
    /**
     * “発生場所”
     * 実際に事故が発生した場所を記録する。
     * 事故を目撃した場合のみ。
     * 詳細付きその他あり。
     */
    // TODO: 定義する。
    /**
     * “発見場所”
     * 入居者を発見した場所を記録する。
     * 詳細付きその他あり。
     */
    // TODO: 定義する。
    /** “転倒地点周囲の環境” */
    // TODO: 定義する。
    /**
     * “転倒時の関わり方”
     * 1個だけ派生あり。
     * 事故を目撃した場合のみ。
     */
    // TODO: 定義する。
    /**
     * “周辺環境(支えになる物)”
     * 転倒地点周囲の環境に関する情報を記録する。
     * 恐らく派生ありになる。
     */
    // TODO: 定義する。
    /**
     * “周辺環境(発見時点)”
     * 転倒地点周囲の環境に関する情報を記録する。
     * 恐らく派生ありになる。
     */
    // TODO: 定義する。
    /**
     * “補助具(本人使用)”
     * 転倒時に本人が使用していた補助具に関する情報を記録する。
     */
    // TODO: 定義する。
    /**
     * “補助具(発見時点)”
     * 転倒時に本人が使用していた補助具に関する情報を記録する。
     */
    // TODO: 定義する。
    /**
     * “最後に入居者が無事である事を確認した日時”
     * 事故後の発見よりも前に、最後に入居者が無事である事を確認した日時を記録する。
     */
    // TODO: 定義する。
    /**
     * “最後に入居者が無事である事を確認した時の施設職員の業務内容”
     * 事故後の発見よりも前に、最後に入居者が無事である事を確認した時の施設職員の業務内容を記録する。
     */
    // TODO: 定義する。
    //
    // ステップ3
    //
    /**
     * “ご本人は痛みを訴えましたか？”
     * 複数選択の派生あり。
     */
    // TODO: 定義する。
    /**
     * “外観上の外傷・出血は確認されましたか？”
     * 複数選択の派生あり。さらにそこから派生する。
     */
    // TODO: 定義する。
  });
}
__name(SchemaB2, "SchemaB");
var IncidentReportSchema = memoize4(function() {
  return v50.intersect([IncidentReportKeychainSchema(), SchemaB2()]);
});
var PartialIncidentReportSchema = memoize4(function() {
  return v50.pipe(
    v50.tuple([IncidentReportKeychainSchema(), v50.partial(SchemaB2())]),
    v50.transform(function([a, b, ..._]) {
      _;
      return { ...a, ...b };
    })
  );
});
function parseIncidentReport(incidentReport, options) {
  return parse2(IncidentReportSchema(), incidentReport, options);
}
__name(parseIncidentReport, "parseIncidentReport");
function parsePartialIncidentReport(incidentReport, options) {
  return parse2(PartialIncidentReportSchema(), incidentReport, options);
}
__name(parsePartialIncidentReport, "parsePartialIncidentReport");

// src/models/entities/independence-level-entry.ts
import * as v51 from "valibot";
var IndependenceLevelEntryKeyChainSchema = memoize(function() {
  return v51.object({
    /** ユーザーキー */
    userKey: UserKeySchema(),
    /** 評価日時 */
    assessedAt: DateTimeSchema()
  });
});
function Schema18() {
  return v51.object({
    /** エンティティクラス */
    class: EntityClassSchema(entity_class_values_exports.INDEPENDENCE_LEVEL_ENTRY),
    /** 作成日時 */
    createdAt: CreationDateTimeSchema(),
    /** ダミーフラグ */
    dummy: v51.optional(v51.boolean()),
    /** 自立度 */
    independenceLevels: IndependenceLevelsSchema(),
    /** 旧Reha3.0から新Reha3.0に移行したかどうかのフラグ */
    migrated: v51.optional(v51.boolean()),
    /** 旧Reha3.0から新Reha3.0に移行した日時 */
    migratedAt: MigrationDateTimeSchema(),
    /** 移行元のデータベースのホスト名 */
    migratedFrom: v51.optional(v51.string()),
    /** 更新日時 */
    updatedAt: UpdateDateTimeSchema()
  });
}
__name(Schema18, "Schema1");
function Schema2() {
  return v51.variant("type", [
    v51.object({
      /** 自立度タイプ */
      type: v51.literal(enumeration_exports6.COMPLEMENTED),
      /** 評価者の識別子 */
      assessedBy: UsernameSchema(),
      /** 簡易自立度 */
      simpleIndependenceLevels: SimpleIndependenceLevelsSchema1()
    }),
    v51.object({
      /** 自立度タイプ */
      type: v51.literal(enumeration_exports6.ESTIMATED)
    }),
    v51.object({
      /** 自立度タイプ */
      type: v51.literal(enumeration_exports6.OBSERVED),
      /** 評価者の識別子 */
      assessedBy: UsernameSchema()
    })
  ]);
}
__name(Schema2, "Schema2");
var IndependenceLevelEntrySchema = memoize(function() {
  return v51.intersect([IndependenceLevelEntryKeyChainSchema(), Schema18(), Schema2()]);
});
function parseIndependenceLevelEntry(independenceLevelEntry) {
  return v51.parse(IndependenceLevelEntrySchema(), independenceLevelEntry);
}
__name(parseIndependenceLevelEntry, "parseIndependenceLevelEntry");
var IndependenceLevelEntryQuerySchema = memoize(function() {
  const independenceLevelEntry = IndependenceLevelEntrySchema();
  const { assessedAt, userKey } = independenceLevelEntry.options[0].entries;
  const assessedAtConditionSchema = v51.union([
    v51.tuple([v51.literal("assessedAt"), v51.picklist(["=", "<", "<=", ">", ">="]), assessedAt]),
    v51.tuple([v51.picklist(["BEGINS_WITH"]), v51.literal("assessedAt"), assessedAt]),
    v51.tuple([
      v51.literal("assessedAt"),
      v51.picklist(["BETWEEN"]),
      assessedAt,
      v51.literal("AND"),
      assessedAt
    ])
  ]);
  const userKeyConditionSchema = v51.tuple([v51.literal("userKey"), v51.literal("="), userKey]);
  return v51.intersect([
    v51.object({
      descendingOrder: v51.optional(v51.boolean()),
      limit: v51.optional(LimitSchema()),
      nextPageToken: v51.optional(NextPageTokenSchema())
    }),
    v51.variant("index", [
      v51.object({
        index: v51.optional(v51.undefined()),
        /** 省略した場合、QueryではなくScanが行われる。 */
        condition: v51.optional(
          v51.union([
            v51.strictTuple([userKeyConditionSchema]),
            v51.tuple([userKeyConditionSchema, assessedAtConditionSchema])
          ])
        )
      })
    ])
  ]);
});

// src/models/entities/measurement.ts
import { Temporal as Temporal11 } from "temporal-polyfill";
import * as v52 from "valibot";
function MeasurementKeyChain() {
  return v52.object({
    /** 測定データキー  */
    measurementKey: MeasurementKeySchema()
  });
}
__name(MeasurementKeyChain, "MeasurementKeyChain");
function Schema19() {
  return v52.object({
    /** エンティティクラス */
    class: EntityClassSchema(entity_class_values_exports.MEASUREMENT),
    /** 作成日時 */
    createdAt: CreationDateTimeSchema(),
    /**
     * **削除フラグ**
     * @deprecated 測定データの削除はフラグでは行わない。
     */
    deleted: v52.optional(v52.literal(values_exports2.DEFAULT), values_exports2.DEFAULT),
    /** 削除日時 */
    deletedAt: DeletionDateTimeSchema(),
    /** ダミーフラグ */
    dummy: v52.optional(v52.boolean()),
    /**
     * **測定時間[分]**
     * 測定日時(`measuredAt`)を終点として、どれくらいの時間を測定し続けたかを示す。
     */
    duration: v52.union([
      v52.pipe(
        v52.literal(1),
        v52.transform(function() {
          return Temporal11.Duration.from({ minutes: 1 });
        })
      ),
      DurationSchema()
    ]),
    /**
     * **心拍数[回/分]**
     * `null`も`undefined`も扱いは同じ。`undefined`を推奨する。
     */
    heartRate: v52.nullish(v52.pipe(v52.number(), v52.gtValue(0))),
    /** 測定日時 */
    measuredAt: DateTimeSchema(),
    /** 測定者の識別子 */
    measuredBy: v52.optional(
      v52.union([FacilityKeySchema(), OrganizationKeySchema(), SensorKeySchema(), UserKeySchema()])
    ),
    /** 旧Reha3.0から新Reha3.0に移行したかどうかのフラグ */
    migrated: v52.optional(v52.boolean()),
    /** 旧Reha3.0から新Reha3.0に移行した日時 */
    migratedAt: MigrationDateTimeSchema(),
    /** 移行元のデータベースのホスト名 */
    migratedFrom: v52.optional(v52.string()),
    /**
     * **呼吸数[回/分]**
     * `null`も`undefined`も扱いは同じ。`undefined`を推奨する。
     */
    respiratoryRate: v52.nullish(v52.pipe(v52.number(), v52.gtValue(0))),
    /**
     * **センサーキー**
     * このデータを通知したセンサーの識別子。
     * ホットパーティションの発生が懸念されるため、
     * センサーキーは含めるが例外的にプロバイダーキーは含めない。
     */
    sensorKey: v52.optional(SensorKeySchema()),
    /** 更新日時 */
    updatedAt: UpdateDateTimeSchema(),
    /** **ユーザーキー** 入居者の識別子。 */
    userKey: v52.optional(UserKeySchema())
  });
}
__name(Schema19, "Schema1");
function Schema22() {
  return v52.variant("raw", [
    v52.object({
      /**
       * **心拍の回数[回]**
       * 測定時間内に行われた心拍の数。
       * 測定時間が1分の場合、この値は脈拍(PR)[回/分]や心拍数(HR)[回/分]と一致する。
       * (但し、センサーによって平滑化されている場合はこの限りではない。)
       */
      heartbeatCount: v52.optional(v52.pipe(v52.number(), v52.gtValue(0))),
      /** **生フラグ** 心拍や呼吸の回数の生値が存在する場合、`true`。 */
      raw: v52.literal(true),
      /**
       * **呼吸の回数[回]**
       * 測定時間内に行われた呼吸の数。
       * 測定時間が1分の場合、この値は呼吸数(RR)[回/分]と一致する。
       * (但し、センサーによって平滑化されている場合はこの限りではない。)
       */
      respirationCount: v52.optional(v52.pipe(v52.number(), v52.gtValue(0)))
    }),
    v52.object({
      /** **生フラグ** 心拍や呼吸の回数の生値が存在する場合、`true`。 */
      raw: v52.literal(false)
    })
  ]);
}
__name(Schema22, "Schema2");
var MeasurementSchema = memoize(function() {
  return v52.intersect([MeasurementKeyChain(), Schema19(), Schema22()]);
});
var getMeasurementSchema = MeasurementSchema;
function parseMeasurement(measurement) {
  return v52.parse(MeasurementSchema(), measurement);
}
__name(parseMeasurement, "parseMeasurement");

// src/models/entities/operator.ts
import * as v53 from "valibot";
function OperatorKeyChainSchema() {
  return v53.object({
    /** ユーザーキー */
    userKey: UserKeySchema()
  });
}
__name(OperatorKeyChainSchema, "OperatorKeyChainSchema");
function Schema110() {
  return v53.object({
    /** エンティティクラス */
    class: EntityClassSchema(entity_class_values_exports.OPERATOR),
    /** 作成日時 */
    createdAt: CreationDateTimeSchema(),
    /** 削除フラグ */
    deleted: DefaultDeletionFlagSchema(),
    /** 削除日時 */
    deletedAt: DeletionDateTimeSchema(),
    /** 名前 */
    name: v53.string(),
    /** パーミッション */
    permissions: v53.array(v53.string()),
    /** ロール */
    roles: v53.array(v53.string()),
    /** ティア */
    tier: getOperatorTierSchema(),
    /** 更新日時 */
    updatedAt: UpdateDateTimeSchema()
  });
}
__name(Schema110, "Schema1");
var OperatorSchema = memoize(function() {
  return v53.intersect([OperatorKeyChainSchema(), Schema110()]);
});
var getOperatorSchema = OperatorSchema;
function parseOperator(operator) {
  return v53.parse(OperatorSchema(), operator);
}
__name(parseOperator, "parseOperator");

// src/models/entities/organization.ts
import * as v54 from "valibot";
function OrganizationKeyChainSchema() {
  return v54.object({
    /** **組織キー** (Cognitoユーザーの`username`属性) */
    organizationKey: OrganizationKeySchema()
  });
}
__name(OrganizationKeyChainSchema, "OrganizationKeyChainSchema");
function Schema111() {
  return v54.object({
    /** 住所 */
    address: v54.pipe(v54.string(), v54.minLength(1), v54.maxGraphemes(256)),
    /** エンティティクラス */
    class: EntityClassSchema(entity_class_values_exports.ORGANIZATION),
    /** 作成日時 */
    createdAt: CreationDateTimeSchema(),
    /** 削除フラグ */
    deleted: DefaultDeletionFlagSchema(),
    /** 削除日時 */
    deletedAt: DeletionDateTimeSchema(),
    /** ダミーフラグ */
    dummy: v54.optional(v54.boolean()),
    /** **メールアドレス** (Cognitoユーザーの`email`属性) */
    emailAddress: getEmailAddressSchema(),
    /** メールアドレスログインフラグ */
    emailAddressLogin: v54.boolean(),
    /** 一度でもログインした場合に`true`になるフラグ */
    loggedIn: v54.boolean(),
    /** **名前(組織名・法人名)** (Cognitoユーザーの`name`属性) */
    name: v54.pipe(v54.string(), v54.trim(), v54.maxGraphemes(32)),
    /** 郵便番号 */
    postalCode: getPostalCodeSchema(),
    /** 代表者名 */
    representativeName: v54.pipe(v54.string(), v54.maxGraphemes(32)),
    /** 更新日時 */
    updatedAt: UpdateDateTimeSchema()
  });
}
__name(Schema111, "Schema1");
var OrganizationSchema = memoize(function() {
  return v54.intersect([OrganizationKeyChainSchema(), Schema111()]);
});
var OrganizationQuerySchema = memoize(function() {
  const bed = OrganizationSchema();
  const { organizationKey } = bed.options[0].entries;
  const organizationKeyConditionSchema = v54.tuple([
    v54.literal("organizationKey"),
    v54.literal("="),
    organizationKey
  ]);
  return v54.intersect([
    v54.object({
      descendingOrder: v54.optional(v54.boolean()),
      limit: v54.optional(LimitSchema()),
      nextPageToken: v54.optional(NextPageTokenSchema())
    }),
    v54.variant("index", [
      v54.object({
        index: v54.optional(v54.undefined()),
        /** 省略した場合、QueryではなくScanが行われる。 */
        condition: v54.optional(v54.tuple([organizationKeyConditionSchema]))
      })
    ])
  ]);
});

// src/models/entities/provider.ts
import * as v55 from "valibot";
function ProviderKeyChainSchema() {
  return v55.object({
    /** プロバイダーキー  */
    providerKey: ProviderKeySchema()
  });
}
__name(ProviderKeyChainSchema, "ProviderKeyChainSchema");
function Schema112() {
  return v55.object({
    /** エンティティクラス */
    class: EntityClassSchema(entity_class_values_exports.PROVIDER),
    /** 作成日時 */
    createdAt: CreationDateTimeSchema(),
    /** 削除フラグ */
    deleted: DefaultDeletionFlagSchema(),
    /** 削除日時 */
    deletedAt: DeletionDateTimeSchema(),
    /** ダミーフラグ */
    dummy: v55.optional(v55.boolean()),
    /** 施設キー */
    facilityKey: v55.optional(FacilityKeySchema()),
    /** 旧Reha3.0から新Reha3.0に移行したかどうかのフラグ */
    migrated: v55.optional(v55.boolean()),
    /** 旧Reha3.0から新Reha3.0に移行した日時 */
    migratedAt: MigrationDateTimeSchema(),
    /** 移行元のデータベースのホスト名 */
    migratedFrom: v55.optional(v55.string()),
    /** 名前(プロバイダー名) */
    name: v55.pipe(v55.string(), v55.trim(), v55.maxGraphemes(32)),
    /** 組織キー */
    organizationKey: v55.optional(OrganizationKeySchema()),
    /** 固有文字列 */
    uniqueString: v55.string(),
    /** 更新日時 */
    updatedAt: UpdateDateTimeSchema()
  });
}
__name(Schema112, "Schema1");
function Schema23() {
  return v55.variant("type", [
    v55.object({
      /**
       * **`x-api-key`ヘッダー**
       * この値が一致する事を確認することで、
       * リクエストを検証する。
       * aamsサーバーがリクエストヘッダーに設定する。
       */
      apiKey: v55.string(),
      /**
       * **`x-api-secret`ヘッダー**
       * この値が一致する事を確認することで、
       * リクエストを検証する。
       * aamsサーバーがリクエストヘッダーに設定する。
       */
      apiSecret: v55.string(),
      /** データの中継先のURL */
      relayTo: v55.optional(
        v55.object({
          [values_exports.AAMS_ALERT]: v55.array(
            v55.pipe(v55.string(), v55.url(), v55.startsWith("https://"))
          ),
          [values_exports.AAMS_CARE_RECORDS]: v55.array(
            v55.pipe(v55.string(), v55.url(), v55.startsWith("https://"))
          )
        })
      ),
      type: v55.literal(values_exports6.AAMS_SERVER)
    }),
    v55.object({
      /**
       * **`/api/v1/issueToken` `api_key`パラメーター**
       */
      apiKey: v55.string(),
      /** **エントリポイント** `"https://"`から始まり、最後がスラッシュではないURL。 */
      entryPoint: v55.pipe(v55.string(), v55.regex(/^https:\/\/.+[^/]$/)),
      /**
       * **組織コード**
       * 諸々のリクエストに必要な`organization_code`パラメーター。
       */
      organizationCode: v55.string(),
      /**
       * **`/api/v1/issueToken` `password`パラメーター**
       */
      password: v55.string(),
      /** データの中継先のURL */
      relayTo: v55.object({
        [values_exports.ANSIEL_PUSH_NOTIFICATION]: v55.array(
          v55.pipe(v55.string(), v55.url(), v55.startsWith("https://"))
        )
      }),
      type: v55.literal(values_exports6.ANSIEL_API)
    }),
    v55.object({
      /** **HMAC鍵** HMACに使用する。 */
      hmacKey: v55.pipe(v55.string(), v55.length(32)),
      type: v55.literal(values_exports6.GENERIC_PROVIDER)
    })
  ]);
}
__name(Schema23, "Schema2");
var ProviderSchema = memoize(function() {
  return v55.intersect([ProviderKeyChainSchema(), Schema112(), Schema23()]);
});
function parseProvider(provider) {
  return v55.parse(ProviderSchema(), provider);
}
__name(parseProvider, "parseProvider");
var ProviderQuerySchema = memoize(function() {
  const provider = ProviderSchema();
  const { providerKey } = provider.options[0].entries;
  const { deleted, facilityKey, uniqueString } = provider.options[1].entries;
  const deletedConditionSchema = v55.tuple([
    v55.literal("deleted"),
    v55.picklist(["=", "<", "<=", ">", ">="]),
    deleted
  ]);
  const facilityKeyConditionSchema = v55.tuple([
    v55.literal("facilityKey"),
    v55.literal("="),
    v55.nonNullable(v55.unwrap(facilityKey))
    // TODO: `facilityKey`から`null`を取り除いたら`nonNullable()`を外す。
  ]);
  const providerKeyConditionSchema = v55.tuple([
    v55.literal("providerKey"),
    v55.literal("="),
    providerKey
  ]);
  const typeConditionSchema = v55.tuple([v55.literal("type"), v55.literal("="), ProviderTypeSchema()]);
  const uniqueStringConditionSchema = v55.tuple([
    v55.literal("uniqueString"),
    v55.literal("="),
    uniqueString
  ]);
  return v55.intersect([
    v55.object({
      descendingOrder: v55.optional(v55.boolean()),
      limit: v55.optional(LimitSchema()),
      nextPageToken: v55.optional(NextPageTokenSchema())
    }),
    v55.variant("index", [
      v55.object({
        index: v55.literal("facilityKey-deleted-gsi"),
        condition: v55.union([
          v55.strictTuple([facilityKeyConditionSchema]),
          v55.tuple([facilityKeyConditionSchema, deletedConditionSchema])
        ])
      }),
      v55.object({
        index: v55.literal("type-deleted-gsi"),
        condition: v55.union([
          v55.strictTuple([typeConditionSchema]),
          v55.tuple([typeConditionSchema, deletedConditionSchema])
        ])
      }),
      v55.object({
        index: v55.literal("uniqueString-gsi"),
        condition: v55.union([
          v55.strictTuple([uniqueStringConditionSchema]),
          v55.tuple([uniqueStringConditionSchema, deletedConditionSchema])
        ])
      }),
      v55.object({
        index: v55.optional(v55.undefined()),
        /** 省略した場合、QueryではなくScanが行われる。 */
        condition: v55.optional(v55.tuple([providerKeyConditionSchema]))
      })
    ])
  ]);
});
function generateProviderUniqueString(provider) {
  switch (provider.type) {
    case values_exports6.AAMS_SERVER:
      return provider.type + "." + provider.apiKey;
    case values_exports6.ANSIEL_API:
      return provider.type + "." + provider.entryPoint + "." + provider.organizationCode;
    default:
      throw new UniversalError(enumeration_exports.UNEXPECTED, {
        data: { private: { provider } },
        message: "\u4E0D\u660E\u306A\u30D7\u30ED\u30D0\u30A4\u30C0\u30FC\u30BF\u30A4\u30D7\u3067\u3059\u3002"
      });
  }
}
__name(generateProviderUniqueString, "generateProviderUniqueString");

// src/models/entities/push-notification-receiver.ts
import { memoize as memoize5 } from "es-toolkit";
import * as v56 from "valibot";
var NUMBER_OF_PUSH_NOTIFICATION_RECEIVER_SHARDS = 256;
function PushNotificationReceiverKeyChainSchema() {
  return v56.object({
    /** **プッシュ通知トークン** プッシュ通知の送信先として指定する文字列。 */
    token: v56.pipe(v56.string(), v56.nonEmpty()),
    /** プッシュ通知受信機タイプ */
    type: PushNotificationReceiverTypeSchema()
  });
}
__name(PushNotificationReceiverKeyChainSchema, "PushNotificationReceiverKeyChainSchema");
function SchemaB3() {
  return v56.object({
    /** エンティティクラス */
    class: EntityClassSchema(entity_class_values_exports.PUSH_NOTIFICATION_RECEIVER),
    /** 作成日時 */
    createdAt: CreationDateTimeSchema(),
    /** **施設キー** 購読している施設の識別子。 */
    facilityKey: v56.optional(FacilityKeySchema()),
    /** **シャード** 分散処理のためのグローバルセカンダリインデックスのパーティションキー。 */
    shard: v56.optional(
      v56.pipe(
        v56.number(),
        v56.integer(),
        v56.minValue(0),
        v56.ltValue(NUMBER_OF_PUSH_NOTIFICATION_RECEIVER_SHARDS)
      ),
      function() {
        return Math.floor(NUMBER_OF_PUSH_NOTIFICATION_RECEIVER_SHARDS * Math.random());
      }
    ),
    /** 購読日時 */
    subscribedAt: DateTimeSchema(),
    /** 更新日時 */
    updatedAt: UpdateDateTimeSchema(),
    /** **ユーザー名** ログインしているユーザーの識別子。 */
    username: v56.optional(UsernameSchema())
  });
}
__name(SchemaB3, "SchemaB");
var PushNotificationReceiverSchema = memoize5(function() {
  return v56.intersect([PushNotificationReceiverKeyChainSchema(), SchemaB3()]);
});
var PartialPushNotificationReceiverSchema = memoize5(function() {
  return v56.pipe(
    v56.tuple([PushNotificationReceiverKeyChainSchema(), v56.partial(SchemaB3())]),
    v56.transform(function([a, b, ..._]) {
      _;
      return { ...a, ...b };
    })
  );
});
function parsePushNotificationReceiver(pushNotificationReceiver, options) {
  return parse2(PushNotificationReceiverSchema(), pushNotificationReceiver, options);
}
__name(parsePushNotificationReceiver, "parsePushNotificationReceiver");
function parsePartialPushNotificationReceiver(pushNotificationReceiver, options) {
  return parse2(PartialPushNotificationReceiverSchema(), pushNotificationReceiver, options);
}
__name(parsePartialPushNotificationReceiver, "parsePartialPushNotificationReceiver");

// src/models/entities/resident.ts
import * as v57 from "valibot";
function ResidentKeyChainSchema() {
  return v57.object({
    /** ユーザーキー */
    userKey: UserKeySchema()
  });
}
__name(ResidentKeyChainSchema, "ResidentKeyChainSchema");
function Schema113() {
  return v57.object({
    /** 同意フラグ */
    agreed: v57.optional(v57.boolean()),
    /** アラート設定 */
    alertSettings: v57.object({
      [resident_state_values_exports.GOT_UP]: v57.object({ enabled: v57.nullable(v57.boolean()) }),
      [resident_state_values_exports.WANDERING]: v57.object({
        /** 誤ってヌル許容型になっているが`null`は`false`と同じ扱い。 */
        enabled: v57.nullable(v57.boolean()),
        range: v57.tuple([TimeSchema(), TimeSchema()]),
        threshold: DurationSchema()
      })
    }),
    /** ベッドキー */
    bedKey: v57.optional(BedKeySchema()),
    /** 誕生日 */
    birthday: DateSchema(),
    /** エンティティクラス */
    class: EntityClassSchema(entity_class_values_exports.RESIDENT),
    /** 作成日時 */
    createdAt: CreationDateTimeSchema(),
    /** 削除フラグ */
    deleted: DefaultDeletionFlagSchema(),
    /** 削除日時 */
    deletedAt: DeletionDateTimeSchema(),
    /** 表示名 */
    displayName: v57.pipe(v57.string(), v57.maxGraphemes(32)),
    /** ダミーフラグ */
    dummy: v57.optional(v57.boolean()),
    /** 施設キー */
    facilityKey: FacilityKeySchema(),
    /** 身長[cm] */
    height: v57.pipe(v57.number(), v57.gtValue(0), v57.maxValue(999)),
    /**
     * **組織・施設管理フラグ**
     * 施設がユーザーそのものを管理可能な場合、`true`。
     * `true`の場合、施設に権限を持つユーザーがこのエンティティを介して
     * 対象ユーザーのログイン情報の変更が可能。
     */
    managed: v57.optional(v57.boolean()),
    /** 旧Reha3.0から新Reha3.0に移行したかどうかのフラグ */
    migrated: v57.optional(v57.boolean()),
    /** 旧Reha3.0から新Reha3.0に移行した日時 */
    migratedAt: MigrationDateTimeSchema(),
    /** 移行元のデータベースのホスト名 */
    migratedFrom: v57.optional(v57.string()),
    /** 名前(入居者の本名) */
    name: v57.pipe(v57.string(), v57.nonEmpty(), v57.maxGraphemes(64)),
    /** 組織キー */
    organizationKey: OrganizationKeySchema(),
    /** 発音名 */
    pronunciationName: v57.pipe(v57.string(), v57.maxGraphemes(32)),
    /** プロバイダーキー */
    providerKey: v57.optional(ProviderKeySchema()),
    /** センサーキー */
    sensorKey: v57.optional(SensorKeySchema()),
    /** 性別 */
    sex: SexSchema(),
    /** 更新日時 */
    updatedAt: UpdateDateTimeSchema(),
    /** 体重[kg] */
    weight: v57.pipe(v57.number(), v57.gtValue(0), v57.maxValue(999))
  });
}
__name(Schema113, "Schema1");
var ResidentSchema = memoize(function() {
  return v57.intersect([ResidentKeyChainSchema(), Schema113()]);
});
var getResidentSchema = ResidentSchema;
function parseResident(resident) {
  return v57.parse(ResidentSchema(), resident);
}
__name(parseResident, "parseResident");
var PartialResidentSchema = memoize(function() {
  return v57.pipe(
    v57.tuple([ResidentKeyChainSchema(), v57.partial(Schema113())]),
    v57.transform(function([a, b, ..._]) {
      _;
      return { ...a, ...b };
    })
  );
});
var getPartialResidentSchema = PartialResidentSchema;
function parsePartialResident(resident) {
  return v57.parse(PartialResidentSchema(), resident);
}
__name(parsePartialResident, "parsePartialResident");
var ResidentQuerySchema = memoize(function() {
  const resident = ResidentSchema();
  const { userKey } = resident.options[0].entries;
  const { deleted, facilityKey } = resident.options[1].entries;
  const deletedConditionSchema = v57.tuple([
    v57.literal("deleted"),
    v57.picklist(["=", "<", "<=", ">", ">="]),
    deleted
  ]);
  const facilityKeyConditionSchema = v57.tuple([
    v57.literal("facilityKey"),
    v57.literal("="),
    facilityKey
  ]);
  const userKeyConditionSchema = v57.tuple([v57.literal("userKey"), v57.literal("="), userKey]);
  return v57.intersect([
    v57.object({
      descendingOrder: v57.optional(v57.boolean()),
      limit: v57.optional(LimitSchema()),
      nextPageToken: v57.optional(NextPageTokenSchema())
    }),
    v57.variant("index", [
      v57.object({
        index: v57.literal("facilityKey-deleted-gsi"),
        condition: v57.union([
          v57.strictTuple([facilityKeyConditionSchema]),
          v57.tuple([facilityKeyConditionSchema, deletedConditionSchema])
        ])
      }),
      v57.object({
        index: v57.optional(v57.undefined()),
        /** 省略した場合、QueryではなくScanが行われる。 */
        condition: v57.optional(v57.tuple([userKeyConditionSchema]))
      })
    ])
  ]);
});

// src/models/entities/resource-instance.ts
import { memoize as memoize6 } from "es-toolkit";
import * as v58 from "valibot";
function ResourceInstanceKeyChainSchema() {
  return v58.object({
    /** パーティションキー */
    partitionKey: v58.pipe(v58.string(), v58.minLength(1)),
    /** ソートキー */
    sortKey: v58.pipe(v58.string(), v58.minLength(1))
  });
}
__name(ResourceInstanceKeyChainSchema, "ResourceInstanceKeyChainSchema");
function SchemaB4() {
  return v58.object({
    /** エンティティクラス */
    class: EntityClassSchema(entity_class_values_exports.RESOURCE_INSTANCE),
    /** 作成日時 */
    createdAt: CreationDateTimeSchema(),
    /** 更新日時 */
    updatedAt: UpdateDateTimeSchema()
  });
}
__name(SchemaB4, "SchemaB");
var ResourceInstanceSchema = memoize6(function() {
  return v58.intersect([ResourceInstanceKeyChainSchema(), SchemaB4()]);
});
var PartialResourceInstanceSchema = memoize6(function() {
  return v58.pipe(
    v58.tuple([ResourceInstanceKeyChainSchema(), v58.partial(SchemaB4())]),
    v58.transform(function([a, b, ..._]) {
      _;
      return { ...a, ...b };
    })
  );
});
function parseResourceInstance(resourceInstance, options) {
  return parse2(ResourceInstanceSchema(), resourceInstance, options);
}
__name(parseResourceInstance, "parseResourceInstance");
function parsePartialResourceInstance(resourceInstance, options) {
  return parse2(PartialResourceInstanceSchema(), resourceInstance, options);
}
__name(parsePartialResourceInstance, "parsePartialResourceInstance");

// src/models/entities/room.ts
import * as v59 from "valibot";
function RoomKeyChainSchema() {
  return v59.object({
    /** 居室キー */
    roomKey: RoomKeySchema()
  });
}
__name(RoomKeyChainSchema, "RoomKeyChainSchema");
function Schema114() {
  return v59.object({
    /** エンティティクラス */
    class: EntityClassSchema(entity_class_values_exports.ROOM),
    /** 作成日時 */
    createdAt: CreationDateTimeSchema(),
    /** 削除フラグ */
    deleted: DefaultDeletionFlagSchema(),
    /** 削除日時 */
    deletedAt: DeletionDateTimeSchema(),
    /** 施設キー */
    facilityKey: FacilityKeySchema(),
    /** 旧Reha3.0から新Reha3.0に移行したかどうかのフラグ */
    migrated: v59.optional(v59.boolean()),
    /** 旧Reha3.0から新Reha3.0に移行した日時 */
    migratedAt: MigrationDateTimeSchema(),
    /** 移行元のデータベースのホスト名 */
    migratedFrom: v59.optional(v59.string()),
    /** 名前 */
    name: v59.pipe(v59.string(), v59.nonEmpty(), v59.maxGraphemes(64)),
    /** 組織キー */
    organizationKey: OrganizationKeySchema(),
    /** 更新日時 */
    updatedAt: UpdateDateTimeSchema()
  });
}
__name(Schema114, "Schema1");
var RoomSchema = memoize(function() {
  return v59.intersect([RoomKeyChainSchema(), Schema114()]);
});
var getRoomSchema = RoomSchema;
var getPartialRoomSchema = memoize(function() {
  return v59.pipe(
    v59.tuple([RoomKeyChainSchema(), v59.partial(Schema114())]),
    v59.transform(function([a, b, ..._]) {
      _;
      return { ...a, ...b };
    })
  );
});
function parseRoom(room, options) {
  return parse2(RoomSchema(), room, options);
}
__name(parseRoom, "parseRoom");
function parsePartialRoom(partialRoom, options) {
  return parse2(getPartialRoomSchema(), partialRoom, options);
}
__name(parsePartialRoom, "parsePartialRoom");

// src/models/entities/sensor.ts
import * as v60 from "valibot";
function SensorKeyChainSchema() {
  return v60.object({
    /** センサーキー  */
    sensorKey: SensorKeySchema()
  });
}
__name(SensorKeyChainSchema, "SensorKeyChainSchema");
function Schema115() {
  return v60.object({
    /** ベッドキー */
    bedKey: v60.optional(BedKeySchema()),
    /** エンティティクラス */
    class: EntityClassSchema(entity_class_values_exports.SENSOR),
    /** 作成日時 */
    createdAt: CreationDateTimeSchema(),
    /** 削除フラグ */
    deleted: DefaultDeletionFlagSchema(),
    /** 削除日時 */
    deletedAt: DeletionDateTimeSchema(),
    /** ダミーフラグ */
    dummy: v60.optional(v60.boolean()),
    /** 施設キー */
    facilityKey: v60.optional(FacilityKeySchema()),
    /** 旧Reha3.0から新Reha3.0に移行したかどうかのフラグ */
    migrated: v60.optional(v60.boolean()),
    /** 旧Reha3.0から新Reha3.0に移行した日時 */
    migratedAt: MigrationDateTimeSchema(),
    /** 移行元のデータベースのホスト名 */
    migratedFrom: v60.optional(v60.string()),
    /** 名前(センサー名) */
    name: v60.pipe(v60.string(), v60.trim(), v60.maxGraphemes(32)),
    /** 組織キー */
    organizationKey: v60.optional(OrganizationKeySchema()),
    /** プロバイダーキー */
    providerKey: ProviderKeySchema(),
    /** 固有文字列 */
    uniqueString: v60.string(),
    /** 更新日時 */
    updatedAt: UpdateDateTimeSchema(),
    /** **ユーザーキー** 入居者の識別子。 */
    userKey: v60.optional(UserKeySchema())
  });
}
__name(Schema115, "Schema1");
function Schema24() {
  return v60.variant("type", [
    v60.object({
      /** MACアドレス */
      macAddress: MacAddressSchema(),
      type: v60.literal(values_exports7.AAMS)
    }),
    v60.object({
      /**
       * **機器ID**
       * ANSIELクラウド環境内で一意な整数。
       * 本体に記載は無く、ANSIEL 外部連携APIで確認する。
       * 機器のシステムID、`"id"`、`"device_id"`とも呼ばれる。
       */
      deviceId: AnsielDeviceIdSchema(),
      /**
       * **受信者ユニークキー**
       * 外部連携APIのプッシュ通知機能への登録で排出される文字列。
       * 登録を行わない場合は省略される。
       */
      receiverUniqueKey: v60.optional(AnsielReceiverUniqueKeySchema()),
      /**
       * **シリアルナンバー**
       * 全てのANSIELで一意な、主に`P`から始まる文字列。
       * 本体背面にある`Serial No.`の欄に記載されている。
       * 睡眠計機器の固有MYH番号、機器の識別固有番号、機器固有識別番号、
       * `"device_myh"`、`"device_identifier"`、`"identifier"`とも呼ばれる。
       */
      serialNumber: AnsielSerialNumberSchema(),
      type: v60.literal(values_exports7.ANSIEL)
    })
  ]);
}
__name(Schema24, "Schema2");
var SensorSchema = memoize(function() {
  return v60.intersect([SensorKeyChainSchema(), Schema115(), Schema24()]);
});
function parseSensor(sensor, options) {
  return parse2(SensorSchema(), sensor, options);
}
__name(parseSensor, "parseSensor");
var PartialSensorSchema = memoize(function() {
  const c = Schema24();
  return v60.pipe(
    v60.tuple([
      SensorKeyChainSchema(),
      v60.optional(v60.partial(Schema115())),
      v60.optional(
        v60.variant(c.key, [
          v60.object({ ...v60.partial(c.options[0]).entries, [c.key]: c.options[0].entries[c.key] }),
          v60.object({ ...v60.partial(c.options[1]).entries, [c.key]: c.options[1].entries[c.key] })
        ])
      )
    ]),
    v60.transform(function([a, b, c2, ..._]) {
      _;
      return { ...a, ...b, ...c2 };
    })
  );
});
function parsePartialSensor(sensor, options) {
  return parse2(PartialSensorSchema(), sensor, options);
}
__name(parsePartialSensor, "parsePartialSensor");
var SensorQuerySchema = memoize(function() {
  const sensor = SensorSchema();
  const { sensorKey } = sensor.options[0].entries;
  const { deleted, facilityKey, providerKey, uniqueString } = sensor.options[1].entries;
  const deletedConditionSchema = v60.tuple([
    v60.literal("deleted"),
    v60.picklist(["=", "<", "<=", ">", ">="]),
    deleted
  ]);
  const facilityKeyConditionSchema = v60.tuple([
    v60.literal("facilityKey"),
    v60.literal("="),
    v60.nonNullable(v60.unwrap(facilityKey))
    // TODO: `facilityKey`から`null`を取り除いたら`nonNullable()`を外す。
  ]);
  const providerKeyConditionSchema = v60.tuple([
    v60.literal("providerKey"),
    v60.literal("="),
    providerKey
  ]);
  const sensorKeyConditionSchema = v60.tuple([v60.literal("sensorKey"), v60.literal("="), sensorKey]);
  const uniqueStringConditionSchema = v60.tuple([
    v60.literal("uniqueString"),
    v60.literal("="),
    uniqueString
  ]);
  return v60.intersect([
    v60.object({
      descendingOrder: v60.optional(v60.boolean()),
      limit: v60.optional(LimitSchema()),
      nextPageToken: v60.optional(NextPageTokenSchema())
    }),
    v60.variant("index", [
      v60.object({
        index: v60.literal("facilityKey-deleted-gsi"),
        condition: v60.union([
          v60.strictTuple([facilityKeyConditionSchema]),
          v60.tuple([facilityKeyConditionSchema, deletedConditionSchema])
        ])
      }),
      v60.object({
        index: v60.literal("providerKey-deleted-gsi"),
        condition: v60.union([
          v60.strictTuple([providerKeyConditionSchema]),
          v60.tuple([providerKeyConditionSchema, deletedConditionSchema])
        ])
      }),
      v60.object({
        index: v60.literal("uniqueString-gsi"),
        condition: v60.union([
          v60.strictTuple([uniqueStringConditionSchema]),
          v60.tuple([uniqueStringConditionSchema, deletedConditionSchema])
        ])
      }),
      v60.object({
        index: v60.optional(v60.undefined()),
        /** 省略した場合、QueryではなくScanが行われる。 */
        condition: v60.optional(v60.tuple([sensorKeyConditionSchema]))
      })
    ])
  ]);
});
function generateSensorUniqueString(sensor) {
  switch (sensor.type) {
    case values_exports7.AAMS:
      return values_exports7.AAMS + "." + sensor.macAddress;
    case values_exports7.ANSIEL:
      return values_exports7.ANSIEL + "." + sensor.serialNumber;
    default:
      throw new UniversalError(enumeration_exports.UNEXPECTED, {
        data: { private: { sensor } },
        message: "\u4E0D\u660E\u306A\u30BB\u30F3\u30B5\u30FC\u30BF\u30A4\u30D7\u3067\u3059\u3002"
      });
  }
}
__name(generateSensorUniqueString, "generateSensorUniqueString");

// src/models/entities/socket-client.ts
import { memoize as memoize7 } from "es-toolkit";
import * as v61 from "valibot";
var NUMBER_OF_SOCKET_CLIENT_SHARDS = 256;
var SocketClientKeyChainSchema = memoize7(function() {
  return v61.object({
    /** **コネクションID** Amazon API Gateway WebSocket APIにおけるソケット接続の識別子。 */
    connectionId: v61.pipe(v61.string(), v61.nonEmpty())
  });
});
function Schema116() {
  return v61.object({
    /** エンティティクラス */
    class: EntityClassSchema(entity_class_values_exports.SOCKET_CLIENT),
    /** 作成日時 */
    createdAt: CreationDateTimeSchema(),
    /** **施設キー** 購読している施設の識別子。 */
    facilityKey: v61.optional(FacilityKeySchema()),
    /** **シャード** 分散処理のためのグローバルセカンダリインデックスのパーティションキー。 */
    shard: v61.optional(
      v61.pipe(v61.number(), v61.integer(), v61.minValue(0), v61.ltValue(NUMBER_OF_SOCKET_CLIENT_SHARDS)),
      function() {
        return Math.floor(NUMBER_OF_SOCKET_CLIENT_SHARDS * Math.random());
      }
    ),
    /** 購読日時 */
    subscribedAt: DateTimeSchema(),
    /** 更新日時 */
    updatedAt: UpdateDateTimeSchema(),
    /** **ユーザー名** ログインしているユーザーの識別子。 */
    username: v61.optional(UsernameSchema())
  });
}
__name(Schema116, "Schema1");
var SocketClientSchema = memoize7(function() {
  return v61.intersect([SocketClientKeyChainSchema(), Schema116()]);
});
function parseSocketClient(socketClient, options) {
  return parse2(SocketClientSchema(), socketClient, options);
}
__name(parseSocketClient, "parseSocketClient");
var PartialSocketClientSchema = memoize7(function() {
  return v61.pipe(
    v61.tuple([SocketClientKeyChainSchema(), v61.partial(Schema116())]),
    v61.transform(function([a, b, ..._]) {
      _;
      return { ...a, ...b };
    })
  );
});
function parsePartialSocketClient(socketClient, options) {
  return parse2(PartialSocketClientSchema(), socketClient, options);
}
__name(parsePartialSocketClient, "parsePartialSocketClient");
var SocketClientQuerySchema = memoize7(function() {
  const socketClient = SocketClientSchema();
  const { connectionId } = socketClient.options[0].entries;
  const { facilityKey, subscribedAt } = socketClient.options[1].entries;
  const connectionIdConditionSchema = v61.tuple([
    v61.literal("connectionId"),
    v61.literal("="),
    connectionId
  ]);
  const facilityKeyConditionSchema = v61.tuple([
    v61.literal("facilityKey"),
    v61.literal("="),
    v61.unwrap(facilityKey)
  ]);
  const subscribedAtConditionSchema = v61.union([
    v61.tuple([v61.literal("subscribedAt"), v61.picklist(["=", "<", "<=", ">", ">="]), subscribedAt]),
    v61.tuple([v61.picklist(["BEGINS_WITH"]), v61.literal("subscribedAt"), subscribedAt]),
    v61.tuple([
      v61.literal("subscribedAt"),
      v61.picklist(["BETWEEN"]),
      subscribedAt,
      v61.literal("AND"),
      subscribedAt
    ])
  ]);
  return v61.intersect([
    v61.object({
      descendingOrder: v61.optional(v61.boolean()),
      limit: v61.optional(LimitSchema()),
      nextPageToken: v61.optional(NextPageTokenSchema())
    }),
    v61.variant("index", [
      v61.object({
        index: v61.literal("facilityKey-subscribedAt"),
        condition: v61.union([
          v61.strictTuple([facilityKeyConditionSchema]),
          v61.tuple([facilityKeyConditionSchema, subscribedAtConditionSchema])
        ])
      }),
      v61.object({
        index: v61.optional(v61.undefined()),
        /** 省略した場合、QueryではなくScanが行われる。 */
        condition: v61.optional(v61.tuple([connectionIdConditionSchema]))
      })
    ])
  ]);
});

// src/models/entities/status.ts
import { Temporal as Temporal12 } from "temporal-polyfill";
import * as v62 from "valibot";
function StatusKeyChainSchema() {
  return v62.object({
    /** 状態データキー  */
    statusKey: StatusKeySchema()
  });
}
__name(StatusKeyChainSchema, "StatusKeyChainSchema");
function Schema117() {
  return v62.object({
    /** アラート済みフラグ */
    alerted: v62.optional(v62.boolean()),
    /** アラート日時 */
    alertedAt: v62.optional(DateTimeSchema()),
    /** エンティティクラス */
    class: EntityClassSchema(entity_class_values_exports.STATUS),
    /** 確認済みフラグ */
    confirmed: v62.optional(v62.boolean()),
    /** 確認日時 */
    confirmedAt: v62.optional(DateTimeSchema()),
    /** 確認者の識別子 */
    confirmedBy: v62.optional(
      v62.union([FacilityKeySchema(), OrganizationKeySchema(), UserKeySchema()])
    ),
    /**
     * **状態遷移時点での入居者の転倒リスク**
     * アラート機能の音声の選択に用いる。
     * 状態データに入居者が関連しない場合や未評価の場合は`undefined`となる。
     */
    fallRisk: v62.optional(FallRiskSchema()),
    /** 作成日時 */
    createdAt: CreationDateTimeSchema(),
    /**
     * **削除フラグ**
     * @deprecated 状態データの削除はフラグでは行わない。
     */
    deleted: v62.optional(v62.literal(values_exports2.DEFAULT), values_exports2.DEFAULT),
    /** 削除日時 */
    deletedAt: DeletionDateTimeSchema(),
    /** ダミーフラグ */
    dummy: v62.optional(v62.boolean()),
    /** 旧Reha3.0から新Reha3.0に移行したかどうかのフラグ */
    migrated: v62.optional(v62.boolean()),
    /** 旧Reha3.0から新Reha3.0に移行した日時 */
    migratedAt: MigrationDateTimeSchema(),
    /** 移行元のデータベースのホスト名 */
    migratedFrom: v62.optional(v62.string()),
    /** **プロバイダーキー** `sensorKey`に対応するセンサーを管理するプロバイダーの識別子。 */
    providerKey: v62.optional(ProviderKeySchema()),
    /** **センサーキー** この状態遷移を通知したセンサーの識別子。 */
    sensorKey: v62.optional(SensorKeySchema()),
    /** **状態** `transitionedAt`以降の入居者の状態。 */
    state: ResidentStateSchema(),
    /** **遷移日時** 入居者の状態が遷移した日時。 */
    transitionedAt: DateTimeSchema(),
    /** **遷移者の識別子** この遷移の原因となったエンティティの識別子。 */
    transitionedBy: v62.optional(
      v62.union([
        FacilityKeySchema(),
        OrganizationKeySchema(),
        ProviderKeySchema(),
        SensorKeySchema(),
        UserKeySchema()
      ])
    ),
    /** 更新日時 */
    updatedAt: UpdateDateTimeSchema(),
    /** **ユーザーキー** 入居者の識別子。 */
    userKey: v62.optional(UserKeySchema())
  });
}
__name(Schema117, "Schema1");
var StatusSchema = memoize(function() {
  return v62.intersect([StatusKeyChainSchema(), Schema117()]);
});
var PartialStatusSchema = memoize(function() {
  return v62.pipe(
    v62.tuple([StatusKeyChainSchema(), v62.partial(Schema117())]),
    v62.transform(function([a, b, ..._]) {
      _;
      return { ...a, ...b };
    })
  );
});
function parseStatus(status, options) {
  return parse2(StatusSchema(), status, options);
}
__name(parseStatus, "parseStatus");
function parsePartialStatus(partialStatus, options) {
  return parse2(PartialStatusSchema(), partialStatus, options);
}
__name(parsePartialStatus, "parsePartialStatus");
var StatusQuerySchema = memoize(function() {
  const status = StatusSchema();
  const { statusKey } = status.options[0].entries;
  const { sensorKey, transitionedAt, userKey } = status.options[1].entries;
  const sensorKeyConditionSchema = v62.tuple([
    v62.literal("sensorKey"),
    v62.literal("="),
    v62.unwrap(sensorKey)
  ]);
  const statusKeyConditionSchema = v62.tuple([v62.literal("statusKey"), v62.literal("="), statusKey]);
  const transitionedAtConditionSchema = v62.union([
    v62.tuple([v62.literal("transitionedAt"), v62.picklist(["=", "<", "<=", ">", ">="]), transitionedAt]),
    v62.tuple([v62.picklist(["BEGINS_WITH"]), v62.literal("transitionedAt"), transitionedAt]),
    v62.tuple([
      v62.literal("transitionedAt"),
      v62.picklist(["BETWEEN"]),
      transitionedAt,
      v62.literal("AND"),
      transitionedAt
    ])
  ]);
  const userKeyConditionSchema = v62.tuple([v62.literal("userKey"), v62.literal("="), v62.unwrap(userKey)]);
  return v62.intersect([
    v62.object({
      descendingOrder: v62.optional(v62.boolean()),
      limit: v62.optional(LimitSchema()),
      nextPageToken: v62.optional(NextPageTokenSchema())
    }),
    v62.variant("index", [
      v62.object({
        index: v62.literal("sensorKey-transitionedAt"),
        condition: v62.union([
          v62.strictTuple([sensorKeyConditionSchema]),
          v62.tuple([sensorKeyConditionSchema, transitionedAtConditionSchema])
        ])
      }),
      v62.object({
        index: v62.literal("userKey-transitionedAt"),
        condition: v62.union([
          v62.strictTuple([userKeyConditionSchema]),
          v62.tuple([userKeyConditionSchema, transitionedAtConditionSchema])
        ])
      }),
      v62.object({
        index: v62.optional(v62.undefined()),
        /** 省略した場合、QueryではなくScanが行われる。 */
        condition: v62.optional(v62.tuple([statusKeyConditionSchema]))
      })
    ])
  ]);
});
function calculateResidentStateDurations(stateTransitions, options) {
  const durations = {
    [resident_state_values_exports.CAME_BACK]: new Temporal12.Duration(),
    [resident_state_values_exports.GOT_UP]: new Temporal12.Duration(),
    [resident_state_values_exports.PROVIDER_ERROR]: new Temporal12.Duration(),
    [resident_state_values_exports.SENSOR_ERROR]: new Temporal12.Duration(),
    [resident_state_values_exports.SLEEPING]: new Temporal12.Duration(),
    [resident_state_values_exports.SLEEPING_HEAVILY]: new Temporal12.Duration(),
    [resident_state_values_exports.SLEEPING_LIGHTLY]: new Temporal12.Duration(),
    [resident_state_values_exports.UNKNOWN]: new Temporal12.Duration(),
    [resident_state_values_exports.WAKING]: new Temporal12.Duration(),
    [resident_state_values_exports.WANDERING]: new Temporal12.Duration(),
    [resident_state_values_exports.WENT_OUT]: new Temporal12.Duration()
  };
  if (stateTransitions.length === 0) {
    if (options?.period) {
      durations[resident_state_values_exports.UNKNOWN] = durations[resident_state_values_exports.UNKNOWN].add(
        options.period[0].until(options.period[1])
      );
    }
    return durations;
  }
  const period = options?.period ?? [
    stateTransitions[0][0],
    stateTransitions[stateTransitions.length - 1][0]
  ];
  if (Temporal12.PlainDateTime.compare(period[0], stateTransitions[0][0]) < 0) {
    durations[resident_state_values_exports.UNKNOWN] = durations[resident_state_values_exports.UNKNOWN].add(
      period[0].until(stateTransitions[0][0])
    );
  }
  for (let i = 0; i < stateTransitions.length; i++) {
    const [transitionedAt1, state] = stateTransitions[i];
    const transitionedAt2 = stateTransitions.at(i + 1)?.[0];
    let duration;
    if (Temporal12.PlainDateTime.compare(transitionedAt1, period[0]) < 0) {
      if (!transitionedAt2 || Temporal12.PlainDateTime.compare(period[1], transitionedAt2) <= 0) {
        duration = period[0].until(period[1]);
      } else if (Temporal12.PlainDateTime.compare(period[0], transitionedAt2) < 0 && Temporal12.PlainDateTime.compare(transitionedAt2, period[1]) < 0) {
        duration = period[0].until(transitionedAt2);
      }
    } else if (Temporal12.PlainDateTime.compare(transitionedAt1, period[1]) < 0) {
      if (!transitionedAt2 || Temporal12.PlainDateTime.compare(period[1], transitionedAt2) <= 0) {
        duration = transitionedAt1.until(period[1]);
      } else if (Temporal12.PlainDateTime.compare(transitionedAt2, period[1]) < 0) {
        duration = transitionedAt1.until(transitionedAt2);
      }
    }
    if (duration) {
      durations[state] = durations[state].add(duration);
    }
  }
  return durations;
}
__name(calculateResidentStateDurations, "calculateResidentStateDurations");
function calculateSleepingHours(durations) {
  let duration = new Temporal12.Duration();
  for (const state of SLEEPING_RESIDENT_STATES) {
    if (durations[state]) {
      duration = duration.add(durations[state]);
    }
  }
  return duration;
}
__name(calculateSleepingHours, "calculateSleepingHours");

// src/models/entities/status-schedule.ts
import * as v63 from "valibot";
var NUMBER_OF_STATUS_SCHEDULE_SHARDS = 20;
function StatusScheduleKeyChainSchema() {
  return v63.object({
    /** ユーザーキー  */
    userKey: UserKeySchema(),
    /** 予約日時 */
    scheduledAt: DateTimeSchema()
  });
}
__name(StatusScheduleKeyChainSchema, "StatusScheduleKeyChainSchema");
function Schema118() {
  return v63.object({
    /** エンティティクラス */
    class: EntityClassSchema(entity_class_values_exports.STATUS_SCHEDULE),
    /** 作成日時 */
    createdAt: CreationDateTimeSchema(),
    /**
     * **失敗回数**
     * 状態スケジュールの処理が失敗した回数。
     */
    failed: v63.optional(v63.pipe(v63.number(), v63.integer(), v63.minValue(0)), 0),
    /** **シャード** 日時順で参照する時にセカンダリインデックスの負荷を分散するためのシャード。 */
    shard: v63.optional(
      v63.pipe(v63.number(), v63.integer(), v63.minValue(0), v63.ltValue(NUMBER_OF_STATUS_SCHEDULE_SHARDS)),
      function() {
        return Math.floor(NUMBER_OF_STATUS_SCHEDULE_SHARDS * Math.random());
      }
    ),
    /** 更新日時 */
    updatedAt: UpdateDateTimeSchema(),
    /** **ユーザーキー** 入居者の識別子。 */
    userKey: v63.optional(UserKeySchema())
  });
}
__name(Schema118, "Schema1");
function Schema25() {
  return v63.variant("state", [
    v63.object({
      /**
       * **状態遷移時点での入居者の転倒リスク**
       * アラート機能の音声の選択に用いる。
       * 状態データに入居者が関連しない場合や未評価の場合は`undefined`となる。
       */
      fallRisk: v63.optional(FallRiskSchema()),
      /** 遷移予定の状態 */
      state: v63.literal(resident_state_values_exports.WANDERING),
      /** **状態データキー** 徘徊中判定を行う起点となった離床済みの状態データの識別子。 */
      statusKey: StatusKeySchema(),
      /** **遷移日時** 入居者の状態が遷移する場合の遷移日時。 */
      transitionedAt: DateTimeSchema()
    })
  ]);
}
__name(Schema25, "Schema2");
var StatusScheduleSchema = memoize(function() {
  return v63.intersect([StatusScheduleKeyChainSchema(), Schema118(), Schema25()]);
});
var PartialStatusScheduleSchema = memoize(function() {
  const schemaC = Schema25();
  return v63.pipe(
    v63.tuple([
      StatusScheduleKeyChainSchema(),
      v63.partial(Schema118()),
      v63.variant(schemaC.key, [
        v63.object({
          ...v63.partial(schemaC.options[0]).entries,
          [schemaC.key]: schemaC.options[0].entries[schemaC.key]
        })
      ])
    ]),
    v63.transform(function([a, b, c, ..._]) {
      _;
      return { ...a, ...b, ...c };
    })
  );
});
function parseStatusSchedule(statusSchedule, options) {
  return parse2(StatusScheduleSchema(), statusSchedule, options);
}
__name(parseStatusSchedule, "parseStatusSchedule");
function parsePartialStatusSchedule(statusSchedule, options) {
  return parse2(PartialStatusScheduleSchema(), statusSchedule, options);
}
__name(parsePartialStatusSchedule, "parsePartialStatusSchedule");

// src/models/entities/unique-constraint.ts
import * as v64 from "valibot";
function UniqueConstraintKeyChainSchema() {
  return v64.object({
    /** 一意制約キー  */
    uniqueConstraintKey: v64.string()
  });
}
__name(UniqueConstraintKeyChainSchema, "UniqueConstraintKeyChainSchema");
function Schema119() {
  return v64.object({
    /** エンティティクラス */
    class: EntityClassSchema(entity_class_values_exports.UNIQUE_CONSTRAINT),
    /** 旧Reha3.0から新Reha3.0に移行したかどうかのフラグ */
    migrated: v64.optional(v64.boolean()),
    /** 旧Reha3.0から新Reha3.0に移行した日時 */
    migratedAt: MigrationDateTimeSchema(),
    /** 移行元のデータベースのホスト名 */
    migratedFrom: v64.optional(v64.string()),
    /** 所有者識別子 */
    ownerIdentifier: v64.string()
  });
}
__name(Schema119, "Schema1");
var getUniqueConstraintSchema = memoize(function() {
  return v64.intersect([UniqueConstraintKeyChainSchema(), Schema119()]);
});
function generateUniqueConstraintKeys(entity) {
  const uniqueConstraintKeys = [];
  if ("emailAddress" in entity && "emailAddressLogin" in entity && entity.emailAddress && entity.emailAddressLogin) {
    uniqueConstraintKeys.push(["emailAddress", entity.emailAddress].join("."));
  }
  if ("phoneNumber" in entity && "phoneNumberLogin" in entity && entity.phoneNumber && entity.phoneNumberLogin) {
    uniqueConstraintKeys.push(["phoneNumber", entity.phoneNumber].join("."));
  }
  if ("uniqueString" in entity && entity.uniqueString) {
    uniqueConstraintKeys.push(["uniqueString", entity.class, entity.uniqueString].join("."));
  }
  return uniqueConstraintKeys;
}
__name(generateUniqueConstraintKeys, "generateUniqueConstraintKeys");
function parseUniqueConstraint(uniqueConstraint) {
  return v64.parse(getUniqueConstraintSchema(), uniqueConstraint);
}
__name(parseUniqueConstraint, "parseUniqueConstraint");

// src/models/entities/user.ts
import * as v65 from "valibot";
function UserKeyChain() {
  return v65.object({
    /** **ユーザーキー** (Cognitoユーザーの`username`属性) */
    userKey: UserKeySchema()
  });
}
__name(UserKeyChain, "UserKeyChain");
function Schema120() {
  return v65.object({
    /** エンティティクラス */
    class: EntityClassSchema(entity_class_values_exports.USER),
    /** 作成日時 */
    createdAt: CreationDateTimeSchema(),
    /** 削除フラグ */
    deleted: DefaultDeletionFlagSchema(),
    /** 削除日時 */
    deletedAt: DeletionDateTimeSchema(),
    /** ダミーフラグ */
    dummy: v65.optional(v65.boolean()),
    /** **メールアドレス** (Cognitoユーザーの`email`属性) */
    emailAddress: v65.nullable(getEmailAddressSchema()),
    /** メールアドレスログインフラグ */
    emailAddressLogin: v65.boolean(),
    /** 旧Reha3.0から新Reha3.0に移行したかどうかのフラグ */
    migrated: v65.optional(v65.boolean()),
    /** 旧Reha3.0から新Reha3.0に移行した日時 */
    migratedAt: MigrationDateTimeSchema(),
    /** 移行元のデータベースのホスト名 */
    migratedFrom: v65.optional(v65.string()),
    /** **名前** (Cognitoユーザーの`name`属性) */
    name: v65.pipe(v65.string(), v65.trim(), v65.maxGraphemes(32)),
    /** **`+`から始まる電話番号** (Cognitoユーザーの`phone_number`属性) */
    phoneNumber: v65.nullable(getPhoneNumberSchema()),
    /** 電話番号ログインフラグ */
    phoneNumberLogin: v65.boolean(),
    /** 更新日時 */
    updatedAt: UpdateDateTimeSchema()
  });
}
__name(Schema120, "Schema1");
var UserSchema = memoize(function() {
  return v65.intersect([UserKeyChain(), Schema120()]);
});
var getUserSchema = UserSchema;
function parseUser(user) {
  return v65.parse(UserSchema(), user);
}
__name(parseUser, "parseUser");
var PartialUserSchema = memoize(function() {
  return v65.pipe(
    v65.tuple([UserKeyChain(), v65.partial(Schema120())]),
    v65.transform(function([a, b, ..._]) {
      _;
      return { ...a, ...b };
    })
  );
});
function parsePartialUser(user) {
  return v65.parse(PartialUserSchema(), user);
}
__name(parsePartialUser, "parsePartialUser");

// src/models/entities/watchtower.ts
import { memoize as memoize8 } from "es-toolkit";
import * as v66 from "valibot";
var WatchtowerKeyChainSchema = memoize8(function() {
  return v66.object({
    /** ウォッチタワーキー */
    watchtowerKey: WatchtowerKeySchema()
  });
});
function Schema121() {
  return v66.object({
    /** エンティティクラス */
    class: EntityClassSchema(entity_class_values_exports.WATCHTOWER),
    /** 作成日時 */
    createdAt: CreationDateTimeSchema(),
    /** 作成者 */
    createdBy: UserKeySchema(),
    /** 削除フラグ */
    deleted: v66.optional(
      v66.picklist([values_exports2.DEFAULT, values_exports2.ARCHIVED]),
      values_exports2.DEFAULT
    ),
    /** 削除日時 */
    deletedAt: DeletionDateTimeSchema(),
    /** 名前 */
    name: v66.pipe(v66.string(), v66.minLength(1), v66.maxGraphemes(128)),
    /** 更新日時 */
    updatedAt: UpdateDateTimeSchema()
  });
}
__name(Schema121, "Schema1");
function Schema26() {
  return v66.variant("type", [
    v66.object({
      type: v66.literal(enumeration_exports17.EMAIL_ADDRESS),
      emailAddress: v66.pipe(v66.string(), v66.email())
    }),
    v66.object({
      type: v66.literal(enumeration_exports17.SLACK_INCOMING_WEBHOOK),
      url: v66.pipe(v66.string(), v66.url())
    })
  ]);
}
__name(Schema26, "Schema2");
var WatchtowerSchema = memoize8(function() {
  return v66.intersect([WatchtowerKeyChainSchema(), Schema121(), Schema26()]);
});
function parseWatchtower(watchtower, options) {
  return parse2(WatchtowerSchema(), watchtower, options);
}
__name(parseWatchtower, "parseWatchtower");
var PartialWatchtowerSchema = memoize8(function() {
  const schema2 = Schema26();
  return v66.pipe(
    v66.tuple([
      WatchtowerKeyChainSchema(),
      v66.partial(Schema121()),
      v66.optional(
        v66.variant(schema2.key, [
          v66.object({
            ...v66.partial(schema2.options[0]).entries,
            [schema2.key]: schema2.options[0].entries[schema2.key]
          }),
          v66.object({
            ...v66.partial(schema2.options[1]).entries,
            [schema2.key]: schema2.options[1].entries[schema2.key]
          })
        ])
      )
    ]),
    v66.transform(function([a, b, c, ..._]) {
      _;
      return { ...a, ...b, ...c };
    })
  );
});
function parsePartialWatchtower(watchtower, options) {
  return parse2(PartialWatchtowerSchema(), watchtower, options);
}
__name(parsePartialWatchtower, "parsePartialWatchtower");

// src/models/forms/assessment.ts
import * as v67 from "valibot";
var AssessmentInitializationFormSchema = memoize(function() {
  return v67.pipe(
    v67.object({
      assessments: v67.array(
        v67.object({
          simpleIndependenceLevelI: v67.optional(SimpleIndependenceLevelSchema()),
          simpleIndependenceLevelL: v67.optional(SimpleIndependenceLevelSchema()),
          simpleIndependenceLevelQ: v67.optional(SimpleIndependenceLevelSchema()),
          simpleIndependenceLevelR: v67.optional(SimpleIndependenceLevelSchema()),
          userKey: UserKeySchema()
        })
      )
    }),
    v67.rawCheck(function({ addIssue, dataset }) {
      if (dataset.typed) {
        for (let x = 0; x < dataset.value.assessments.length; x++) {
          const {
            simpleIndependenceLevelI,
            simpleIndependenceLevelL,
            simpleIndependenceLevelQ,
            simpleIndependenceLevelR
          } = dataset.value.assessments[x];
          if (simpleIndependenceLevelI || simpleIndependenceLevelL || simpleIndependenceLevelQ || simpleIndependenceLevelR) {
            for (const [k, v131] of [
              ["simpleIndependenceLevelI", simpleIndependenceLevelI],
              ["simpleIndependenceLevelL", simpleIndependenceLevelL],
              ["simpleIndependenceLevelQ", simpleIndependenceLevelQ],
              ["simpleIndependenceLevelR", simpleIndependenceLevelR]
            ]) {
              if (!v131) {
                addIssue({
                  expected: ALL_SIMPLE_INDEPENDENCE_LEVELS.join(" | "),
                  message: enumeration_exports.INPUT_REQUIRED,
                  path: [
                    {
                      type: "object",
                      key: "assessments",
                      input: dataset.value,
                      origin: "value",
                      value: dataset.value.assessments
                    },
                    {
                      type: "array",
                      key: x,
                      input: dataset.value.assessments,
                      origin: "value",
                      value: dataset.value.assessments[x]
                    },
                    {
                      type: "unknown",
                      key: k,
                      input: dataset.value.assessments[x],
                      origin: "value",
                      value: v131
                    }
                  ],
                  received: String(v131)
                });
              }
            }
          }
        }
      }
      return true;
    })
  );
});
var SimpleIndependenceLevelBatchRegistrationRowSchema = memoize(function() {
  const simpleIndependenceLevelSchema = v67.union([
    v67.pipe(
      v67.picklist(["1", "\uFF11"]),
      v67.transform(function() {
        return 1;
      })
    ),
    v67.pipe(
      v67.picklist(["2", "\uFF12"]),
      v67.transform(function() {
        return 2;
      })
    ),
    v67.pipe(
      v67.picklist(["3", "\uFF13"]),
      v67.transform(function() {
        return 3;
      })
    ),
    v67.pipe(
      v67.literal(""),
      v67.transform(function() {
        return void 0;
      })
    )
  ]);
  return v67.pipe(
    v67.tuple([
      v67.union([
        UserKeySchema(),
        v67.pipe(
          v67.literal(""),
          v67.transform(function() {
            return void 0;
          })
        )
      ]),
      /** 補完時に参照する入居者名 */
      v67.string(),
      // 順序が一般的な定義と少し異なるので注意する。
      simpleIndependenceLevelSchema,
      simpleIndependenceLevelSchema,
      simpleIndependenceLevelSchema,
      simpleIndependenceLevelSchema
    ]),
    v67.transform(function([
      userKey,
      name,
      // 順序が一般的な定義と少し異なるので注意する。
      simpleIndependenceLevelL,
      simpleIndependenceLevelI,
      simpleIndependenceLevelQ,
      simpleIndependenceLevelR
    ]) {
      return {
        userKey,
        name,
        simpleIndependenceLevelI,
        simpleIndependenceLevelL,
        simpleIndependenceLevelQ,
        simpleIndependenceLevelR
      };
    })
  );
});
function toSimpleIndependenceLevelBatchRegistrationRow(resident) {
  return [
    resident.userKey ?? "",
    resident.name,
    // 順序が一般的な定義と少し異なるので注意する。
    resident.simpleIndependenceLevelL ?? "",
    resident.simpleIndependenceLevelI ?? "",
    resident.simpleIndependenceLevelQ ?? "",
    resident.simpleIndependenceLevelR ?? ""
  ].join(",");
}
__name(toSimpleIndependenceLevelBatchRegistrationRow, "toSimpleIndependenceLevelBatchRegistrationRow");
function SimpleIndependenceLevelBatchRegistrationHeaderRows(dependencies) {
  const { translate } = dependencies;
  return [
    [
      translate("%UserKey.0%"),
      translate("%Name.0%"),
      // 順序が一般的な定義と少し異なるので注意する。
      translate("%FimDomain." + enumeration_exports11.LOCOMOTION + ".0%") + " " + translate("%FimItem." + fim_item_values_exports.WALK_WHEELCHAIR + ".0%") + " [" + ALL_SIMPLE_INDEPENDENCE_LEVELS.join(" / ") + "]",
      translate("%FimDomain." + enumeration_exports11.TRANSFER + ".0%") + " " + translate("%FimItem." + fim_item_values_exports.BED_CHAIR_WHEELCHAIR + ".0%") + " [" + ALL_SIMPLE_INDEPENDENCE_LEVELS.join(" / ") + "]",
      translate("%FimDomain." + enumeration_exports11.SOCIAL_COGNITION + ".0%") + " " + translate("%FimItem." + fim_item_values_exports.PROBLEM_SOLVING + ".0%") + " [" + ALL_SIMPLE_INDEPENDENCE_LEVELS.join(" / ") + "]",
      translate("%FimDomain." + enumeration_exports11.SOCIAL_COGNITION + ".0%") + " " + translate("%FimItem." + fim_item_values_exports.MEMORY + ".0%") + " [" + ALL_SIMPLE_INDEPENDENCE_LEVELS.join(" / ") + "]"
    ].join(","),
    [
      "",
      translate("%SimpleIndependenceLevelBatchRegistration.4%"),
      translate("%SimpleIndependenceLevelBatchRegistration.5%"),
      "",
      "",
      ""
    ].join(",")
  ];
}
__name(SimpleIndependenceLevelBatchRegistrationHeaderRows, "SimpleIndependenceLevelBatchRegistrationHeaderRows");
var AssessmentRegistrationFormSchema = memoize(function() {
  const independenceLevelSchema = v67.message(IndependenceLevelSchema(), enumeration_exports.INPUT_REQUIRED);
  return v67.object({
    assessedAt: v67.message(DateTimeSchema(), enumeration_exports.INVALID_DATE_TIME),
    0: independenceLevelSchema,
    1: independenceLevelSchema,
    2: independenceLevelSchema,
    3: independenceLevelSchema,
    4: independenceLevelSchema,
    5: independenceLevelSchema,
    6: independenceLevelSchema,
    7: independenceLevelSchema,
    8: independenceLevelSchema,
    9: independenceLevelSchema,
    10: independenceLevelSchema,
    11: independenceLevelSchema,
    12: independenceLevelSchema,
    13: independenceLevelSchema,
    14: independenceLevelSchema,
    15: independenceLevelSchema,
    16: independenceLevelSchema,
    17: independenceLevelSchema
  });
});

// src/models/forms/bed.ts
import * as v68 from "valibot";
var getBedAllocationFormSchema = memoize(function() {
  return v68.pipe(
    v68.object({
      allocations: v68.array(
        v68.object({
          bedKey: BedKeySchema(),
          sensorKey: v68.nullish(SensorKeySchema()),
          userKey: v68.nullish(UserKeySchema())
        })
      )
    }),
    v68.rawCheck(function({ addIssue, dataset }) {
      if (dataset.typed) {
        const map = /* @__PURE__ */ new Map();
        for (let x = 0; x < dataset.value.allocations.length; x++) {
          const { sensorKey, userKey } = dataset.value.allocations[x];
          if (userKey) {
            const y = map.get(userKey);
            if (y !== void 0) {
              addIssue({
                expected: String(y + 1),
                message: enumeration_exports.INPUT_DUPLICATED,
                path: [
                  {
                    type: "object",
                    key: "allocations",
                    input: dataset.value,
                    origin: "value",
                    value: dataset.value.allocations
                  },
                  {
                    type: "array",
                    key: x,
                    input: dataset.value.allocations,
                    origin: "value",
                    value: dataset.value.allocations[x]
                  },
                  {
                    type: "unknown",
                    key: "userKey",
                    input: dataset.value.allocations[x]?.userKey,
                    origin: "value",
                    value: dataset.value.allocations[x]?.userKey
                  }
                ],
                received: String(x + 1)
              });
            }
            map.set(userKey, x);
          }
          if (sensorKey) {
            const y = map.get(sensorKey);
            if (y !== void 0) {
              addIssue({
                expected: String(y + 1),
                message: enumeration_exports.INPUT_DUPLICATED,
                path: [
                  {
                    type: "object",
                    key: "allocations",
                    input: dataset.value,
                    origin: "value",
                    value: dataset.value.allocations
                  },
                  {
                    type: "array",
                    key: x,
                    input: dataset.value.allocations,
                    origin: "value",
                    value: dataset.value.allocations[x]
                  },
                  {
                    type: "unknown",
                    key: "sensorKey",
                    input: dataset.value.allocations[x]?.sensorKey,
                    origin: "value",
                    value: dataset.value.allocations[x]?.sensorKey
                  }
                ],
                received: String(x + 1)
              });
            }
            map.set(sensorKey, x);
          }
        }
      }
      return true;
    })
  );
});

// src/models/forms/facility-registration-form-data.ts
import * as v69 from "valibot";
var getFacilityRegistrationFormDataSchema = memoize(function() {
  return v69.object({
    address: v69.pipe(
      v69.string(enumeration_exports.INPUT_REQUIRED),
      v69.trim(),
      v69.nonEmpty(enumeration_exports.INPUT_REQUIRED),
      v69.maxLength(512, enumeration_exports.TOO_MANY_CHARACTERS)
    ),
    emailAddress: v69.pipe(
      v69.string(enumeration_exports.INPUT_REQUIRED),
      v69.trim(),
      v69.nonEmpty(enumeration_exports.INPUT_REQUIRED),
      v69.rfcEmail(enumeration_exports.INVALID_EMAIL_ADDRESS_INPUT),
      v69.maxLength(512, enumeration_exports.TOO_MANY_CHARACTERS)
    ),
    emailAddressLogin: v69.boolean(enumeration_exports.UNEXPECTED),
    name: v69.pipe(
      v69.string(enumeration_exports.INPUT_REQUIRED),
      v69.trim(),
      v69.nonEmpty(enumeration_exports.INPUT_REQUIRED),
      v69.maxGraphemes(32, enumeration_exports.TOO_MANY_CHARACTERS)
    ),
    organization: v69.pipe(
      v69.custom(function(input) {
        return input !== null;
      }, enumeration_exports.INPUT_REQUIRED),
      v69.message(OrganizationSchema(), enumeration_exports.UNEXPECTED)
    ),
    password: v69.pipe(
      v69.string(enumeration_exports.INPUT_REQUIRED),
      v69.trim(),
      v69.minLength(6, enumeration_exports.TOO_FEW_CHARACTERS),
      v69.maxLength(256, enumeration_exports.TOO_MANY_CHARACTERS),
      v69.regex(PASSWORD_REGEX)
    ),
    phoneNumber: v69.pipe(
      v69.string(enumeration_exports.INPUT_REQUIRED),
      v69.trim(),
      v69.nonEmpty(enumeration_exports.INPUT_REQUIRED),
      v69.maxLength(24, enumeration_exports.TOO_MANY_CHARACTERS),
      v69.regex(PHONE_NUMBER_REGEX, enumeration_exports.INVALID_PHONE_NUMBER_INPUT),
      v69.transform(normalizePhoneNumber)
    ),
    phoneNumberLogin: v69.boolean(enumeration_exports.UNEXPECTED),
    postalCode: v69.pipe(
      v69.string(enumeration_exports.INPUT_REQUIRED),
      v69.trim(),
      v69.nonEmpty(enumeration_exports.INPUT_REQUIRED),
      v69.regex(/^\d{7}$/, enumeration_exports.INVALID_POSTAL_CODE_INPUT)
    ),
    remark: v69.pipe(
      v69.string(enumeration_exports.INPUT_REQUIRED),
      v69.trim(),
      v69.maxLength(1024, enumeration_exports.TOO_MANY_CHARACTERS)
    ),
    representativeName: v69.pipe(
      v69.string(enumeration_exports.INPUT_REQUIRED),
      v69.trim(),
      v69.nonEmpty(enumeration_exports.INPUT_REQUIRED)
    )
  });
});
var getFacilityRegistrationFormDataDefaultValues = memoize(
  function() {
    return {
      address: "",
      emailAddress: "",
      emailAddressLogin: false,
      name: "",
      password: "",
      postalCode: "",
      representativeName: "",
      organization: null,
      phoneNumber: "",
      phoneNumberLogin: false,
      remark: ""
    };
  }
);

// src/models/forms/facility-staff.ts
import { uniq } from "es-toolkit";
import * as v70 from "valibot";
var FacilityStaffRegistrationFormSchema = memoize(function() {
  return v70.object({
    emailAddress: v70.pipe(
      v70.string(),
      v70.trim(),
      v70.nonEmpty(enumeration_exports.INPUT_REQUIRED),
      v70.rfcEmail(enumeration_exports.INVALID_EMAIL_ADDRESS_INPUT)
    ),
    name: v70.pipe(
      v70.string(),
      v70.trim(),
      v70.minLength(1, enumeration_exports.INPUT_REQUIRED),
      v70.maxGraphemes(64, enumeration_exports.TOO_MANY_CHARACTERS)
    ),
    password: v70.message(PasswordSchema(), enumeration_exports.INVALID_PASSWORD_INPUT),
    roles: v70.pipe(
      v70.array(v70.message(FacilityStaffRoleSchema(), enumeration_exports.UNEXPECTED)),
      v70.transform(function(input) {
        return uniq(input).sort();
      })
    ),
    tier: v70.message(FacilityStaffTierSchema(), enumeration_exports.UNEXPECTED),
    userKey: v70.union([UserKeySchema(), v70.literal("")], enumeration_exports.INVALID_USER_KEY_FORMAT)
  });
});
var FacilityStaffModificationFormSchema = memoize(function() {
  return v70.object({
    emailAddress: v70.optional(
      v70.pipe(
        v70.string(),
        v70.trim(),
        v70.nonEmpty(enumeration_exports.INPUT_REQUIRED),
        v70.rfcEmail(enumeration_exports.INVALID_EMAIL_ADDRESS_INPUT)
      )
    ),
    name: v70.pipe(
      v70.string(),
      v70.trim(),
      v70.minLength(1, enumeration_exports.INPUT_REQUIRED),
      v70.maxGraphemes(64, enumeration_exports.TOO_MANY_CHARACTERS)
    ),
    password: v70.optional(v70.message(PasswordSchema(), enumeration_exports.INVALID_PASSWORD_INPUT)),
    roles: v70.message(v70.array(FacilityStaffRoleSchema()), enumeration_exports.UNEXPECTED),
    tier: v70.message(FacilityStaffTierSchema(), enumeration_exports.UNEXPECTED)
  });
});

// src/models/forms/fall.ts
import * as v71 from "valibot";
var FallRegistrationFormSchema = memoize(function() {
  return v71.pipe(
    v71.object({ falls: v71.array(v71.object({ fellAt: DateTimeSchema() })) }),
    v71.rawCheck(function({ addIssue, dataset }) {
      if (dataset.typed) {
        const map = /* @__PURE__ */ new Map();
        for (let x = 0; x < dataset.value.falls.length; x++) {
          const { fellAt } = dataset.value.falls[x];
          const y = map.get(fellAt.toString());
          if (y !== void 0) {
            addIssue({
              expected: String(y + 1),
              message: enumeration_exports.INPUT_DUPLICATED,
              path: [
                {
                  type: "object",
                  key: "falls",
                  input: dataset.value,
                  origin: "value",
                  value: dataset.value.falls
                },
                {
                  type: "array",
                  key: x,
                  input: dataset.value.falls,
                  origin: "value",
                  value: dataset.value.falls[x]
                },
                {
                  type: "unknown",
                  key: "fellAt",
                  input: dataset.value.falls[x]?.fellAt,
                  origin: "value",
                  value: dataset.value.falls[x]?.fellAt
                }
              ],
              received: String(x + 1)
            });
          }
          map.set(fellAt.toString(), x);
        }
      }
    })
  );
});

// src/models/forms/login-form-data.ts
import * as v72 from "valibot";
var getLoginFormDataSchema = memoize(function() {
  return v72.object({
    userInformation: v72.pipe(v72.string(), v72.trim(), v72.nonEmpty(enumeration_exports.INPUT_REQUIRED)),
    password: v72.pipe(v72.string(), v72.trim(), v72.nonEmpty(enumeration_exports.INPUT_REQUIRED))
  });
});
var getLoginFormDataDefaultValues = memoize(function() {
  return {
    userInformation: "",
    password: ""
  };
});

// src/models/forms/organization-registration-form-data.ts
import * as v73 from "valibot";
var getOrganizationRegistrationFormDataSchema = memoize(function() {
  return v73.object({
    address: v73.pipe(v73.string(), v73.trim(), v73.nonEmpty(enumeration_exports.INPUT_REQUIRED)),
    emailAddress: v73.pipe(
      v73.string(),
      v73.trim(),
      v73.nonEmpty(enumeration_exports.INPUT_REQUIRED),
      v73.rfcEmail(enumeration_exports.INVALID_EMAIL_ADDRESS_INPUT)
    ),
    emailAddressLogin: v73.boolean(enumeration_exports.UNEXPECTED),
    name: v73.pipe(
      v73.string(),
      v73.trim(),
      v73.nonEmpty(enumeration_exports.INPUT_REQUIRED),
      v73.maxGraphemes(32, enumeration_exports.TOO_MANY_CHARACTERS)
    ),
    password: v73.message(PasswordSchema(), enumeration_exports.INVALID_PASSWORD_INPUT),
    postalCode: v73.pipe(
      v73.string(),
      v73.trim(),
      v73.nonEmpty(enumeration_exports.INPUT_REQUIRED),
      v73.regex(/^\d{7}$/, enumeration_exports.INVALID_POSTAL_CODE_INPUT)
    ),
    representativeName: v73.pipe(v73.string(), v73.trim(), v73.nonEmpty(enumeration_exports.INPUT_REQUIRED))
  });
});
var getOrganizationRegistrationFormDataDefaultValues = memoize(function() {
  return {
    address: "",
    emailAddress: "",
    emailAddressLogin: false,
    name: "",
    password: "",
    postalCode: "",
    representativeName: ""
  };
});

// src/models/forms/provider.ts
import * as v74 from "valibot";
var getAamsServerRegistrationFormSchema = memoize(function() {
  return v74.object({
    facility: v74.nullable(FacilitySchema()),
    name: v74.pipe(
      v74.string(),
      v74.trim(),
      v74.minLength(1, enumeration_exports.INPUT_REQUIRED),
      v74.maxGraphemes(48, enumeration_exports.TOO_MANY_CHARACTERS)
    ),
    organization: v74.nullable(OrganizationSchema()),
    type: v74.literal(values_exports6.AAMS_SERVER)
  });
});
var getAnsielApiRegistrationFormSchema = memoize(function() {
  return v74.object({
    apiKey: v74.string(),
    entryPoint: v74.pipe(
      v74.string(enumeration_exports.INPUT_REQUIRED),
      v74.trim(),
      v74.transform(function(input) {
        return input.replace(/\/+$/, "");
      }),
      v74.regex(/^https:\/\/.+[^/]$/, enumeration_exports.INVALID_ENTRY_POINT_INPUT)
    ),
    facility: v74.nullable(FacilitySchema()),
    name: v74.pipe(
      v74.string(),
      v74.trim(),
      v74.minLength(1, enumeration_exports.INPUT_REQUIRED),
      v74.maxGraphemes(48, enumeration_exports.TOO_MANY_CHARACTERS)
    ),
    organization: v74.nullable(OrganizationSchema()),
    organizationCode: v74.string(),
    relayTo: v74.object({
      [values_exports.ANSIEL_PUSH_NOTIFICATION]: v74.array(
        v74.pipe(
          v74.string(enumeration_exports.INVALID_HTTPS_URL),
          v74.url(enumeration_exports.INVALID_HTTPS_URL),
          v74.startsWith("https://", enumeration_exports.INVALID_HTTPS_URL)
        )
      )
    }),
    password: v74.string(),
    type: v74.literal(values_exports6.ANSIEL_API)
  });
});

// src/models/forms/resident.ts
import * as v75 from "valibot";
var getResidentRegistrationFormSchema = memoize(function() {
  return v75.object({
    /** 同意フラグ */
    agreed: v75.boolean(),
    /** 誕生日 */
    birthday: v75.message(DateSchema(), enumeration_exports.INVALID_DATE),
    /** 表示名 */
    displayName: v75.pipe(v75.string(), v75.trim(), v75.maxGraphemes(32, enumeration_exports.TOO_MANY_CHARACTERS)),
    /** 身長[cm] */
    height: v75.pipe(
      v75.union([
        v75.pipe(
          v75.string(),
          v75.trim(),
          v75.nonEmpty(enumeration_exports.INPUT_REQUIRED),
          v75.transform(function(input) {
            return Number.parseFloat(input);
          })
        ),
        v75.number(enumeration_exports.INPUT_REQUIRED)
      ]),
      v75.gtValue(0, enumeration_exports.TOO_SHORT_HEIGHT),
      v75.maxValue(999, enumeration_exports.TOO_TALL_HEIGHT)
    ),
    /** 名前(入居者の本名) */
    name: v75.pipe(
      v75.string(),
      v75.trim(),
      v75.nonEmpty(enumeration_exports.INPUT_REQUIRED),
      v75.maxGraphemes(64, enumeration_exports.TOO_MANY_CHARACTERS)
    ),
    /** 発音名 */
    pronunciationName: v75.pipe(
      v75.string(),
      v75.trim(),
      v75.maxGraphemes(32, enumeration_exports.TOO_MANY_CHARACTERS)
    ),
    /** 性別 */
    sex: SexSchema(),
    /** ユーザーキー */
    userKey: v75.optional(v75.message(UserKeySchema(), enumeration_exports.INVALID_USER_KEY_FORMAT)),
    /** 体重[kg] */
    weight: v75.pipe(
      v75.union([
        v75.pipe(
          v75.string(),
          v75.trim(),
          v75.nonEmpty(enumeration_exports.INPUT_REQUIRED),
          v75.transform(function(input) {
            return Number.parseFloat(input);
          })
        ),
        v75.number(enumeration_exports.INPUT_REQUIRED)
      ]),
      v75.gtValue(0, enumeration_exports.TOO_LIGHT_WEIGHT),
      v75.maxValue(999, enumeration_exports.TOO_HEAVY_WEIGHT)
    )
  });
});
var ResidentModificationFormSchema = memoize(function() {
  return v75.object({
    /** 同意フラグ */
    agreed: v75.boolean(),
    /** 誕生日 */
    birthday: v75.message(DateSchema(), enumeration_exports.INVALID_DATE),
    /** 削除フラグ */
    deleted: v75.picklist([values_exports2.DEFAULT, values_exports2.ARCHIVED], enumeration_exports.INVALID_DATA),
    /** 表示名 */
    displayName: v75.pipe(v75.string(), v75.trim(), v75.maxGraphemes(32, enumeration_exports.TOO_MANY_CHARACTERS)),
    /** 身長[cm] */
    height: v75.pipe(
      v75.union([
        v75.pipe(
          v75.string(),
          v75.trim(),
          v75.nonEmpty(enumeration_exports.INPUT_REQUIRED),
          v75.transform(function(input) {
            return Number.parseFloat(input);
          })
        ),
        v75.number(enumeration_exports.INPUT_REQUIRED)
      ]),
      v75.gtValue(0, enumeration_exports.TOO_SHORT_HEIGHT),
      v75.maxValue(999, enumeration_exports.TOO_TALL_HEIGHT)
    ),
    /** 名前(入居者の本名) */
    name: v75.pipe(
      v75.string(),
      v75.trim(),
      v75.nonEmpty(enumeration_exports.INPUT_REQUIRED),
      v75.maxGraphemes(64, enumeration_exports.TOO_MANY_CHARACTERS)
    ),
    /** 発音名 */
    pronunciationName: v75.pipe(
      v75.string(),
      v75.trim(),
      v75.maxGraphemes(32, enumeration_exports.TOO_MANY_CHARACTERS)
    ),
    /** 性別 */
    sex: SexSchema(),
    /** 体重[kg] */
    weight: v75.pipe(
      v75.union([
        v75.pipe(
          v75.string(),
          v75.trim(),
          v75.nonEmpty(enumeration_exports.INPUT_REQUIRED),
          v75.transform(function(input) {
            return Number.parseFloat(input);
          })
        ),
        v75.number(enumeration_exports.INPUT_REQUIRED)
      ]),
      v75.gtValue(0, enumeration_exports.TOO_LIGHT_WEIGHT),
      v75.maxValue(999, enumeration_exports.TOO_HEAVY_WEIGHT)
    )
  });
});
function ResidentBatchRegistrationRowSchema(dependencies) {
  const { translate } = dependencies;
  return v75.pipe(
    v75.tuple([
      v75.union([
        UserKeySchema(),
        v75.pipe(
          v75.literal(""),
          v75.transform(function() {
            return void 0;
          })
        )
      ]),
      v75.pipe(v75.string(), v75.trim(), v75.maxGraphemes(32, enumeration_exports.TOO_MANY_CHARACTERS)),
      v75.pipe(v75.string(), v75.trim(), v75.maxGraphemes(32, enumeration_exports.TOO_MANY_CHARACTERS)),
      v75.pipe(v75.string(), v75.trim(), v75.maxGraphemes(32, enumeration_exports.TOO_MANY_CHARACTERS)),
      v75.union([
        v75.pipe(
          v75.literal(translate("%Sex." + values_exports9.MALE + ".0%")),
          v75.transform(function() {
            return values_exports9.MALE;
          })
        ),
        v75.pipe(
          v75.literal(translate("%Sex." + values_exports9.FEMALE + ".0%")),
          v75.transform(function() {
            return values_exports9.FEMALE;
          })
        )
      ]),
      v75.pipe(
        v75.string(),
        v75.trim(),
        v75.nonEmpty(enumeration_exports.INPUT_REQUIRED),
        v75.transform(function(input) {
          return Number.parseFloat(input);
        }),
        v75.gtValue(0, enumeration_exports.TOO_SHORT_HEIGHT),
        v75.maxValue(999, enumeration_exports.TOO_TALL_HEIGHT)
      ),
      v75.pipe(
        v75.string(),
        v75.trim(),
        v75.nonEmpty(enumeration_exports.INPUT_REQUIRED),
        v75.transform(function(input) {
          return Number.parseFloat(input);
        }),
        v75.gtValue(0, enumeration_exports.TOO_LIGHT_WEIGHT),
        v75.maxValue(999, enumeration_exports.TOO_HEAVY_WEIGHT)
      ),
      DateSchema(),
      v75.union([
        v75.pipe(
          v75.union([v75.literal("true"), v75.literal("TRUE")]),
          v75.transform(function() {
            return true;
          })
        ),
        v75.pipe(
          v75.union([v75.literal("false"), v75.literal("FALSE"), v75.literal("")]),
          v75.transform(function() {
            return false;
          })
        )
      ])
    ]),
    v75.transform(function([
      userKey,
      name,
      displayName,
      pronunciationName,
      sex,
      height,
      weight,
      birthday,
      agreed
    ]) {
      return {
        userKey,
        name,
        displayName,
        pronunciationName,
        sex,
        height,
        weight,
        birthday,
        agreed
      };
    })
  );
}
__name(ResidentBatchRegistrationRowSchema, "ResidentBatchRegistrationRowSchema");
function toResidentBatchRegistrationRow(resident, dependencies) {
  const { translate } = dependencies;
  return [
    resident.userKey ?? "",
    resident.name,
    resident.displayName,
    resident.pronunciationName,
    resident.sex === values_exports9.MALE ? translate("%Sex." + values_exports9.MALE + ".0%") : translate("%Sex." + values_exports9.FEMALE + ".0%"),
    resident.height,
    resident.weight,
    resident.birthday.toString(),
    resident.agreed ?? false
  ].join(",");
}
__name(toResidentBatchRegistrationRow, "toResidentBatchRegistrationRow");
function ResidentBatchRegistrationHeaderRows(dependencies) {
  const { translate } = dependencies;
  return [
    [
      translate("%UserKey.0%") + " (" + translate("%ResidentBatchRegistration.7%") + ")",
      translate("%Name.0%"),
      translate("%DisplayName.0%"),
      translate("%PronunciationName.0%"),
      translate("%Sex.0%") + " [" + ALL_SEXES.map(function(sex) {
        return translate("%Sex." + sex + ".0%");
      }).join(" / ") + "]",
      translate("%Height.0%") + " [cm]",
      translate("%Weight.0%") + " [kg]",
      translate("%Birthday.0%") + " [YYYY/MM/DD]",
      translate("%PrivacyPolicy.1%") + " [TRUE / FALSE]"
    ].join(",")
  ];
}
__name(ResidentBatchRegistrationHeaderRows, "ResidentBatchRegistrationHeaderRows");

// src/models/forms/sensor.ts
import * as v76 from "valibot";
var getAamsRegistrationFormSchema = memoize(function() {
  return v76.object({
    facility: v76.nullable(FacilitySchema()),
    macAddress: v76.message(MacAddressSchema(), enumeration_exports.INVALID_DATA),
    name: v76.pipe(
      v76.string(),
      v76.trim(),
      v76.minLength(1, enumeration_exports.INPUT_REQUIRED),
      v76.maxGraphemes(48, enumeration_exports.TOO_MANY_CHARACTERS)
    ),
    organization: v76.nullable(OrganizationSchema()),
    provider: v76.pipe(
      v76.custom(function(input) {
        return input !== null;
      }, enumeration_exports.INPUT_REQUIRED),
      v76.message(ProviderSchema(), enumeration_exports.UNEXPECTED)
    ),
    type: v76.literal(values_exports7.AAMS)
  });
});
var getAnsielRegistrationFormSchema = memoize(function() {
  return v76.object({
    facility: v76.nullable(FacilitySchema()),
    name: v76.pipe(
      v76.string(),
      v76.trim(),
      v76.minLength(1, enumeration_exports.INPUT_REQUIRED),
      v76.maxGraphemes(48, enumeration_exports.TOO_MANY_CHARACTERS)
    ),
    organization: v76.nullable(OrganizationSchema()),
    provider: v76.pipe(
      v76.custom(function(input) {
        return input !== null;
      }, enumeration_exports.INPUT_REQUIRED),
      v76.message(ProviderSchema(), enumeration_exports.UNEXPECTED)
    ),
    /**
     * **プッシュ通知有効化フラグ**
     * ANSIELのプッシュ通知機能を利用する場合、`true`にする。
     * このフラグを有効化した場合、ANSIELのプッシュ通知機能を利用するための登録を行う。
     */
    pushNotificationEnabled: v76.boolean(),
    serialNumber: v76.pipe(v76.string(), v76.trim(), v76.minLength(1, enumeration_exports.INPUT_REQUIRED)),
    type: v76.literal(values_exports7.ANSIEL)
  });
});
function SensorBatchRegistrationRowSchema(dependencies) {
  const { translate } = dependencies;
  const providerKeySchema = v76.union([
    ProviderKeySchema(),
    v76.pipe(
      v76.literal(""),
      v76.transform(function() {
        return void 0;
      })
    )
  ]);
  const sensorKeySchema = v76.union([
    SensorKeySchema(),
    v76.pipe(
      v76.literal(""),
      v76.transform(function() {
        return void 0;
      })
    )
  ]);
  const nameSchema = v76.pipe(
    v76.string(enumeration_exports.UNEXPECTED),
    v76.trim(),
    v76.nonEmpty(enumeration_exports.INPUT_REQUIRED),
    v76.maxGraphemes(48, enumeration_exports.TOO_MANY_CHARACTERS)
  );
  return v76.pipe(
    v76.union([
      v76.tuple([
        providerKeySchema,
        sensorKeySchema,
        nameSchema,
        v76.pipe(
          v76.literal(translate("%SensorType." + values_exports7.AAMS + ".0%")),
          v76.transform(function() {
            return values_exports7.AAMS;
          })
        ),
        MacAddressSchema()
      ]),
      v76.tuple([
        providerKeySchema,
        sensorKeySchema,
        nameSchema,
        v76.pipe(
          v76.literal(translate("%SensorType." + values_exports7.ANSIEL + ".0%")),
          v76.transform(function() {
            return values_exports7.ANSIEL;
          })
        ),
        AnsielSerialNumberSchema()
      ])
    ]),
    v76.transform(function([providerKey, sensorKey, name, type, ...properties]) {
      switch (type) {
        case values_exports7.AAMS:
          return { providerKey, sensorKey, name, type, macAddress: properties[0] };
        case values_exports7.ANSIEL:
          return { providerKey, sensorKey, name, type, serialNumber: properties[0] };
        default:
          return { providerKey, sensorKey, name, type: "Unknown" };
      }
    })
  );
}
__name(SensorBatchRegistrationRowSchema, "SensorBatchRegistrationRowSchema");
function toSensorBatchRegistrationRow(sensor, dependencies) {
  const { translate } = dependencies;
  switch (sensor.type) {
    case values_exports7.AAMS:
      return [
        sensor.providerKey ?? "",
        sensor.sensorKey ?? "",
        sensor.name,
        translate("%SensorType." + sensor.type + ".0%"),
        sensor.macAddress
      ].join(",");
    case values_exports7.ANSIEL:
      return [
        sensor.providerKey ?? "",
        sensor.sensorKey ?? "",
        sensor.name,
        translate("%SensorType." + sensor.type + ".0%"),
        sensor.serialNumber
      ].join(",");
    default:
      throw new UniversalError(enumeration_exports.UNEXPECTED, "\u4E00\u62EC\u5165\u529B\u306B\u5BFE\u5FDC\u3057\u3066\u3044\u306A\u3044\u30BB\u30F3\u30B5\u30FC\u7A2E\u5225\u3067\u3059\u3002");
  }
}
__name(toSensorBatchRegistrationRow, "toSensorBatchRegistrationRow");
function SensorBatchRegistrationHeaderRows(dependencies) {
  const { translate } = dependencies;
  return [
    [
      translate("%ProviderKey.0%") + " (" + translate("%SensorBatchRegistration.7%") + ")",
      translate("%SensorKey.0%") + " (" + translate("%SensorBatchRegistration.7%") + ")",
      translate("%SensorName.0%"),
      translate("%SensorType.0%") + " [" + ALL_SENSOR_TYPES.map(function(sensorType) {
        return translate("%SensorType." + sensorType + ".0%");
      }).join(" / ") + "]"
    ].join(","),
    [
      "",
      "",
      "",
      translate("%SensorType." + values_exports7.AAMS + ".0%") + " \u2192",
      translate("%MacAddress.0%")
    ].join(","),
    [
      "",
      "",
      "",
      translate("%SensorType." + values_exports7.ANSIEL + ".0%") + " \u2192",
      translate("%SerialNumber.0%")
    ]
  ];
}
__name(SensorBatchRegistrationHeaderRows, "SensorBatchRegistrationHeaderRows");

// src/models/functions/index.ts
var functions_exports = {};
__export(functions_exports, {
  AllocateBed: () => allocate_bed_exports,
  AssessResidents: () => assess_residents_exports,
  BatchData: () => batch_data_exports,
  CheckStatusSchedules: () => check_status_schedules_exports,
  ConfirmStatus: () => confirm_status_exports,
  CreateFacility: () => create_facility_exports,
  CreateOrganization: () => create_organization_exports,
  CreateProvider: () => create_provider_exports,
  CreateResident: () => create_resident_exports,
  CreateSensor: () => create_sensor_exports,
  DeleteOldInstallations: () => delete_old_installations_exports,
  DeleteResidentImage: () => delete_resident_image_exports,
  DeleteStorageObject: () => delete_storage_object_exports,
  FindBeds: () => find_beds_exports,
  FindFacilities: () => find_facilities_exports,
  FindFallRiskEntries: () => find_fall_risk_entries_exports,
  FindFallScoreEntries: () => find_fall_score_entries_exports,
  FindGroups: () => find_groups_exports,
  FindIndependenceLevelEntries: () => find_independence_level_entries_exports,
  FindInstallations: () => find_installations_exports,
  FindOrganizations: () => find_organizations_exports,
  FindProviders: () => find_providers_exports,
  FindResidents: () => find_residents_exports,
  FindSensors: () => find_sensors_exports,
  FindStatuses: () => find_statuses_exports,
  GenerateResidentImageGetUrl: () => generate_resident_image_get_url_exports,
  GenerateResidentImagePutUrl: () => generate_resident_image_put_url_exports,
  GenerateStorageObjectUrl: () => generate_storage_object_url_exports,
  ModifyBed: () => modify_bed_exports,
  ModifyFacility: () => modify_facility_exports,
  ModifyFacilityStaff: () => modify_facility_staff_exports,
  ModifyGroup: () => modify_group_exports,
  ModifyResident: () => modify_resident_exports,
  ModifyRoom: () => modify_room_exports,
  ModifySensor: () => modify_sensor_exports,
  ModifyUser: () => modify_user_exports,
  ModifyWatchtower: () => modify_watchtower_exports,
  NotifyErrorLog: () => notify_error_log_exports,
  RegisterAamsCareRecord: () => register_aams_care_record_exports,
  RegisterAnsielVitals: () => register_ansiel_vitals_exports,
  RegisterBed: () => register_bed_exports,
  RegisterFacilityStaff: () => register_facility_staff_exports,
  RegisterFall: () => register_fall_exports,
  RegisterGroup: () => register_group_exports,
  RegisterIndependenceLevels: () => register_independence_levels_exports,
  RegisterInstallation: () => register_installation_exports,
  RegisterWatchtower: () => register_watchtower_exports,
  RunAnsielPolling: () => run_ansiel_polling_exports,
  SubscribePushNotifications: () => subscribe_push_notifications_exports,
  UnregisterFall: () => unregister_fall_exports,
  VerifyWatchtower: () => verify_watchtower_exports
});

// src/models/functions/allocate-bed.ts
var allocate_bed_exports = {};
__export(allocate_bed_exports, {
  END_POINT: () => END_POINT,
  METHOD: () => METHOD,
  getRequestDataSchema: () => getRequestDataSchema,
  getResponseDataSchema: () => getResponseDataSchema
});
import * as v77 from "valibot";
var END_POINT = "/allocate-bed";
var METHOD = "POST";
var getRequestDataSchema = memoize(function() {
  return v77.object({
    bedKey: BedKeySchema(),
    sensorKey: v77.nullable(SensorKeySchema()),
    userKey: v77.nullable(UserKeySchema())
  });
});
var getResponseDataSchema = memoize(function() {
  return v77.object({});
});

// src/models/functions/assess-residents.ts
var assess_residents_exports = {};
__export(assess_residents_exports, {
  MessageBodySchema: () => MessageBodySchema,
  QUEUE: () => QUEUE,
  RESOURCE_INSTANCE_PARTITION_KEY: () => RESOURCE_INSTANCE_PARTITION_KEY,
  WORKER_FUNCTION: () => WORKER_FUNCTION,
  WorkerInputSchema: () => WorkerInputSchema
});
import * as v78 from "valibot";
var RESOURCE_INSTANCE_PARTITION_KEY = "assess-residents";
var QUEUE = "assess-residents";
var WORKER_FUNCTION = "assess-residents--worker";
var MessageBodySchema = memoize(function() {
  return v78.variant("type", [
    v78.object({
      type: v78.literal(enumeration_exports6.COMPLEMENTED),
      /** 評価日時 */
      assessedAt: DateTimeSchema(),
      /** 評価者の識別子 */
      assessedBy: UsernameSchema(),
      /** **自立度エントリ** 自立度エントリの一部。 */
      independenceLevelEntries: v78.array(
        v78.object({
          /** 簡易自立度 */
          simpleIndependenceLevels: SimpleIndependenceLevelsSchema1(),
          /** ユーザーキー */
          userKey: UserKeySchema()
        })
      )
    }),
    v78.object({
      type: v78.literal(enumeration_exports6.ESTIMATED),
      /** 評価日 */
      assessedOn: DateSchema(),
      /** グループキー */
      groupKey: GroupKeySchema()
    })
  ]);
});
var WorkerInputSchema = memoize(function() {
  return v78.intersect([MessageBodySchema(), v78.object({ sortKey: v78.string() })]);
});

// src/models/functions/batch-data.ts
var batch_data_exports = {};
__export(batch_data_exports, {
  END_POINT: () => END_POINT2,
  METHOD: () => METHOD2,
  RequestDataSchema: () => RequestDataSchema,
  ResponseDataSchema: () => ResponseDataSchema
});
import * as v80 from "valibot";

// src/models/fetching.ts
import * as v79 from "valibot";
var FetchDataRequestSchema = memoize(function() {
  const optionsSchema = v79.optional(QueryOptionsSchema());
  return v79.variant("type", [
    v79.object({
      type: v79.literal("Entity::ApplicationConfiguration"),
      input: v79.optional(v79.unknown())
    }),
    v79.object({
      type: v79.literal("Entity::Bed"),
      input: v79.object({ bedKey: BedKeySchema() })
    }),
    v79.object({
      type: v79.literal("Entity::Facility"),
      input: v79.object({ facilityKey: FacilityKeySchema() })
    }),
    v79.object({
      type: v79.literal("Entity::FacilityStaff"),
      input: v79.object({ facilityKey: FacilityKeySchema(), userKey: UserKeySchema() })
    }),
    v79.object({
      type: v79.literal("Entity::Fall"),
      input: v79.object({ fallKey: FallKeySchema() })
    }),
    v79.object({
      type: v79.literal("Entity::FallRiskEntry"),
      input: FallRiskEntryQuerySchema()
    }),
    v79.object({
      type: v79.literal("Entity::Group"),
      input: v79.object({ groupKey: GroupKeySchema() })
    }),
    v79.object({
      type: v79.literal("Entity::IndependenceLevelEntry"),
      input: IndependenceLevelEntryQuerySchema()
    }),
    v79.object({
      type: v79.literal("Entity::Operator"),
      input: v79.object({ userKey: UserKeySchema() })
    }),
    v79.object({
      type: v79.literal("Entity::Organization"),
      input: v79.object({ organizationKey: OrganizationKeySchema() })
    }),
    v79.object({
      type: v79.literal("Entity::Provider"),
      input: v79.object({ providerKey: ProviderKeySchema() })
    }),
    v79.object({
      type: v79.literal("Entity::Resident"),
      input: v79.object({ userKey: UserKeySchema() })
    }),
    v79.object({
      type: v79.literal("Entity::Room"),
      input: v79.object({ roomKey: RoomKeySchema() })
    }),
    v79.object({
      type: v79.literal("Entity::Sensor"),
      input: v79.object({ sensorKey: SensorKeySchema() })
    }),
    v79.object({
      type: v79.literal("Entity::Status"),
      input: StatusQuerySchema()
    }),
    v79.object({
      type: v79.literal("Entity::User"),
      input: v79.object({ userKey: UserKeySchema() })
    }),
    v79.object({
      type: v79.literal("Entity::Watchtower"),
      input: v79.object({ watchtowerKey: WatchtowerKeySchema() })
    }),
    v79.object({
      type: v79.literal("Entities::Beds"),
      input: v79.object({
        filters: v79.optional(BedQueryFiltersSchema()),
        options: optionsSchema
      })
    }),
    v79.object({
      type: v79.literal("Entities::Facilities"),
      input: v79.object({
        filters: v79.optional(FacilityQueryFiltersSchema()),
        options: optionsSchema
      })
    }),
    v79.object({
      type: v79.literal("Entities::FacilityStaffs"),
      input: v79.object({
        filters: v79.optional(FacilityStaffQueryFiltersSchema()),
        options: optionsSchema
      })
    }),
    v79.object({
      type: v79.literal("Entities::Falls"),
      input: v79.object({
        filters: v79.optional(FallQueryFiltersSchema()),
        options: optionsSchema
      })
    }),
    v79.object({
      type: v79.literal("Entities::Measurements"),
      input: v79.object({
        filters: v79.optional(MeasurementQueryFiltersSchema()),
        options: optionsSchema
      })
    }),
    v79.object({
      type: v79.literal("Entities::Organizations"),
      input: v79.object({
        filters: v79.optional(OrganizationQueryFiltersSchema()),
        options: optionsSchema
      })
    }),
    v79.object({
      type: v79.literal("Entities::Providers"),
      input: v79.object({
        filters: v79.optional(ProviderQueryFiltersSchema()),
        options: optionsSchema
      })
    }),
    v79.object({
      type: v79.literal("Entities::Residents"),
      input: v79.object({
        filters: v79.optional(ResidentQueryFiltersSchema()),
        options: optionsSchema
      })
    }),
    v79.object({
      type: v79.literal("Entities::Rooms"),
      input: v79.object({
        filters: v79.optional(RoomQueryFiltersSchema()),
        options: optionsSchema
      })
    }),
    v79.object({
      type: v79.literal("Entities::Sensors"),
      input: v79.object({
        filters: v79.optional(SensorQueryFiltersSchema()),
        options: optionsSchema
      })
    }),
    v79.object({
      type: v79.literal("Entities::Statuses"),
      input: v79.object({
        filters: v79.optional(StatusQueryFiltersSchema()),
        options: optionsSchema
      })
    }),
    v79.object({
      type: v79.literal("Entities::Watchtowers"),
      input: v79.object({
        filters: v79.optional(WatchtowerQueryFiltersSchema()),
        options: optionsSchema
      })
    }),
    v79.object({
      type: v79.literal("StorageObject::ResidentImage"),
      input: v79.object({ userKey: UserKeySchema() })
    })
  ]);
});
var FetchDataResponseSchema = memoize(function() {
  const nextPageTokenSchema = v79.optional(v79.record(v79.string(), v79.any()));
  return v79.variant("type", [
    v79.object({
      type: v79.literal("Entity::ApplicationConfiguration"),
      output: v79.nullable(v79.union([ApplicationConfigurationSchema(), ErrorSchema()]))
    }),
    v79.object({
      type: v79.literal("Entity::Bed"),
      output: v79.nullable(v79.union([BedSchema(), ErrorSchema()]))
    }),
    v79.object({
      type: v79.literal("Entity::Facility"),
      output: v79.nullable(v79.union([FacilitySchema(), ErrorSchema()]))
    }),
    v79.object({
      type: v79.literal("Entity::FacilityStaff"),
      output: v79.nullable(v79.union([FacilityStaffSchema(), ErrorSchema()]))
    }),
    v79.object({
      type: v79.literal("Entity::Fall"),
      output: v79.nullable(v79.union([FallSchema(), ErrorSchema()]))
    }),
    v79.object({
      type: v79.literal("Entity::FallRiskEntry"),
      output: v79.nullable(v79.union([FallRiskEntrySchema(), ErrorSchema()]))
    }),
    v79.object({
      type: v79.literal("Entity::Group"),
      output: v79.nullable(v79.union([GroupSchema(), ErrorSchema()]))
    }),
    v79.object({
      type: v79.literal("Entity::IndependenceLevelEntry"),
      output: v79.nullable(v79.union([IndependenceLevelEntrySchema(), ErrorSchema()]))
    }),
    v79.object({
      type: v79.literal("Entity::Operator"),
      output: v79.nullable(v79.union([OperatorSchema(), ErrorSchema()]))
    }),
    v79.object({
      type: v79.literal("Entity::Organization"),
      output: v79.nullable(v79.union([OrganizationSchema(), ErrorSchema()]))
    }),
    v79.object({
      type: v79.literal("Entity::Provider"),
      output: v79.nullable(v79.union([ProviderSchema(), ErrorSchema()]))
    }),
    v79.object({
      type: v79.literal("Entity::Resident"),
      output: v79.nullable(v79.union([ResidentSchema(), ErrorSchema()]))
    }),
    v79.object({
      type: v79.literal("Entity::Room"),
      output: v79.nullable(v79.union([RoomSchema(), ErrorSchema()]))
    }),
    v79.object({
      type: v79.literal("Entity::Sensor"),
      output: v79.nullable(v79.union([SensorSchema(), ErrorSchema()]))
    }),
    v79.object({
      type: v79.literal("Entity::Status"),
      output: v79.nullable(v79.union([StatusSchema(), ErrorSchema()]))
    }),
    v79.object({
      type: v79.literal("Entity::User"),
      output: v79.nullable(v79.union([UserSchema(), ErrorSchema()]))
    }),
    v79.object({
      type: v79.literal("Entity::Watchtower"),
      output: v79.nullable(v79.union([WatchtowerSchema(), ErrorSchema()]))
    }),
    v79.object({
      type: v79.literal("Entities::Beds"),
      output: v79.union([
        v79.object({
          beds: v79.array(BedSchema()),
          numberOfBeds: v79.number(),
          errors: v79.array(ErrorSchema()),
          nextPageToken: nextPageTokenSchema
        }),
        ErrorSchema()
      ])
    }),
    v79.object({
      type: v79.literal("Entities::Facilities"),
      output: v79.union([
        v79.object({
          facilities: v79.array(FacilitySchema()),
          numberOfFacilities: v79.number(),
          errors: v79.array(ErrorSchema()),
          nextPageToken: nextPageTokenSchema
        }),
        ErrorSchema()
      ])
    }),
    v79.object({
      type: v79.literal("Entities::FacilityStaffs"),
      output: v79.union([
        v79.object({
          facilityStaffs: v79.array(FacilityStaffSchema()),
          numberOfFacilityStaffs: v79.number(),
          errors: v79.array(ErrorSchema()),
          nextPageToken: nextPageTokenSchema
        }),
        ErrorSchema()
      ])
    }),
    v79.object({
      type: v79.literal("Entities::Falls"),
      output: v79.union([
        v79.object({
          falls: v79.array(FallSchema()),
          numberOfFalls: v79.number(),
          errors: v79.array(ErrorSchema()),
          nextPageToken: nextPageTokenSchema
        }),
        ErrorSchema()
      ])
    }),
    v79.object({
      type: v79.literal("Entities::Measurements"),
      output: v79.union([
        v79.object({
          measurements: v79.array(MeasurementSchema()),
          numberOfMeasurements: v79.number(),
          errors: v79.array(ErrorSchema()),
          nextPageToken: nextPageTokenSchema
        }),
        ErrorSchema()
      ])
    }),
    v79.object({
      type: v79.literal("Entities::Organizations"),
      output: v79.union([
        v79.object({
          organizations: v79.array(OrganizationSchema()),
          numberOfOrganizations: v79.number(),
          errors: v79.array(ErrorSchema()),
          nextPageToken: nextPageTokenSchema
        }),
        ErrorSchema()
      ])
    }),
    v79.object({
      type: v79.literal("Entities::Providers"),
      output: v79.union([
        v79.object({
          providers: v79.array(ProviderSchema()),
          numberOfProviders: v79.number(),
          errors: v79.array(ErrorSchema()),
          nextPageToken: nextPageTokenSchema
        }),
        ErrorSchema()
      ])
    }),
    v79.object({
      type: v79.literal("Entities::Residents"),
      output: v79.union([
        v79.object({
          residents: v79.array(ResidentSchema()),
          numberOfResidents: v79.number(),
          errors: v79.array(ErrorSchema()),
          nextPageToken: nextPageTokenSchema
        }),
        ErrorSchema()
      ])
    }),
    v79.object({
      type: v79.literal("Entities::Rooms"),
      output: v79.union([
        v79.object({
          rooms: v79.array(RoomSchema()),
          numberOfRooms: v79.number(),
          errors: v79.array(ErrorSchema()),
          nextPageToken: nextPageTokenSchema
        }),
        ErrorSchema()
      ])
    }),
    v79.object({
      type: v79.literal("Entities::Sensors"),
      output: v79.union([
        v79.object({
          sensors: v79.array(SensorSchema()),
          numberOfSensors: v79.number(),
          errors: v79.array(ErrorSchema()),
          nextPageToken: nextPageTokenSchema
        }),
        ErrorSchema()
      ])
    }),
    v79.object({
      type: v79.literal("Entities::Statuses"),
      output: v79.union([
        v79.object({
          statuses: v79.array(StatusSchema()),
          numberOfStatuses: v79.number(),
          errors: v79.array(ErrorSchema()),
          nextPageToken: nextPageTokenSchema
        }),
        ErrorSchema()
      ])
    }),
    v79.object({
      type: v79.literal("Entities::Watchtowers"),
      output: v79.union([
        v79.object({
          watchtowers: v79.array(WatchtowerSchema()),
          numberOfWatchtowers: v79.number(),
          errors: v79.array(ErrorSchema()),
          nextPageToken: nextPageTokenSchema
        }),
        ErrorSchema()
      ])
    }),
    v79.object({
      type: v79.literal("StorageObject::ResidentImage"),
      output: v79.nullable(v79.union([v79.string(), ErrorSchema()]))
    })
  ]);
});

// src/models/functions/batch-data.ts
var END_POINT2 = "/batch-data";
var METHOD2 = "GET";
var RequestDataSchema = memoize(function() {
  return v80.array(FetchDataRequestSchema());
});
var ResponseDataSchema = memoize(function() {
  return v80.array(FetchDataResponseSchema());
});

// src/models/functions/check-status-schedules.ts
var check_status_schedules_exports = {};
__export(check_status_schedules_exports, {
  WORKER_FUNCTION: () => WORKER_FUNCTION2,
  WorkerInputSchema: () => WorkerInputSchema2
});
import * as v81 from "valibot";
var WORKER_FUNCTION2 = "check-status-schedules--worker";
var WorkerInputSchema2 = memoize(function() {
  return v81.object({
    /** 予定日時 */
    scheduledAt: DateTimeSchema(),
    /** シャード */
    shard: v81.pipe(v81.number(), v81.integer(), v81.minValue(0))
  });
});

// src/models/functions/confirm-status.ts
var confirm_status_exports = {};
__export(confirm_status_exports, {
  END_POINT: () => END_POINT3,
  METHOD: () => METHOD3,
  RequestDataSchema: () => RequestDataSchema2,
  ResponseDataSchema: () => ResponseDataSchema2
});
import * as v82 from "valibot";
var END_POINT3 = "/confirm-status";
var METHOD3 = "PUT";
var RequestDataSchema2 = memoize(function() {
  return v82.object({ statusKey: StatusKeySchema() });
});
var ResponseDataSchema2 = memoize(function() {
  return v82.object({ status: StatusSchema() });
});

// src/models/functions/create-facility.ts
var create_facility_exports = {};
__export(create_facility_exports, {
  END_POINT: () => END_POINT4,
  METHOD: () => METHOD4,
  getRequestDataSchema: () => getRequestDataSchema2,
  getResponseDataSchema: () => getResponseDataSchema2
});
import * as v83 from "valibot";
var END_POINT4 = "/create-facility";
var METHOD4 = "POST";
var getRequestDataSchema2 = memoize(function() {
  return v83.object({
    ...v83.omit(getFacilityRegistrationFormDataSchema(), ["organization"]).entries,
    organizationKey: OrganizationKeySchema()
  });
});
var getResponseDataSchema2 = memoize(function() {
  return v83.object({ facility: FacilitySchema() });
});

// src/models/functions/create-organization.ts
var create_organization_exports = {};
__export(create_organization_exports, {
  END_POINT: () => END_POINT5,
  METHOD: () => METHOD5,
  getRequestDataSchema: () => getRequestDataSchema3,
  getResponseDataSchema: () => getResponseDataSchema3
});
import * as v84 from "valibot";
var END_POINT5 = "/create-organization";
var METHOD5 = "POST";
var getRequestDataSchema3 = memoize(function() {
  return getOrganizationRegistrationFormDataSchema();
});
var getResponseDataSchema3 = memoize(function() {
  return v84.object({ organization: OrganizationSchema() });
});

// src/models/functions/create-provider.ts
var create_provider_exports = {};
__export(create_provider_exports, {
  END_POINT: () => END_POINT6,
  METHOD: () => METHOD6,
  getRequestDataSchema: () => getRequestDataSchema4,
  getResponseDataSchema: () => getResponseDataSchema4
});
import * as v85 from "valibot";
var END_POINT6 = "/create-provider";
var METHOD6 = "POST";
var getRequestDataSchema4 = memoize(function() {
  return v85.union([
    v85.object({
      ...v85.omit(getAamsServerRegistrationFormSchema(), ["facility", "organization"]).entries,
      facilityKey: v85.optional(FacilityKeySchema()),
      organizationKey: v85.optional(OrganizationKeySchema())
    }),
    v85.object({
      ...v85.omit(getAnsielApiRegistrationFormSchema(), ["facility", "organization"]).entries,
      facilityKey: v85.optional(FacilityKeySchema()),
      organizationKey: v85.optional(OrganizationKeySchema())
    })
  ]);
});
var getResponseDataSchema4 = memoize(function() {
  return v85.object({ provider: ProviderSchema() });
});

// src/models/functions/create-resident.ts
var create_resident_exports = {};
__export(create_resident_exports, {
  END_POINT: () => END_POINT7,
  METHOD: () => METHOD7,
  getRequestDataSchema: () => getRequestDataSchema5,
  getResponseDataSchema: () => getResponseDataSchema5
});
import * as v86 from "valibot";
var END_POINT7 = "/create-resident";
var METHOD7 = "POST";
var getRequestDataSchema5 = memoize(function() {
  return v86.object({
    ...getResidentRegistrationFormSchema().entries,
    facilityKey: FacilityKeySchema()
  });
});
var getResponseDataSchema5 = memoize(function() {
  return v86.object({ resident: ResidentSchema() });
});

// src/models/functions/create-sensor.ts
var create_sensor_exports = {};
__export(create_sensor_exports, {
  END_POINT: () => END_POINT8,
  METHOD: () => METHOD8,
  getRequestDataSchema: () => getRequestDataSchema6,
  getResponseDataSchema: () => getResponseDataSchema6
});
import * as v87 from "valibot";
var END_POINT8 = "/create-sensor";
var METHOD8 = "POST";
var getRequestDataSchema6 = memoize(function() {
  return v87.union([
    v87.object({
      ...v87.omit(getAamsRegistrationFormSchema(), ["facility", "organization", "provider"]).entries,
      facilityKey: v87.nullish(FacilityKeySchema()),
      organizationKey: v87.nullish(OrganizationKeySchema()),
      providerKey: ProviderKeySchema()
    }),
    v87.object({
      ...v87.omit(getAnsielRegistrationFormSchema(), ["facility", "organization", "provider"]).entries,
      facilityKey: v87.nullish(FacilityKeySchema()),
      organizationKey: v87.nullish(OrganizationKeySchema()),
      providerKey: ProviderKeySchema()
    })
  ]);
});
var getResponseDataSchema6 = memoize(function() {
  return v87.object({ sensor: SensorSchema() });
});

// src/models/functions/delete-old-installations.ts
var delete_old_installations_exports = {};
__export(delete_old_installations_exports, {
  WORKER_FUNCTION: () => WORKER_FUNCTION3,
  WorkerInputSchema: () => WorkerInputSchema3
});
import * as v88 from "valibot";
var WORKER_FUNCTION3 = "delete-old-installations--worker";
var WorkerInputSchema3 = memoize(function() {
  return v88.object({
    /** 実行予定日時 */
    scheduledAt: DateTimeSchema(),
    /** シャード */
    shard: v88.pipe(v88.number(), v88.safeInteger(), v88.minValue(0))
  });
});

// src/models/functions/delete-resident-image.ts
var delete_resident_image_exports = {};
__export(delete_resident_image_exports, {
  END_POINT: () => END_POINT9,
  METHOD: () => METHOD9,
  RequestDataSchema: () => RequestDataSchema3,
  ResponseDataSchema: () => ResponseDataSchema3
});
import * as v89 from "valibot";
var END_POINT9 = "/delete-resident-image";
var METHOD9 = "DELETE";
var RequestDataSchema3 = memoize(function() {
  return v89.object({ userKey: UserKeySchema() });
});
var ResponseDataSchema3 = memoize(function() {
  return v89.void();
});

// src/models/functions/delete-storage-object.ts
var delete_storage_object_exports = {};
__export(delete_storage_object_exports, {
  END_POINT: () => END_POINT10,
  METHOD: () => METHOD10,
  RequestDataSchema: () => RequestDataSchema4,
  ResponseDataSchema: () => ResponseDataSchema4
});
import * as v90 from "valibot";
var END_POINT10 = "/delete-storage-object";
var METHOD10 = "DELETE";
var RequestDataSchema4 = memoize(function() {
  return v90.union([
    v90.object({
      type: v90.literal(enumeration_exports15.RESIDENT_IMAGE),
      userKey: UserKeySchema()
    })
  ]);
});
var ResponseDataSchema4 = memoize(function() {
  return v90.boolean();
});

// src/models/functions/find-beds.ts
var find_beds_exports = {};
__export(find_beds_exports, {
  END_POINT: () => END_POINT11,
  METHOD: () => METHOD11,
  RequestDataSchema: () => RequestDataSchema5,
  ResponseDataSchema: () => ResponseDataSchema5
});
import * as v91 from "valibot";
var END_POINT11 = "/find-beds";
var METHOD11 = "GET";
var RequestDataSchema5 = memoize(function() {
  return BedQuerySchema();
});
var ResponseDataSchema5 = memoize(function() {
  return v91.object({
    beds: v91.array(BedSchema()),
    errors: v91.array(ErrorSchema()),
    nextPageToken: v91.optional(NextPageTokenSchema())
  });
});

// src/models/functions/find-facilities.ts
var find_facilities_exports = {};
__export(find_facilities_exports, {
  END_POINT: () => END_POINT12,
  METHOD: () => METHOD12,
  RequestDataSchema: () => RequestDataSchema6,
  ResponseDataSchema: () => ResponseDataSchema6
});
import * as v92 from "valibot";
var END_POINT12 = "/find-facilities";
var METHOD12 = "GET";
var RequestDataSchema6 = memoize(function() {
  return FacilityQuerySchema();
});
var ResponseDataSchema6 = memoize(function() {
  return v92.object({
    facilities: v92.array(FacilitySchema()),
    numberOfErrors: v92.pipe(v92.number(), v92.safeInteger(), v92.minValue(0)),
    nextPageToken: v92.optional(NextPageTokenSchema())
  });
});

// src/models/functions/find-fall-risk-entries.ts
var find_fall_risk_entries_exports = {};
__export(find_fall_risk_entries_exports, {
  END_POINT: () => END_POINT13,
  METHOD: () => METHOD13,
  RequestDataSchema: () => RequestDataSchema7,
  ResponseDataSchema: () => ResponseDataSchema7
});
import * as v93 from "valibot";
var END_POINT13 = "/find-fall-risk-entries";
var METHOD13 = "GET";
var RequestDataSchema7 = memoize(function() {
  return FallRiskEntryQuerySchema();
});
var ResponseDataSchema7 = memoize(function() {
  return v93.object({
    fallRiskEntries: v93.array(FallRiskEntrySchema()),
    errors: v93.array(ErrorSchema()),
    nextPageToken: v93.optional(NextPageTokenSchema())
  });
});

// src/models/functions/find-fall-score-entries.ts
var find_fall_score_entries_exports = {};
__export(find_fall_score_entries_exports, {
  END_POINT: () => END_POINT14,
  METHOD: () => METHOD14,
  RequestDataSchema: () => RequestDataSchema8,
  ResponseDataSchema: () => ResponseDataSchema8
});
import * as v94 from "valibot";
var END_POINT14 = "/find-fall-score-entries";
var METHOD14 = "GET";
var RequestDataSchema8 = memoize(function() {
  return FallScoreEntryQuerySchema();
});
var ResponseDataSchema8 = memoize(function() {
  return v94.object({
    fallScoreEntries: v94.array(FallScoreEntrySchema()),
    errors: v94.array(ErrorSchema()),
    nextPageToken: v94.optional(NextPageTokenSchema())
  });
});

// src/models/functions/find-groups.ts
var find_groups_exports = {};
__export(find_groups_exports, {
  END_POINT: () => END_POINT15,
  METHOD: () => METHOD15,
  RequestDataSchema: () => RequestDataSchema9,
  ResponseDataSchema: () => ResponseDataSchema9
});
import * as v95 from "valibot";
var END_POINT15 = "/find-groups";
var METHOD15 = "GET";
var RequestDataSchema9 = memoize(function() {
  return GroupQuerySchema();
});
var ResponseDataSchema9 = memoize(function() {
  return v95.object({
    groups: v95.array(GroupSchema()),
    errors: v95.array(ErrorSchema()),
    nextPageToken: v95.optional(NextPageTokenSchema())
  });
});

// src/models/functions/find-independence-level-entries.ts
var find_independence_level_entries_exports = {};
__export(find_independence_level_entries_exports, {
  END_POINT: () => END_POINT16,
  METHOD: () => METHOD16,
  RequestDataSchema: () => RequestDataSchema10,
  ResponseDataSchema: () => ResponseDataSchema10
});
import * as v96 from "valibot";
var END_POINT16 = "/find-independence-level-entries";
var METHOD16 = "GET";
var RequestDataSchema10 = memoize(function() {
  return IndependenceLevelEntryQuerySchema();
});
var ResponseDataSchema10 = memoize(function() {
  return v96.object({
    independenceLevelEntries: v96.array(IndependenceLevelEntrySchema()),
    errors: v96.array(ErrorSchema()),
    nextPageToken: v96.optional(NextPageTokenSchema())
  });
});

// src/models/functions/find-installations.ts
var find_installations_exports = {};
__export(find_installations_exports, {
  END_POINT: () => END_POINT17,
  METHOD: () => METHOD17,
  RequestDataSchema: () => RequestDataSchema11,
  ResponseDataSchema: () => ResponseDataSchema11
});
import * as v97 from "valibot";
var END_POINT17 = "/find-installations";
var METHOD17 = "GET";
var RequestDataSchema11 = memoize(function() {
  return InstallationQuerySchema();
});
var ResponseDataSchema11 = memoize(function() {
  return v97.object({
    installations: v97.array(InstallationSchema()),
    numberOfErrors: v97.pipe(v97.number(), v97.safeInteger(), v97.minValue(0)),
    nextPageToken: v97.optional(NextPageTokenSchema())
  });
});

// src/models/functions/find-organizations.ts
var find_organizations_exports = {};
__export(find_organizations_exports, {
  END_POINT: () => END_POINT18,
  METHOD: () => METHOD18,
  RequestDataSchema: () => RequestDataSchema12,
  ResponseDataSchema: () => ResponseDataSchema12
});
import * as v98 from "valibot";
var END_POINT18 = "/find-organizations";
var METHOD18 = "GET";
var RequestDataSchema12 = memoize(function() {
  return OrganizationQuerySchema();
});
var ResponseDataSchema12 = memoize(function() {
  return v98.object({
    organizations: v98.array(OrganizationSchema()),
    numberOfErrors: v98.pipe(v98.number(), v98.safeInteger(), v98.minValue(0)),
    nextPageToken: v98.optional(NextPageTokenSchema())
  });
});

// src/models/functions/find-providers.ts
var find_providers_exports = {};
__export(find_providers_exports, {
  END_POINT: () => END_POINT19,
  METHOD: () => METHOD19,
  RequestDataSchema: () => RequestDataSchema13,
  ResponseDataSchema: () => ResponseDataSchema13
});
import * as v99 from "valibot";
var END_POINT19 = "/find-providers";
var METHOD19 = "GET";
var RequestDataSchema13 = memoize(function() {
  return ProviderQuerySchema();
});
var ResponseDataSchema13 = memoize(function() {
  return v99.object({
    providers: v99.array(ProviderSchema()),
    numberOfErrors: v99.pipe(v99.number(), v99.safeInteger(), v99.minValue(0)),
    nextPageToken: v99.optional(NextPageTokenSchema())
  });
});

// src/models/functions/find-residents.ts
var find_residents_exports = {};
__export(find_residents_exports, {
  END_POINT: () => END_POINT20,
  METHOD: () => METHOD20,
  RequestDataSchema: () => RequestDataSchema14,
  ResponseDataSchema: () => ResponseDataSchema14
});
import * as v100 from "valibot";
var END_POINT20 = "/find-residents";
var METHOD20 = "GET";
var RequestDataSchema14 = memoize(function() {
  return ResidentQuerySchema();
});
var ResponseDataSchema14 = memoize(function() {
  return v100.object({
    residents: v100.array(ResidentSchema()),
    errors: v100.array(ErrorSchema()),
    nextPageToken: v100.optional(NextPageTokenSchema())
  });
});

// src/models/functions/find-sensors.ts
var find_sensors_exports = {};
__export(find_sensors_exports, {
  END_POINT: () => END_POINT21,
  METHOD: () => METHOD21,
  RequestDataSchema: () => RequestDataSchema15,
  ResponseDataSchema: () => ResponseDataSchema15
});
import * as v101 from "valibot";
var END_POINT21 = "/find-sensors";
var METHOD21 = "GET";
var RequestDataSchema15 = memoize(function() {
  return SensorQuerySchema();
});
var ResponseDataSchema15 = memoize(function() {
  return v101.object({
    sensors: v101.array(SensorSchema()),
    numberOfErrors: v101.pipe(v101.number(), v101.safeInteger(), v101.minValue(0)),
    nextPageToken: v101.optional(NextPageTokenSchema())
  });
});

// src/models/functions/find-statuses.ts
var find_statuses_exports = {};
__export(find_statuses_exports, {
  END_POINT: () => END_POINT22,
  METHOD: () => METHOD22,
  RequestDataSchema: () => RequestDataSchema16,
  ResponseDataSchema: () => ResponseDataSchema16
});
import * as v102 from "valibot";
var END_POINT22 = "/find-statuses";
var METHOD22 = "GET";
var RequestDataSchema16 = memoize(function() {
  return StatusQuerySchema();
});
var ResponseDataSchema16 = memoize(function() {
  return v102.object({
    statuses: v102.array(StatusSchema()),
    errors: v102.array(ErrorSchema()),
    nextPageToken: v102.optional(NextPageTokenSchema())
  });
});

// src/models/functions/generate-resident-image-get-url.ts
var generate_resident_image_get_url_exports = {};
__export(generate_resident_image_get_url_exports, {
  END_POINT: () => END_POINT23,
  METHOD: () => METHOD23,
  RequestDataSchema: () => RequestDataSchema17,
  ResponseDataSchema: () => ResponseDataSchema17
});
import * as v103 from "valibot";
var END_POINT23 = "/generate-resident-image-get-url";
var METHOD23 = "GET";
var RequestDataSchema17 = memoize(function() {
  return v103.object({ userKey: UserKeySchema() });
});
var ResponseDataSchema17 = memoize(function() {
  return v103.nullable(v103.string());
});

// src/models/functions/generate-resident-image-put-url.ts
var generate_resident_image_put_url_exports = {};
__export(generate_resident_image_put_url_exports, {
  END_POINT: () => END_POINT24,
  METHOD: () => METHOD24,
  RequestDataSchema: () => RequestDataSchema18,
  ResponseDataSchema: () => ResponseDataSchema18
});
import * as v104 from "valibot";
var END_POINT24 = "/generate-resident-image-put-url";
var METHOD24 = "GET";
var RequestDataSchema18 = memoize(function() {
  return v104.object({ userKey: UserKeySchema() });
});
var ResponseDataSchema18 = memoize(function() {
  return v104.string();
});

// src/models/functions/generate-storage-object-url.ts
var generate_storage_object_url_exports = {};
__export(generate_storage_object_url_exports, {
  END_POINT: () => END_POINT25,
  METHOD: () => METHOD25,
  RequestDataSchema: () => RequestDataSchema19,
  ResponseDataSchema: () => ResponseDataSchema19
});
import * as v105 from "valibot";
var END_POINT25 = "/generate-storage-object-url";
var METHOD25 = "GET";
var RequestDataSchema19 = memoize(function() {
  return v105.union([
    v105.object({
      type: v105.literal(enumeration_exports15.RESIDENT_IMAGE),
      userKey: UserKeySchema()
    })
  ]);
});
var ResponseDataSchema19 = memoize(function() {
  return v105.string();
});

// src/models/functions/modify-bed.ts
var modify_bed_exports = {};
__export(modify_bed_exports, {
  END_POINT: () => END_POINT26,
  METHOD: () => METHOD26,
  RequestDataSchema: () => RequestDataSchema20,
  ResponseDataSchema: () => ResponseDataSchema20
});
import * as v106 from "valibot";
var END_POINT26 = "/modify-bed";
var METHOD26 = "POST";
var RequestDataSchema20 = memoize(function() {
  const bed = BedSchema();
  const { bedName, bedPronunciation, groupKey, roomName, roomPronunciation } = bed.options[1].entries;
  return v106.intersect([
    BedKeyChainSchema(),
    v106.partial(v106.object({ bedName, bedPronunciation, groupKey, roomName, roomPronunciation }))
  ]);
});
var ResponseDataSchema20 = memoize(function() {
  return v106.object({ bed: BedSchema() });
});

// src/models/functions/modify-facility.ts
var modify_facility_exports = {};
__export(modify_facility_exports, {
  END_POINT: () => END_POINT27,
  METHOD: () => METHOD27,
  RequestDataSchema: () => RequestDataSchema21,
  ResponseDataSchema: () => ResponseDataSchema21
});
import * as v107 from "valibot";
var END_POINT27 = "/modify-facility";
var METHOD27 = "POST";
var RequestDataSchema21 = memoize(function() {
  const facility = FacilitySchema();
  const { facilityKey } = facility.options[0].entries;
  const { textToSpeechMode } = facility.options[1].entries;
  return v107.object({
    facilityKey,
    textToSpeechMode: v107.optional(textToSpeechMode)
  });
});
var ResponseDataSchema21 = memoize(function() {
  return v107.object({ facility: FacilitySchema() });
});

// src/models/functions/modify-facility-staff.ts
var modify_facility_staff_exports = {};
__export(modify_facility_staff_exports, {
  END_POINT: () => END_POINT28,
  METHOD: () => METHOD28,
  RequestDataSchema: () => RequestDataSchema22,
  ResponseDataSchema: () => ResponseDataSchema22
});
import * as v108 from "valibot";
var END_POINT28 = "/modify-facility-staff";
var METHOD28 = "POST";
var RequestDataSchema22 = memoize(function() {
  return v108.object({
    emailAddress: v108.optional(v108.union([getEmailAddressSchema(), v108.literal("")])),
    facilityKey: FacilityKeySchema(),
    name: v108.pipe(v108.string(), v108.trim(), v108.minLength(1), v108.maxGraphemes(64)),
    password: v108.optional(v108.union([PasswordSchema(), v108.literal("")])),
    roles: v108.pipe(
      v108.array(FacilityStaffRoleSchema()),
      v108.checkItems(function(item, index, array28) {
        return index === array28.lastIndexOf(item);
      })
    ),
    tier: FacilityStaffTierSchema(),
    userKey: UserKeySchema()
  });
});
var ResponseDataSchema22 = memoize(function() {
  return v108.object({ facilityStaff: FacilityStaffSchema() });
});

// src/models/functions/modify-group.ts
var modify_group_exports = {};
__export(modify_group_exports, {
  END_POINT: () => END_POINT29,
  METHOD: () => METHOD29,
  RequestDataSchema: () => RequestDataSchema23,
  ResponseDataSchema: () => ResponseDataSchema23
});
import * as v109 from "valibot";
var END_POINT29 = "/modify-group";
var METHOD29 = "POST";
var RequestDataSchema23 = memoize(function() {
  const group = GroupSchema();
  const { groupKey } = group.options[0].entries;
  const { deleted, name } = group.options[1].entries;
  return v109.object({ deleted: v109.optional(deleted), groupKey, name: v109.optional(name) });
});
var ResponseDataSchema23 = memoize(function() {
  return v109.object({ group: GroupSchema() });
});

// src/models/functions/modify-resident.ts
var modify_resident_exports = {};
__export(modify_resident_exports, {
  END_POINT: () => END_POINT30,
  METHOD: () => METHOD30,
  RequestDataSchema: () => RequestDataSchema24,
  ResponseDataSchema: () => ResponseDataSchema24
});
import * as v110 from "valibot";
var END_POINT30 = "/modify-resident";
var METHOD30 = "PUT";
var RequestDataSchema24 = memoize(function() {
  const resident = ResidentSchema();
  const {
    alertSettings,
    agreed,
    birthday,
    displayName,
    height,
    name,
    pronunciationName,
    sex,
    weight
  } = resident.options[1].entries;
  return v110.intersect([
    ResidentKeyChainSchema(),
    v110.partial(
      v110.object({
        alertSettings,
        agreed,
        birthday,
        deleted: v110.picklist([values_exports2.ARCHIVED, values_exports2.DEFAULT]),
        displayName,
        height,
        name,
        pronunciationName,
        sex,
        weight
      })
    )
  ]);
});
var ResponseDataSchema24 = memoize(function() {
  return v110.object({ resident: ResidentSchema() });
});

// src/models/functions/modify-room.ts
var modify_room_exports = {};
__export(modify_room_exports, {
  END_POINT: () => END_POINT31,
  METHOD: () => METHOD31,
  RequestDataSchema: () => RequestDataSchema25,
  ResponseDataSchema: () => ResponseDataSchema25
});
import * as v111 from "valibot";
var END_POINT31 = "/modify-room";
var METHOD31 = "PUT";
var RequestDataSchema25 = memoize(function() {
  return v111.object({
    roomKey: RoomKeySchema(),
    prerequisities: v111.optional(v111.partial(v111.object({}))),
    properties: v111.optional(
      v111.partial(
        v111.object({
          name: v111.pipe(v111.string(), v111.trim(), v111.nonEmpty(), v111.maxGraphemes(64))
        })
      )
    )
  });
});
var ResponseDataSchema25 = memoize(function() {
  return v111.object({ room: RoomSchema() });
});

// src/models/functions/modify-sensor.ts
var modify_sensor_exports = {};
__export(modify_sensor_exports, {
  END_POINT: () => END_POINT32,
  METHOD: () => METHOD32,
  RequestDataSchema: () => RequestDataSchema26,
  ResponseDataSchema: () => ResponseDataSchema26
});
import * as v112 from "valibot";
var END_POINT32 = "/modify-sensor";
var METHOD32 = "PUT";
var RequestDataSchema26 = memoize(function() {
  return v112.object({
    sensorKey: SensorKeySchema(),
    prerequisities: v112.optional(v112.partial(v112.object({}))),
    properties: v112.optional(
      v112.partial(
        v112.object({
          name: v112.pipe(v112.string(), v112.trim(), v112.minLength(1), v112.maxGraphemes(48))
        })
      )
    )
  });
});
var ResponseDataSchema26 = memoize(function() {
  return v112.object({ sensor: SensorSchema() });
});

// src/models/functions/modify-user.ts
var modify_user_exports = {};
__export(modify_user_exports, {
  END_POINT: () => END_POINT33,
  METHOD: () => METHOD33,
  RequestDataSchema: () => RequestDataSchema27,
  ResponseDataSchema: () => ResponseDataSchema27
});
import * as v113 from "valibot";
var END_POINT33 = "/modify-user";
var METHOD33 = "PUT";
var RequestDataSchema27 = memoize(function() {
  return v113.object({
    emailAddress: v113.pipe(v113.string(), v113.rfcEmail()),
    password: PasswordSchema()
  });
});
var ResponseDataSchema27 = memoize(function() {
  return v113.object({ user: UserSchema() });
});

// src/models/functions/modify-watchtower.ts
var modify_watchtower_exports = {};
__export(modify_watchtower_exports, {
  END_POINT: () => END_POINT34,
  METHOD: () => METHOD34,
  RequestDataSchema: () => RequestDataSchema28,
  ResponseDataSchema: () => ResponseDataSchema28
});
import * as v114 from "valibot";
var END_POINT34 = "/modify-watchtower";
var METHOD34 = "POST";
var RequestDataSchema28 = memoize(function() {
  return v114.object({
    deleted: v114.optional(v114.picklist([values_exports2.ARCHIVED, values_exports2.DEFAULT])),
    /** 名前 */
    name: v114.optional(v114.pipe(v114.string(), v114.minLength(1), v114.maxGraphemes(128))),
    /** ウォッチタワーキー */
    watchtowerKey: WatchtowerKeySchema()
  });
});
var ResponseDataSchema28 = memoize(function() {
  return v114.object({ watchtower: WatchtowerSchema() });
});

// src/models/functions/notify-error-log.ts
var notify_error_log_exports = {};
__export(notify_error_log_exports, {
  WORKER_QUEUE_NAME: () => WORKER_QUEUE_NAME,
  WorkerInputSchema: () => WorkerInputSchema4
});
import * as v115 from "valibot";
var WORKER_QUEUE_NAME = "notify-error-log--worker";
var WorkerInputSchema4 = memoize(function() {
  return v115.object({
    /** イベント (`CloudWatchLogsEvent`) */
    event: v115.object({
      awslogs: v115.object({
        data: v115.object({
          logEvent: v115.object({
            id: v115.string(),
            message: v115.union([v115.string(), v115.record(v115.string(), v115.unknown())]),
            timestamp: DateTimeSchema()
          }),
          logGroup: v115.string(),
          logStream: v115.string(),
          messageType: v115.string(),
          owner: v115.string(),
          subscriptionFilters: v115.array(v115.string())
        })
      })
    }),
    /** ウォッチタワーキー */
    watchtowerKey: WatchtowerKeySchema()
  });
});

// src/models/functions/register-aams-care-record.ts
var register_aams_care_record_exports = {};
__export(register_aams_care_record_exports, {
  WORKER_QUEUE: () => WORKER_QUEUE,
  WorkerInputSchema: () => WorkerInputSchema5
});
import * as v116 from "valibot";
var WORKER_QUEUE = "register-aams-care-record";
var WorkerInputSchema5 = memoize(function() {
  return v116.object({
    /** **作成日時** このケアレコードが作成された日時。 */
    createdAt: DateTimeSchema(),
    /** ケアレコードの期間 */
    duration: DurationSchema(),
    heartRate: v116.optional(v116.pipe(v116.number(), v116.gtValue(0))),
    macAddress: MacAddressSchema(),
    measuredAt: DateTimeSchema(),
    providerKey: ProviderKeySchema(),
    respiratoryRate: v116.optional(v116.pipe(v116.number(), v116.gtValue(0))),
    state: v116.optional(ResidentStateSchema())
  });
});

// src/models/functions/register-ansiel-vitals.ts
var register_ansiel_vitals_exports = {};
__export(register_ansiel_vitals_exports, {
  WORKER_QUEUE: () => WORKER_QUEUE2,
  WorkerInputSchema: () => WorkerInputSchema6
});
import * as v117 from "valibot";
var WORKER_QUEUE2 = "register-ansiel-vitals";
var WorkerInputSchema6 = memoize(function() {
  return v117.object({
    /** プロバイダーキー */
    providerKey: ProviderKeySchema(),
    /** 対象期間の始点 */
    start: DateTimeSchema(),
    /** 対象期間の終点 */
    stop: DateTimeSchema()
  });
});

// src/models/functions/register-bed.ts
var register_bed_exports = {};
__export(register_bed_exports, {
  END_POINT: () => END_POINT35,
  METHOD: () => METHOD35,
  RequestDataSchema: () => RequestDataSchema29,
  ResponseDataSchema: () => ResponseDataSchema29
});
import * as v118 from "valibot";
var END_POINT35 = "/register-bed";
var METHOD35 = "POST";
var RequestDataSchema29 = memoize(function() {
  const bed = BedSchema();
  const { bedName, bedPronunciation, facilityKey, roomName, roomPronunciation } = bed.options[1].entries;
  return v118.object({ bedName, bedPronunciation, facilityKey, roomName, roomPronunciation });
});
var ResponseDataSchema29 = memoize(function() {
  return v118.object({ bed: BedSchema() });
});

// src/models/functions/register-facility-staff.ts
var register_facility_staff_exports = {};
__export(register_facility_staff_exports, {
  END_POINT: () => END_POINT36,
  METHOD: () => METHOD36,
  RequestDataSchema: () => RequestDataSchema30,
  ResponseDataSchema: () => ResponseDataSchema30
});
import * as v119 from "valibot";
var END_POINT36 = "/register-facility-staff";
var METHOD36 = "POST";
var RequestDataSchema30 = memoize(function() {
  return v119.object({
    emailAddress: v119.pipe(v119.string(), v119.rfcEmail()),
    facilityKey: FacilityKeySchema(),
    name: v119.pipe(v119.string(), v119.trim(), v119.minLength(1), v119.maxGraphemes(64)),
    password: PasswordSchema(),
    roles: v119.pipe(
      v119.array(FacilityStaffRoleSchema()),
      v119.checkItems(function(item, index, array28) {
        return index === array28.lastIndexOf(item);
      })
    ),
    tier: FacilityStaffTierSchema(),
    userKey: v119.optional(UserKeySchema())
  });
});
var ResponseDataSchema30 = memoize(function() {
  return v119.object({ facilityStaff: FacilityStaffSchema() });
});

// src/models/functions/register-fall.ts
var register_fall_exports = {};
__export(register_fall_exports, {
  END_POINT: () => END_POINT37,
  METHOD: () => METHOD37,
  RequestDataSchema: () => RequestDataSchema31,
  ResponseDataSchema: () => ResponseDataSchema31
});
import * as v120 from "valibot";
var END_POINT37 = "/register-fall";
var METHOD37 = "POST";
var RequestDataSchema31 = memoize(function() {
  return v120.object({ fellAt: DateTimeSchema(), userKey: UserKeySchema() });
});
var ResponseDataSchema31 = memoize(function() {
  return v120.object({ fall: FallSchema() });
});

// src/models/functions/register-group.ts
var register_group_exports = {};
__export(register_group_exports, {
  END_POINT: () => END_POINT38,
  METHOD: () => METHOD38,
  RequestDataSchema: () => RequestDataSchema32,
  ResponseDataSchema: () => ResponseDataSchema32
});
import * as v121 from "valibot";
var END_POINT38 = "/register-group";
var METHOD38 = "POST";
var RequestDataSchema32 = memoize(function() {
  const group = GroupSchema();
  const { facilityKey, name } = group.options[1].entries;
  return v121.object({ facilityKey, name });
});
var ResponseDataSchema32 = memoize(function() {
  return v121.object({ group: GroupSchema() });
});

// src/models/functions/register-installation.ts
var register_installation_exports = {};
__export(register_installation_exports, {
  END_POINT: () => END_POINT39,
  METHOD: () => METHOD39,
  RequestDataSchema: () => RequestDataSchema33,
  ResponseDataSchema: () => ResponseDataSchema33
});
import * as v122 from "valibot";
var END_POINT39 = "/register-installation";
var METHOD39 = "POST";
var RequestDataSchema33 = memoize(function() {
  return v122.object({
    /** エディション */
    edition: v122.picklist(["Android", "Ios"]),
    /** **施設キー** このグループを所有する施設の識別子。 */
    facilityKey: v122.optional(FacilityKeySchema()),
    /** インストール情報識別子 */
    identifier: v122.string(),
    /** リビジョン */
    revision: v122.pipe(v122.number(), v122.safeInteger(), v122.minValue(0)),
    /** 更新日時 */
    updatedAt: DateTimeSchema(),
    /** バージョン */
    version: VersionSchema()
  });
});
var ResponseDataSchema33 = memoize(function() {
  return v122.object({
    /** **インストール情報** 登録されなかった場合は`undefined`になる。 */
    installation: v122.optional(InstallationSchema())
  });
});

// src/models/functions/register-independence-levels.ts
var register_independence_levels_exports = {};
__export(register_independence_levels_exports, {
  END_POINT: () => END_POINT40,
  METHOD: () => METHOD40,
  RequestDataSchema: () => RequestDataSchema34,
  ResponseDataSchema: () => ResponseDataSchema34
});
import * as v123 from "valibot";
var END_POINT40 = "/register-independence-levels";
var METHOD40 = "POST";
var RequestDataSchema34 = memoize(function() {
  return v123.variant("type", [
    v123.object({
      type: v123.literal(enumeration_exports6.COMPLEMENTED),
      /** 自立度エントリ */
      independenceLevelEntries: v123.array(
        v123.object({
          /** 簡易自立度 */
          simpleIndependenceLevels: SimpleIndependenceLevelsSchema1(),
          /** 入居者の識別子 */
          userKey: UserKeySchema()
        })
      )
    }),
    v123.object({
      type: v123.literal(enumeration_exports6.OBSERVED),
      /** 自立度 */
      independenceLevels: IndependenceLevelsSchema(),
      /** 入居者の識別子 */
      userKey: UserKeySchema()
    })
  ]);
});
var ResponseDataSchema34 = memoize(function() {
  return v123.void();
});

// src/models/functions/register-watchtower.ts
var register_watchtower_exports = {};
__export(register_watchtower_exports, {
  END_POINT: () => END_POINT41,
  METHOD: () => METHOD41,
  RequestDataSchema: () => RequestDataSchema35,
  ResponseDataSchema: () => ResponseDataSchema35
});
import * as v124 from "valibot";
var END_POINT41 = "/register-watchtower";
var METHOD41 = "POST";
var RequestDataSchema35 = memoize(function() {
  return v124.intersect([
    v124.object({
      /** 名前 */
      name: v124.pipe(v124.string(), v124.minLength(1), v124.maxGraphemes(128))
    }),
    v124.variant("type", [
      v124.object({
        type: v124.literal(enumeration_exports17.EMAIL_ADDRESS),
        emailAddress: v124.pipe(v124.string(), v124.email())
      }),
      v124.object({
        type: v124.literal(enumeration_exports17.SLACK_INCOMING_WEBHOOK),
        url: v124.pipe(v124.string(), v124.url())
      })
    ])
  ]);
});
var ResponseDataSchema35 = memoize(function() {
  return v124.object({ watchtower: WatchtowerSchema() });
});

// src/models/functions/run-ansiel-polling.ts
var run_ansiel_polling_exports = {};
__export(run_ansiel_polling_exports, {
  QUEUE_NAME: () => QUEUE_NAME,
  getRecordDataSchema: () => getRecordDataSchema
});
import * as v125 from "valibot";
var QUEUE_NAME = "run-ansiel-polling";
var getRecordDataSchema = memoize(function() {
  return v125.object({
    end: DateTimeSchema(),
    providerKey: ProviderKeySchema(),
    start: DateTimeSchema()
  });
});

// src/models/functions/subscribe-push-notifications.ts
var subscribe_push_notifications_exports = {};
__export(subscribe_push_notifications_exports, {
  END_POINT: () => END_POINT42,
  METHOD: () => METHOD42,
  RequestDataSchema: () => RequestDataSchema36,
  ResponseDataSchema: () => ResponseDataSchema36
});
import * as v126 from "valibot";
var END_POINT42 = "/subscribe-push-notifications";
var METHOD42 = "POST";
var RequestDataSchema36 = memoize(function() {
  return v126.object({
    /**
     * **施設キー**
     * 購読する施設の識別子。`null`を指定した場合、施設の購読を解除する。
     */
    facilityKey: v126.nullable(FacilityKeySchema()),
    /** 購読日時 */
    subscribedAt: DateTimeSchema(),
    /** プッシュ通知トークン */
    token: v126.string(),
    /** プッシュ通知受信機タイプ */
    type: PushNotificationReceiverTypeSchema()
  });
});
var ResponseDataSchema36 = memoize(function() {
  return v126.void();
});

// src/models/functions/unregister-fall.ts
var unregister_fall_exports = {};
__export(unregister_fall_exports, {
  END_POINT: () => END_POINT43,
  METHOD: () => METHOD43,
  RequestDataSchema: () => RequestDataSchema37,
  ResponseDataSchema: () => ResponseDataSchema37
});
import * as v127 from "valibot";
var END_POINT43 = "/unregister-fall";
var METHOD43 = "POST";
var RequestDataSchema37 = memoize(function() {
  return v127.object({ fallKey: FallKeySchema() });
});
var ResponseDataSchema37 = memoize(function() {
  return v127.object({});
});

// src/models/functions/verify-watchtower.ts
var verify_watchtower_exports = {};
__export(verify_watchtower_exports, {
  END_POINT: () => END_POINT44,
  METHOD: () => METHOD44,
  RequestDataSchema: () => RequestDataSchema38,
  ResponseDataSchema: () => ResponseDataSchema38
});
import * as v128 from "valibot";
var END_POINT44 = "/verify-watchtower";
var METHOD44 = "POST";
var RequestDataSchema38 = memoize(function() {
  return v128.object({
    /** ウォッチタワーキー */
    watchtowerKey: WatchtowerKeySchema()
  });
});
var ResponseDataSchema38 = memoize(function() {
  return v128.void();
});

// src/models/native-application.ts
import * as v129 from "valibot";
function NullableSchema(schema) {
  return v129.nullish(schema, null);
}
__name(NullableSchema, "NullableSchema");
var NativeApplicationPacketSchema = memoize(function() {
  return v129.object({
    payload: NativeApplicationPayloadSchema(),
    /**
     * **リクエスト番号**
     * 受信側がレスポンスを期待する時に指定される。
     * 送信側はこの番号を`response`に指定してレスポンスを返す必要がある。
     */
    request: NullableSchema(v129.pipe(v129.number(), v129.integer())),
    /**
     * **レスポンス番号**
     * リクエストに対するレスポンスを識別するために使用される。
     */
    response: NullableSchema(v129.pipe(v129.number(), v129.integer()))
  });
});
var NativeApplicationPayloadSchema = memoize(function() {
  return v129.fallback(
    v129.variant("type", [
      v129.object({
        type: v129.literal("Error"),
        code: NullableSchema(
          v129.picklist([
            "NOT_FOUND",
            "NOT_IMPLEMENTED",
            "UNKNOWN_ERROR_OCCURRED",
            "E987",
            "E055",
            "E056"
          ])
        ),
        message: NullableSchema(v129.string())
      }),
      // TODO: 互換性を保つための定義なので、将来的に削除する。
      v129.object({
        /** @deprecated 代わりに個別のリクエストを使用する。 */
        type: v129.literal("GetNativeApplicationInformationRequest")
      }),
      // TODO: 互換性を保つための定義なので、将来的に削除する。
      v129.object({
        /** @deprecated 代わりに個別のレスポンスを使用する。 */
        type: v129.literal("GetNativeApplicationInformationResponse"),
        edition: v129.picklist(["Android", "Ios"]),
        revision: v129.pipe(v129.number(), v129.safeInteger(), v129.minValue(0)),
        version: VersionSchema()
      }),
      v129.object({ type: v129.literal("IdentifierRequest") }),
      v129.object({ type: v129.literal("IdentifierResponse"), identifier: v129.string() }),
      // TODO: 互換性を保つための定義なので、将来的に削除する。
      v129.object({ type: v129.literal("GetPushNotificationTokenRequest") }),
      // TODO: 互換性を保つための定義なので、将来的に削除する。
      v129.object({ type: v129.literal("GetPushNotificationTokenResponse"), token: v129.string() }),
      v129.object({ type: v129.literal("NewPushNotificationToken"), token: v129.string() }),
      v129.object({ type: v129.literal("Open"), url: v129.string() }),
      v129.object({
        type: v129.literal("PushNotification"),
        data: NativeApplicationPushNotificationDataSchema()
      }),
      v129.object({ type: v129.literal("PushNotificationPermissionRequest") }),
      v129.object({
        type: v129.literal("PushNotificationPermissionResponse"),
        granted: NullableSchema(v129.boolean())
      }),
      v129.object({ type: v129.literal("PushNotificationTokenRequest") }),
      v129.object({ type: v129.literal("PushNotificationTokenResponse"), token: v129.string() }),
      // TODO: 互換性を保つための定義なので、将来的に削除する。
      v129.object({ type: v129.literal("RequestPushNotificationPermissionRequest") }),
      // TODO: 互換性を保つための定義なので、将来的に削除する。
      v129.object({
        type: v129.literal("RequestPushNotificationPermissionResponse"),
        granted: NullableSchema(v129.boolean())
      }),
      v129.object({ type: v129.literal("RevisionRequest") }),
      v129.object({
        type: v129.literal("RevisionResponse"),
        revision: v129.pipe(v129.number(), v129.safeInteger(), v129.minValue(0))
      }),
      v129.object({
        type: v129.literal("SetTextToSpeechPitch"),
        pitch: v129.pipe(v129.number(), v129.minValue(0.1), v129.maxValue(2))
      }),
      v129.object({
        type: v129.literal("SetTextToSpeechRate"),
        rate: v129.pipe(v129.number(), v129.minValue(0.1), v129.maxValue(2))
      }),
      v129.object({
        type: v129.literal("SetTextToSpeechVolume"),
        volume: v129.pipe(v129.number(), v129.minValue(0), v129.maxValue(1))
      }),
      v129.object({
        type: v129.literal("PlayRequest"),
        file: v129.string(),
        volume: NullableSchema(v129.number())
      }),
      v129.object({ type: v129.literal("PlayResponse") }),
      v129.object({
        type: v129.literal("SpeakRequest"),
        pitch: NullableSchema(v129.number()),
        rate: NullableSchema(v129.number()),
        text: v129.string(),
        volume: NullableSchema(v129.number())
      }),
      v129.object({ type: v129.literal("SpeakResponse") }),
      v129.object({
        /**
         * **スタートペイロード**
         * Webアプリケーション側がメッセージが受け取れるようになった時に送信される。
         */
        type: v129.literal("Start")
      }),
      v129.object({
        /**
         * **ストップペイロード**
         * Webアプリケーション側がメッセージを受け取れなくなる時に送信される。
         */
        type: v129.literal("Stop")
      }),
      // TODO: 互換性を保つための定義なので、将来的に削除する。
      v129.object({
        type: v129.literal("TextToSpeechRequest"),
        pitch: NullableSchema(v129.number()),
        rate: NullableSchema(v129.number()),
        text: v129.string(),
        volume: NullableSchema(v129.number())
      }),
      // TODO: 互換性を保つための定義なので、将来的に削除する。
      v129.object({ type: v129.literal("TextToSpeechResponse") }),
      /**
       * **不明なペイロード**
       * 受信側が理解できないペイロードを受信した時に使用される。
       * 送信側はこのペイロードを明示的に送信してはならない。
       */
      v129.object({ type: v129.literal("Unknown") }),
      v129.object({ type: v129.literal("VersionRequest") }),
      v129.object({ type: v129.literal("VersionResponse"), version: VersionSchema() })
    ]),
    { type: "Unknown" }
  );
});
var NativeApplicationPushNotificationDataSchema = memoize(function() {
  return v129.intersect([
    v129.object({
      "aps.alert.title": v129.optional(v129.string()),
      "aps.alert.body": v129.optional(v129.string()),
      "aps.sound": v129.optional(v129.string()),
      "android.notification.channel_id": v129.optional(AndroidNotificationChannelSchema()),
      "notification.body": v129.optional(v129.string()),
      "notification.title": v129.optional(v129.string()),
      "text_to_speech.pitch": v129.optional(v129.string()),
      "text_to_speech.speech_rate": v129.optional(v129.string()),
      "text_to_speech.text": v129.optional(v129.string()),
      "text_to_speech.volume": v129.optional(v129.string())
    }),
    v129.variant("type", [
      v129.object({
        type: v129.literal(resident_state_values_exports.GOT_UP),
        facilityKey: FacilityKeySchema(),
        userKey: UserKeySchema()
      }),
      v129.object({
        type: v129.literal(resident_state_values_exports.WANDERING),
        facilityKey: FacilityKeySchema(),
        userKey: UserKeySchema()
      })
    ])
  ]);
});

// src/models/socket-communication.ts
import * as v130 from "valibot";
function NullableSchema2(schema) {
  return v130.nullish(schema, null);
}
__name(NullableSchema2, "NullableSchema");
var SocketCommunicationPacketSchema = memoize(function() {
  return v130.object({
    payload: SocketCommunicationPayloadSchema(),
    /**
     * **リクエスト番号**
     * 受信側がレスポンスを期待する時に指定される。
     * 送信側はこの番号を`response`に指定してレスポンスを返す必要がある。
     */
    request: NullableSchema2(v130.pipe(v130.number(), v130.integer())),
    /**
     * **レスポンス番号**
     * リクエストに対するレスポンスを識別するために使用される。
     */
    response: NullableSchema2(v130.pipe(v130.number(), v130.integer()))
  });
});
function parseSocketCommunicationPacket(socketCommunicationPacket) {
  return v130.parse(SocketCommunicationPacketSchema(), socketCommunicationPacket);
}
__name(parseSocketCommunicationPacket, "parseSocketCommunicationPacket");
var SocketCommunicationPayloadSchema = memoize(function() {
  return v130.variant("type", [
    v130.object({
      type: v130.literal("ApplicationConfigurationData"),
      applicationConfiguration: ApplicationConfigurationSchema()
    }),
    v130.object({
      type: v130.literal("BedData"),
      bed: NullableSchema2(BedSchema()),
      bedKey: BedKeySchema()
    }),
    v130.object({ type: v130.literal("Error"), code: NullableSchema2(v130.string()) }),
    v130.object({
      type: v130.literal("FacilityData"),
      facility: NullableSchema2(FacilitySchema()),
      facilityKey: FacilityKeySchema()
    }),
    v130.object({ type: v130.literal("FallRiskEntryData"), fallRiskEntry: FallRiskEntrySchema() }),
    v130.object({
      type: v130.literal("Ping"),
      /** ピン時間 */
      now: DateTimeSchema()
    }),
    v130.object({
      type: v130.literal("Pong"),
      /** ポン時間 */
      now: DateTimeSchema()
    }),
    v130.object({
      type: v130.literal("ResidentData"),
      resident: NullableSchema2(ResidentSchema()),
      userKey: UserKeySchema()
    }),
    v130.object({
      type: v130.literal("SensorData"),
      sensor: NullableSchema2(SensorSchema()),
      sensorKey: SensorKeySchema()
    }),
    v130.object({
      type: v130.literal("StatusData"),
      status: StatusSchema()
    }),
    v130.object({
      type: v130.literal("SubscribeDataRequest"),
      /**
       * **施設キー**
       * 購読する施設の識別子。`null`を指定した場合、施設の購読を解除する。
       */
      facilityKey: NullableSchema2(FacilityKeySchema()),
      /** 購読日時 */
      subscribedAt: DateTimeSchema(),
      /** アクセストークン */
      accessToken: NullableSchema2(v130.string())
    }),
    v130.object({ type: v130.literal("SubscribeDataResponse") })
  ]);
});
function parseSocketCommunicationPayload(socketCommunicationPayload) {
  return v130.parse(SocketCommunicationPayloadSchema(), socketCommunicationPayload);
}
__name(parseSocketCommunicationPayload, "parseSocketCommunicationPayload");

// src/models/index.ts
var PRIVACY_POLICY_URL = "https://rehabilitation3.jp/archives/504";

// src/services/resident-state-transition/calculate-sleeping-hours.ts
import { Temporal as Temporal13 } from "temporal-polyfill";
function calculateSleepingHours2(events, start, stop) {
  if (events.length === 0) {
    return new Temporal13.Duration();
  }
  const _events = events.toSorted(function({ transitionedAt: a }, { transitionedAt: b }) {
    return Temporal13.PlainDateTime.compare(a, b);
  });
  if (Temporal13.PlainDateTime.compare(start, _events[0].transitionedAt) < 0) {
    _events.unshift({ state: resident_state_values_exports.UNKNOWN, transitionedAt: start });
  }
  if (Temporal13.PlainDateTime.compare(_events[_events.length - 1].transitionedAt, stop) < 0) {
    _events.push({ state: resident_state_values_exports.UNKNOWN, transitionedAt: stop });
  }
  let duration = new Temporal13.Duration();
  for (let i = 0; i < _events.length - 1; i++) {
    const current = _events[i];
    const next = _events[i + 1];
    if (Temporal13.PlainDateTime.compare(next.transitionedAt, start) <= 0) {
      continue;
    } else if (Temporal13.PlainDateTime.compare(stop, current.transitionedAt) <= 0) {
      break;
    }
    if (SLEEPING_RESIDENT_STATES.includes(current.state)) {
      duration = duration.add(
        (Temporal13.PlainDateTime.compare(current.transitionedAt, start) < 0 ? start : current.transitionedAt).until(
          Temporal13.PlainDateTime.compare(stop, next.transitionedAt) < 0 ? stop : next.transitionedAt
        )
      );
    }
  }
  return duration;
}
__name(calculateSleepingHours2, "calculateSleepingHours2");
export {
  enumeration_exports2 as AAMS_ALERT_TYPE,
  enumeration_exports3 as AAMS_CARE_RECORD_STATE,
  ALL_AAMS_ALERT_TYPES,
  ALL_AAMS_CARE_RECORD_STATES,
  ALL_ANSIEL_EVENT_CODES,
  ALL_DELETION_FLAGS,
  ALL_FACILITY_STAFF_ROLES,
  ALL_FACILITY_STAFF_TIERS,
  ALL_FALL_RISKS,
  ALL_FIM_ITEMS,
  ALL_INDEPENDENCE_LEVELS,
  ALL_PROVIDER_TYPES,
  ALL_RESIDENT_STATES,
  ALL_SENSOR_TYPES,
  ALL_SEXES,
  ALL_SIMPLE_INDEPENDENCE_LEVELS,
  ALL_TABLE_NAMES,
  ALL_WATCHTOWER_TYPES,
  ALPHABETIC_CHARACTERS,
  ALPHANUMERIC_CHARACTERS,
  enumeration_exports5 as ANDROID_NOTIFICATION_CHANNEL,
  enumeration_exports4 as ANSIEL_EVENT_CODE,
  AndroidNotificationChannelSchema,
  AnsielDeviceIdSchema,
  AnsielEventCodeSchema,
  AnsielReceiverUniqueKeySchema,
  AnsielSerialNumberSchema,
  AppleDeveloperKeySchema,
  ApplicationConfigurationSchema,
  AssessmentInitializationFormSchema,
  AssessmentRegistrationFormSchema,
  enumeration_exports7 as BODY_PART,
  BatchProcessor,
  BedKeyChainSchema,
  BedKeySchema,
  BedQueryFiltersSchema,
  BedQuerySchema,
  BedSchema,
  BinaryComparisonOperatorSchema,
  CreationDateTimeSchema,
  values_exports as DATA_RECEIVER_PATH,
  DATE_TIME_NUMBER_DAY_MODE,
  DATE_TIME_NUMBER_HOUR_MODE,
  DATE_TIME_NUMBER_MICROSECOND_MODE,
  DATE_TIME_NUMBER_MILLISECOND_MODE,
  DATE_TIME_NUMBER_MINUTE_MODE,
  DATE_TIME_NUMBER_MODE_BIT_COUNT,
  DATE_TIME_NUMBER_MODE_BIT_MASK,
  DATE_TIME_NUMBER_MONTH_MODE,
  DATE_TIME_NUMBER_NANOSECOND_MODE,
  DATE_TIME_NUMBER_SECOND_MODE,
  DATE_TIME_NUMBER_YEAR_MODE,
  DEFAULT_GRAPHEME_SEGMENTER,
  DEFAULT_LOCALE,
  DEFAULT_TIME_ZONE,
  values_exports2 as DELETION_FLAG,
  DateSchema,
  DateTimeSchema,
  DefaultDeletionFlagSchema,
  DefaultNoncascadeDeletionFlagSchema,
  DeletionDateTimeSchema,
  DeletionFlagSchema,
  DurationSchema,
  entity_class_values_exports as ENTITY_CLASS,
  enumeration_exports as ERROR_CODE,
  EntityClassSchema,
  ErrorSchema,
  ExponentialBackOff,
  enumeration_exports8 as FACILITY_STAFF_ROLE,
  enumeration_exports9 as FACILITY_STAFF_TIER,
  enumeration_exports10 as FALL_RISK,
  enumeration_exports11 as FIM_DOMAIN,
  fim_item_values_exports as FIM_ITEM,
  enumeration_exports12 as FIM_SUBSCALE,
  FacilityKeySchema,
  FacilityQueryFiltersSchema,
  FacilityQuerySchema,
  FacilitySchema,
  FacilityStaffModificationFormSchema,
  FacilityStaffQueryFiltersSchema,
  FacilityStaffRegistrationFormSchema,
  FacilityStaffRoleSchema,
  FacilityStaffSchema,
  FacilityStaffTierSchema,
  FallKeySchema,
  FallQueryFiltersSchema,
  FallRegistrationFormSchema,
  FallRiskEntryQuerySchema,
  FallRiskEntrySchema,
  FallRiskSchema,
  FallSchema,
  FallScoreEntryQuerySchema,
  FallScoreEntrySchema,
  FallScoreSchema,
  FetchDataRequestSchema,
  FetchDataResponseSchema,
  functions_exports as Functions,
  GoogleCloudServiceAccountSchema,
  GroupKeySchema,
  GroupQuerySchema,
  GroupSchema,
  values_exports3 as INDEPENDENCE_LEVEL,
  enumeration_exports6 as INDEPENDENCE_LEVEL_TYPE,
  enumeration_exports13 as IOS_SOUND,
  IncidentReportSchema,
  IndependenceLevelEntryQuerySchema,
  IndependenceLevelEntrySchema,
  IndependenceLevelSchema,
  IndependenceLevelTypeSchema,
  IndependenceLevelsSchema,
  InstallationQuerySchema,
  InstallationSchema,
  LimitSchema,
  MacAddressSchema,
  MeasurementKeySchema,
  MeasurementQueryFiltersSchema,
  MeasurementSchema,
  MigrationDateTimeSchema,
  NUMBER_OF_INSTALLATION_SHARDS,
  NUMBER_OF_PUSH_NOTIFICATION_RECEIVER_SHARDS,
  NUMBER_OF_SOCKET_CLIENT_SHARDS,
  NUMBER_OF_STATUS_SCHEDULE_SHARDS,
  NUMERIC_CHARACTERS,
  NativeApplicationPacketSchema,
  NativeApplicationPayloadSchema,
  NativeApplicationPushNotificationDataSchema,
  NextPageTokenSchema,
  operator_tier_values_exports as OPERATOR_TIER,
  OperatorSchema,
  OrganizationKeySchema,
  OrganizationQueryFiltersSchema,
  OrganizationQuerySchema,
  OrganizationSchema,
  PASSWORD_REGEX,
  PHONE_NUMBER_REGEX,
  POSTAL_CODE_REGEX,
  PRIVACY_POLICY_URL,
  values_exports5 as PROVIDER_STATE,
  values_exports6 as PROVIDER_TYPE,
  enumeration_exports14 as PUSH_NOTIFICATION_RECEIVER_TYPE,
  PageSizeSchema,
  PartialApplicationConfigurationSchema,
  PartialBedSchema,
  PartialFacilitySchema,
  PartialFacilityStaffSchema,
  PartialFallSchema,
  PartialGoogleCloudServiceAccountSchema,
  PartialIncidentReportSchema,
  PartialInstallationSchema,
  PartialPushNotificationReceiverSchema,
  PartialResidentSchema,
  PartialResourceInstanceSchema,
  PartialSocketClientSchema,
  PartialStatusScheduleSchema,
  PartialStatusSchema,
  PartialUserSchema,
  PartialWatchtowerSchema,
  PasswordSchema,
  ProviderKeySchema,
  ProviderQueryFiltersSchema,
  ProviderQuerySchema,
  ProviderSchema,
  ProviderTypeSchema,
  PushNotificationReceiverQueryFiltersSchema,
  PushNotificationReceiverSchema,
  PushNotificationReceiverTypeSchema,
  QueryFilterSchema,
  QueryOptionsSchema,
  resident_state_values_exports as RESIDENT_STATE,
  RESIDENT_STATE_ORDER1,
  ResidentArchiveQueryFiltersSchema,
  ResidentBatchRegistrationHeaderRows,
  ResidentBatchRegistrationRowSchema,
  ResidentKeyChainSchema,
  ResidentModificationFormSchema,
  ResidentQueryFiltersSchema,
  ResidentQuerySchema,
  ResidentSchema,
  ResidentStateSchema,
  ResourceInstanceQueryFiltersSchema,
  ResourceInstanceSchema,
  Retry,
  RoomKeySchema,
  RoomQueryFiltersSchema,
  RoomSchema,
  values_exports4 as SENSOR_STATE,
  values_exports7 as SENSOR_TYPE,
  values_exports9 as SEX,
  values_exports8 as SIMPLE_INDEPENDENCE_LEVEL,
  SLEEPING_RESIDENT_STATES,
  enumeration_exports15 as STORAGE_OBJECT_TYPE,
  Semaphore,
  SensorBatchRegistrationHeaderRows,
  SensorBatchRegistrationRowSchema,
  SensorKeySchema,
  SensorQueryFiltersSchema,
  SensorQuerySchema,
  SensorSchema,
  SensorTypeSchema,
  SexSchema,
  SimpleIndependenceLevelBatchRegistrationHeaderRows,
  SimpleIndependenceLevelBatchRegistrationRowSchema,
  SimpleIndependenceLevelSchema,
  SimpleIndependenceLevelsSchema1,
  SocketClientQuerySchema,
  SocketClientSchema,
  SocketCommunicationPacketSchema,
  StatusKeySchema,
  StatusQueryFiltersSchema,
  StatusQuerySchema,
  StatusScheduleQueryFiltersSchema,
  StatusScheduleSchema,
  StatusSchema,
  StringBinaryComparisonOperatorSchema,
  table_name_values_exports as TABLE_NAME,
  enumeration_exports16 as TEXT_TO_SPEECH_MODE,
  values_exports10 as TIME_FRAME,
  TernaryComparisonOperatorSchema,
  TextToSpeechModeSchema,
  TimeSchema,
  UniversalError,
  UpdateDateTimeSchema,
  UserKeySchema,
  UserSchema,
  UsernameSchema,
  VersionSchema,
  enumeration_exports17 as WATCHTOWER_TYPE,
  WatchtowerKeySchema,
  WatchtowerQueryFiltersSchema,
  WatchtowerSchema,
  YearMonthSchema,
  calculateResidentStateDurations,
  calculateSleepingHours,
  calculateSleepingHours2,
  EntityClassSchema as createEntityClassSchema,
  createResidentImagePath,
  createUniversalError,
  denormalizePhoneNumber,
  fromAamsAlertTypeToResidentState,
  fromAamsCareRecordStateToResidentState,
  fromAnsielEventCodeToResidentState,
  fromErrorCodeToHttpStatus,
  fromFimItemToFimDomain,
  generateBedKey,
  generateFacilityKey,
  generateFallKey,
  generateGroupKey,
  generateMeasurementKey,
  generateOrganizationKey,
  generatePassword,
  generateProviderKey,
  generateProviderUniqueString,
  generateRandomString,
  generateRoomKey,
  generateSensorKey,
  generateSensorUniqueString,
  generateStatusKey,
  generateUniqueConstraintKeys,
  generateUserKey,
  generateWatchtowerKey,
  getAamsAlertTypeSchema,
  getAamsCareRecordStateSchema,
  getAamsRegistrationFormSchema,
  getAamsServerRegistrationFormSchema,
  getAnsielApiRegistrationFormSchema,
  getAnsielRegistrationFormSchema,
  getBedAllocationFormSchema,
  getBedSchema,
  getDefaultDeletionFlagSchema,
  getDeletionFlagSchema,
  getEmailAddressSchema,
  getErrorStream,
  getFacilityKeySchema,
  getFacilityRegistrationFormDataDefaultValues,
  getFacilityRegistrationFormDataSchema,
  getFimItemSchema,
  getIndependenceLevelSchema,
  getLocales,
  getLoginFormDataDefaultValues,
  getLoginFormDataSchema,
  getMacAddressSchema,
  getMeasurementSchema,
  getOperatorSchema,
  getOperatorTierSchema,
  getOrganizationKeySchema,
  getOrganizationRegistrationFormDataDefaultValues,
  getOrganizationRegistrationFormDataSchema,
  getPartialBedSchema,
  getPartialResidentSchema,
  getPartialRoomSchema,
  getPasswordSchema,
  getPhoneNumberSchema,
  getPostalCodeSchema,
  getProviderKeySchema,
  getResidentRegistrationFormSchema,
  getResidentSchema,
  getRoomKeySchema,
  getRoomSchema,
  getSensorKeySchema,
  getSensorTypeSchema,
  getSexSchema,
  getUniqueConstraintSchema,
  getUserKeySchema,
  getUserSchema,
  isAamsAlertType,
  isAnsielEventCode,
  isDeleted,
  isDisabled,
  isEnabled,
  isExistent,
  isFacilityKey,
  isFallKey,
  isGroupKey,
  isNotArchived,
  isNotDeleted,
  isNotRemoved,
  isOrganizationKey,
  isProviderKey,
  isRoomKey,
  isSensorKey,
  isStatusKey,
  isUserKey,
  isWatchtowerKey,
  memoize,
  normalizePhoneNumber,
  parse2 as parse,
  parseAamsAlertType,
  parseAnsielEventCode,
  parseAppleDeveloperKey,
  parseApplicationConfiguration,
  parseBed,
  parseData,
  parseDateTime,
  parseFacility,
  parseFacilityStaff,
  parseFacilityStaffRole,
  parseFacilityStaffTier,
  parseFall,
  parseFallRiskEntry,
  parseFallScore,
  parseFallScoreEntry,
  parseGoogleCloudServiceAccount,
  parseGroup,
  parseIncidentReport,
  parseIndependenceLevel,
  parseIndependenceLevelEntry,
  parseIndependenceLevels,
  parseMeasurement,
  parseOperator,
  parseOrganizationKey,
  parsePartialApplicationConfiguration,
  parsePartialBed,
  parsePartialFacility,
  parsePartialFacilityStaff,
  parsePartialFall,
  parsePartialGoogleCloudServiceAccount,
  parsePartialGroup,
  parsePartialIncidentReport,
  parsePartialPushNotificationReceiver,
  parsePartialResident,
  parsePartialResourceInstance,
  parsePartialRoom,
  parsePartialSensor,
  parsePartialSocketClient,
  parsePartialStatus,
  parsePartialStatusSchedule,
  parsePartialUser,
  parsePartialWatchtower,
  parseProvider,
  parsePushNotificationReceiver,
  parseResident,
  parseResourceInstance,
  parseRoom,
  parseSensor,
  parseSocketClient,
  parseSocketCommunicationPacket,
  parseSocketCommunicationPayload,
  parseStatus,
  parseStatusSchedule,
  parseUniqueConstraint,
  parseUser,
  parseUserKey,
  parseUsername,
  parseVersion,
  parseWatchtower,
  serialize,
  setLocales,
  simplifyIndependenceLevel,
  sort,
  streamError,
  t,
  toDateNumber,
  toDateTimeNumber,
  toDateTimeString,
  toDuosexagesimal,
  toPathSafeString,
  toPracticalDate,
  toPythonDateTimeString,
  toResidentBatchRegistrationRow,
  toSensorBatchRegistrationRow,
  toSimpleIndependenceLevelBatchRegistrationRow,
  toTimeNumber,
  toUniversalError,
  tryToParseJson
};
//# sourceMappingURL=import.js.map
